// 服务器发布清单；621 个 KTX2 GLB 的节点变换和解交错几何字节已核对原始模型。
export const OFFICE_TILES_AUDIT = {
  "manifestSha256": "2efcf6336f08491b04bec33813ae23fbea24eebbbba86369dd5793e8b8642056",
  "files": {
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level18_1.glb": {
      "bytes": 282948,
      "sha256": "90cd880e919ce79fd33da2f110f002a7096e2e850e63023fccce1515167b2f37"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level19_1.glb": {
      "bytes": 159280,
      "sha256": "65a4811d576cf89bccfd696b9921d2ea6160f122093f712d9817bbc6b4278d2c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level19_2.glb": {
      "bytes": 285088,
      "sha256": "6128ff91f8b62deb5d135642f5e9e08ed7b5e5d53bff9232a9426a40baa16d5d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level20_1.glb": {
      "bytes": 78868,
      "sha256": "a435e6a8651b03f49ec5996042dca520593b34153bb455a03347e59277f4f8e2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level20_2.glb": {
      "bytes": 53552,
      "sha256": "c9b6cb661818e49514293f7292f34734fdb0e864d36500c0a050da187f833691"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level20_3.glb": {
      "bytes": 258532,
      "sha256": "0ff2ae4d2c20e3b15b5f1ee42ba28344cf9431e9d807a1eb375482b50bbcac74"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level20_4.glb": {
      "bytes": 81000,
      "sha256": "3d51c45196fdeb6c49e6ea4488f037a75377bffaf706a8fc689ffba7fdae1fad"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level21_1.glb": {
      "bytes": 93196,
      "sha256": "578887b19a662818fa5c77d7061d833f214debd893d3bb68ef85cc12917abd04"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level21_2.glb": {
      "bytes": 60940,
      "sha256": "15ef62754beef50bf9de4e6e5835e480a6397d1deec028b8400a0643556f40c2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level21_3.glb": {
      "bytes": 94216,
      "sha256": "061bcc167388a6f997457006637d752b90660fee9c17f3a7812db686a178b2cc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_1.glb": {
      "bytes": 106384,
      "sha256": "128acf019c13c2ed5df42b75c790447d2985fe4ccdbf58d09a8f474af974ecd8"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_2.glb": {
      "bytes": 72024,
      "sha256": "fbfc085119725e5c13405a51cba92e1e1c52fa24960b7e2188e30af804b99e30"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_3.glb": {
      "bytes": 129656,
      "sha256": "8178b70e48558eea203ad8f27884ec43cc657168279e16f6628e4dc596c52430"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_4.glb": {
      "bytes": 36316,
      "sha256": "674a4c1cec84a591c186b68121463468c56757197345ae39035ab9221b32882d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_5.glb": {
      "bytes": 159720,
      "sha256": "1d6f8a688976eb7a4f4dd4187061c91a107fc22a9d7bc35a10ded0413bb44178"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_6.glb": {
      "bytes": 36408,
      "sha256": "22116a24365308e7b201c6137d932626e093781537a96a5dcb2ec5daf716f960"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_7.glb": {
      "bytes": 274120,
      "sha256": "a355d84c9867687678a7f577f8f541ea065e2979ff171427c3ea14524177351a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level22_8.glb": {
      "bytes": 380252,
      "sha256": "c88a9cc2d9783110acb20d1d9a7b591f30121309e654c6b476015ab5d9a5c9ad"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_1.glb": {
      "bytes": 125212,
      "sha256": "8131ed04504a46349f4af20b7f9797b8a5babcc84d06c685874255eccadab0cc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_10.glb": {
      "bytes": 69776,
      "sha256": "079dd5f0fb6a41fee9f94e1d2dcce00225a44b48230f5dbd872ee51ea74a40f1"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_11.glb": {
      "bytes": 114284,
      "sha256": "2b4c68a037ccf1dfa699b67b98fc1759318d9d2128372a29c044a59f86b56c4a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_12.glb": {
      "bytes": 281096,
      "sha256": "5d23f6a1a8a23f2539594d48bced6f3bfecca7f0a98edddb161e5ec2627868ef"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_13.glb": {
      "bytes": 93500,
      "sha256": "de1958d8c0a00d402d545ebbbe98d6e108133c559669d5f8be0e64d321facb1b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_14.glb": {
      "bytes": 329688,
      "sha256": "43cc2b8f38185b48218153281d85b18e2abe0502681efc7cbf51def309faa4fb"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_15.glb": {
      "bytes": 112176,
      "sha256": "6e7fef0a18d2c3f5585a6255e46b88dcd05606c87e3276a3dc93ccdbe8e7f07d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_16.glb": {
      "bytes": 264856,
      "sha256": "ee54a703dbd87c93dcd656b20e67a30df34d78317588741f636e5bc10f03b40d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_17.glb": {
      "bytes": 263152,
      "sha256": "c90f3d6bcd6f2d9986ebf56435adce81f6d7c6f74e9611d7b10516af0956897a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_18.glb": {
      "bytes": 165520,
      "sha256": "0b37cad0c70b61e3720f395fc8c543e0bda42611f923b63f2b9a1f6955994b13"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_19.glb": {
      "bytes": 224544,
      "sha256": "6c7fb58d128e65bfc103d506a26ec9d88fb0ebe6e560f72f0871c08756a2ca31"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_2.glb": {
      "bytes": 92868,
      "sha256": "c073d6ec59d2ed06a04c959d82b855cb20e97d475b9fcb9cb46fb5878c57014e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_20.glb": {
      "bytes": 198728,
      "sha256": "f9a08c69c266d501f3bb4c27f444ccb66e44f1bd6a12207309326d54433ea2dc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_21.glb": {
      "bytes": 264484,
      "sha256": "9185752a513491ead67f13c99e1026adbb4b1ea6854356c7ffed1c3a3ce73138"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_22.glb": {
      "bytes": 275200,
      "sha256": "f2e956562cef677c8d9350ed7e1ec39de3a956371bc9c2453ed580414c0db0a3"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_3.glb": {
      "bytes": 76672,
      "sha256": "140b35bdea71c5037be21a98340d892aa29610469eeab314f90e11c939405eac"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_4.glb": {
      "bytes": 111128,
      "sha256": "b26b58c13af169968829e7c35befbd25909c8d4789c5d8308a93d87aa211dc7b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_5.glb": {
      "bytes": 174416,
      "sha256": "49c81e586244d62f842c115af43de37dbd2cfdf557b2362789369bc0a488103f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_6.glb": {
      "bytes": 192820,
      "sha256": "493d78443dc9c94cdf05229e661b74e68b05ba5faf40fdad101ba9a1c8f68535"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_7.glb": {
      "bytes": 46448,
      "sha256": "0c83180198ca8208cef4186d331a018afa5c3695fa15126ce3666cf618e2c1bc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_8.glb": {
      "bytes": 367464,
      "sha256": "e4e3d6fd19cd64ef56332321237b25f26fb0899e0f8ebc30f26f4b4bd8ad96b7"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level23_9.glb": {
      "bytes": 220212,
      "sha256": "81a397fb2b010bddb82c7e2f1b6730f72eaec07e6ab4a9f8a1cbde788f32c05f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_1.glb": {
      "bytes": 258348,
      "sha256": "f3fdc19b49e875604139c27323236c46245691598371a450c81ae7dab0fb2b6b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_10.glb": {
      "bytes": 78932,
      "sha256": "c63e1f0d50446079d883a732ccfb7dad2d3b4d17e4a9956f7ee611488169faa7"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_11.glb": {
      "bytes": 89296,
      "sha256": "3b5de3db6fe936b0252ef2b20967787f2affbd4070a982832c753e5e9c28e507"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_12.glb": {
      "bytes": 237680,
      "sha256": "70aa5e354dbc1c266d42f287107711d70b447526ab702b4a904933326f2dd743"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_13.glb": {
      "bytes": 324596,
      "sha256": "083d2fc7e781ff8e98121ac37114643376990db1f7625548cfb633e46ab3ee45"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_14.glb": {
      "bytes": 296628,
      "sha256": "38e14ce47fc859bedae9b34da70eb3f78da9e5ef061187ad66d508207d818a87"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_15.glb": {
      "bytes": 121936,
      "sha256": "94d28b50c648e1492b21f03d93fbacb490f94d26f971a7a0d4ca170812258ebe"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_16.glb": {
      "bytes": 198460,
      "sha256": "ee06ee639cd6b3f8e0ef932f1446ae685ec85e5c25665f4dac2684940a739e8d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_17.glb": {
      "bytes": 320440,
      "sha256": "02fe12e96f47c2bd0f6d7d98e2f130b4039c6cb2118a02c2b81554894515915e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_18.glb": {
      "bytes": 161556,
      "sha256": "1ff34223c386cf6da141795b8d1c0bd9d36cdfa2dbe61a95e27a34e5caaf5fda"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_19.glb": {
      "bytes": 153504,
      "sha256": "a24dc44b30cddb1b16caf3c6bee0d8b46c132ee993c5fe28d043c1fefb20c057"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_2.glb": {
      "bytes": 212920,
      "sha256": "a58755a3c73938c3b8205e302c372db7bc7b9314d8abfed962b19f92fa0f0c52"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_20.glb": {
      "bytes": 312684,
      "sha256": "977c8a42b78eb7716ae09a237a10a47f46e0fbaa8794ccb33c574680ac69f73a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_21.glb": {
      "bytes": 331132,
      "sha256": "5ac6d1025fa553e97528aec3ea1aa329468e7fb1b498ce40162379ac366d20cd"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_22.glb": {
      "bytes": 192072,
      "sha256": "192da054eb6d74ba7f3b4afac4fa322d4872a581bd4f9bacb1137b400b0aca61"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_23.glb": {
      "bytes": 234732,
      "sha256": "b81db114dc420cd5c6fd2726aa47c7eeb7421d335f55c8549490798025307f2c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_24.glb": {
      "bytes": 225760,
      "sha256": "d0f58e24b87986906e10e7e1811468f9cba62b618cee1ea8ceadae0a01b123e0"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_25.glb": {
      "bytes": 316968,
      "sha256": "4c01c0dd6e000965d38eda8660ad97b10dd9127387a0a1a0d7a5aa36e097110a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_26.glb": {
      "bytes": 273400,
      "sha256": "b7d30843c0231c862ca9e40b76ec7aed75c36a6d988b22593a0cf66ec43b467d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_27.glb": {
      "bytes": 164164,
      "sha256": "5fc77f70e9e736164537ccc82002b54aea17d0cd11d54e2b308fe2e820aa6896"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_28.glb": {
      "bytes": 352864,
      "sha256": "ae61ad63f588fe9337f46b96b5f9bbd51f190eb6b8b23e559e49514b4ef6d700"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_29.glb": {
      "bytes": 231764,
      "sha256": "384268006f3cae528a2ad62c7aebdcc9841d9695f634d4b30b95bfe1cc11338b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_3.glb": {
      "bytes": 51524,
      "sha256": "a3be0893063cc47c149c3481dc8d2c5b1e506370dd380fb23877dffc8c58a423"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_30.glb": {
      "bytes": 188652,
      "sha256": "71c0efed659f16914db8c09f7bfca1c38d05859cbabcc78ffe5c9dd963cbbd0c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_31.glb": {
      "bytes": 244176,
      "sha256": "54e342ea4030b59eede94fabdc8dcf1dd4602479d2d5e74a788f6b53e25c7356"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_32.glb": {
      "bytes": 336080,
      "sha256": "d752665d24c58760b66a5005e84ca7f6f2b3aed517adb414e493733528e8d08a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_33.glb": {
      "bytes": 295308,
      "sha256": "b3f84f23e47097963a91a227597c24c058bc353ed0dac77d6cf15ed961bccbd2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_4.glb": {
      "bytes": 178268,
      "sha256": "663b41355e2015313187173a77b88e3ef9c26bcd84e8aec953cc3491c450930b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_5.glb": {
      "bytes": 184180,
      "sha256": "dbe5b5cfd5c753b338d696a996fa9d7d1fb24a60581de13017adbf414a1d6ac4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_6.glb": {
      "bytes": 278628,
      "sha256": "c2a939855632dee89593d0634173cdfbe265c47f99dab0f614356bc2e030881e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_7.glb": {
      "bytes": 281092,
      "sha256": "0a1a71523dcf32305a3257c84121a45af75b2f38d5fbda89cbcb29e22bcde453"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_8.glb": {
      "bytes": 242468,
      "sha256": "8bca3f85cff43d05378fa041d720c432cbc5900664decc9c4779422b98ad4e10"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level24_9.glb": {
      "bytes": 106832,
      "sha256": "84ee9a8ee8a2d69527ca8f5781ed2d940a21f4966c40b40fe3123e3a69092f1b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_1.glb": {
      "bytes": 61672,
      "sha256": "fdc99979b6af1b89f0e808f859b4592847faab3b8c21c71ac3dc368af24bcba3"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_10.glb": {
      "bytes": 138436,
      "sha256": "798331fa335251a35f66cf6ac0e33644340d1040a67d1e5ec89f5f67dc6b791d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_11.glb": {
      "bytes": 253600,
      "sha256": "8882befd37c5558bc548fd66fe88f7a0e942cabfd18dd7df88d583770c2aeb57"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_12.glb": {
      "bytes": 209908,
      "sha256": "3719140360255c017b2090d09b70d9ae8eaa7a9f68d823d651700f98a3ea7457"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_13.glb": {
      "bytes": 174532,
      "sha256": "8be5cc8b9f01e77b2b2b8026c54c008eba8115cec0a89d8982dcaa5298d6ebc0"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_14.glb": {
      "bytes": 145676,
      "sha256": "b38509a8659429b0643bdd40e3fed63cb9fabf2474b4a714f98a670c23fc9d7b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_15.glb": {
      "bytes": 255140,
      "sha256": "fba374596d8076cde28d6d324a737ad31733dac67e85fcd96fc7dbbf8bc289b2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_16.glb": {
      "bytes": 98636,
      "sha256": "a88565e00abbe6a2d1fccb82273abbb8177577ea76a9bbd2c0b79625d4ab5917"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_17.glb": {
      "bytes": 105220,
      "sha256": "aabd6eb2fade21e5bbadff74d65240eed827c1acbb3a63d586ee470e93b49994"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_18.glb": {
      "bytes": 203876,
      "sha256": "1c164ea4d17b1c7c5ba65a48682d9d65861450d04626f7b23f343550200b5c5e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_19.glb": {
      "bytes": 97524,
      "sha256": "fbca4759c562b46019d7bc5330287fb5d3f834a22cd06cf606bf0755ad9f771d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_2.glb": {
      "bytes": 122568,
      "sha256": "735aae4b840330313def9539d0769cd438a76af1aec44bc4549c96b0d708d142"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_20.glb": {
      "bytes": 95628,
      "sha256": "161bdda1d5ed5aa970e130696f42d7ead370b21f40383ea9387d050c787b4d60"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_21.glb": {
      "bytes": 186220,
      "sha256": "6c8ba14e8ac9a193d39ec2ce2d9403782d3c09d2709164c26574637b59212729"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_22.glb": {
      "bytes": 284676,
      "sha256": "c189879e853bd7577075f6fcbce53729053b751cb44efe2dfd4830b190527ca1"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_23.glb": {
      "bytes": 366164,
      "sha256": "21e0e5b0a6cc17ff8076fa36ce5acd165a1e93a2df5871f28cd0009e424db0f2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_24.glb": {
      "bytes": 200272,
      "sha256": "e253816dd0e784f6c05f02772fa4452ad33fe0042ffc089acf4039797ffd2473"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_25.glb": {
      "bytes": 65208,
      "sha256": "093d11cce6d96c55ced018df6301140c0ca2e30b610e1af6b2cd8c5537233e12"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_26.glb": {
      "bytes": 123276,
      "sha256": "2151dbc2fe1a1a4341712ba964d64914ddd83edfd1fe455ff70b471f4d7f3d75"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_27.glb": {
      "bytes": 120924,
      "sha256": "2b7eb769eabe8a8ce3be90513f603050b8b310eff1b8a697520e45e850a4dd4f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_28.glb": {
      "bytes": 86892,
      "sha256": "c0de05a2e8459624ba9a266cdf133d3d09d797b3c77a043238b3323798eeb474"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_29.glb": {
      "bytes": 311056,
      "sha256": "d11f4e5fb2c128d30d9b35619df79b13d477917bba51dbbb2889b661e8dc268d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_3.glb": {
      "bytes": 213288,
      "sha256": "711fec6651e18cc3b440a3a49702d7c27a83212882daef956bf09061d93913cc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_30.glb": {
      "bytes": 177540,
      "sha256": "b28d1870b7d0efa4185d86877f30c661abd1ba2f98b3f3517faaebbc75fad979"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_31.glb": {
      "bytes": 242660,
      "sha256": "90858fac446f36979b13d9354da84f29b481ec7646d459be1da6e2693879cf5c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_32.glb": {
      "bytes": 109844,
      "sha256": "3878dd1a2469e70a6f662d3dca0b0259b6b7dbbc7b30398bd6b59b3879d6f593"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_33.glb": {
      "bytes": 246804,
      "sha256": "64c6df99f72562037e30983dfa46d3200dfaa2b7785c4a93f85ddfb4f2e177f8"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_34.glb": {
      "bytes": 254620,
      "sha256": "55a4a191752305d9f4d296b8125c017964567a82d7fc6b40071a8328f83987da"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_35.glb": {
      "bytes": 327332,
      "sha256": "c849069959c5aba6c2a4b148c23b00907b883021d3d336c8d262f5a221e3ee07"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_36.glb": {
      "bytes": 219732,
      "sha256": "4599087b770e955434b3280a9f714c3e907a9b17f63f2c8a6c134be684c7d03e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_37.glb": {
      "bytes": 444584,
      "sha256": "4554e264b28d6a952c5f57b656b377f623bf343ad330e0df38389373ea3fc76e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_38.glb": {
      "bytes": 327036,
      "sha256": "26acbdd913338b1bfdadb0f54c9d748222e906218921b7edf2209e6d6efc359c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_39.glb": {
      "bytes": 379568,
      "sha256": "8f17ed1681c9f85e6e18169fae695053563416c77929a79fa894c800bf008855"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_4.glb": {
      "bytes": 190136,
      "sha256": "75b57925a79c34ce4376cbb813e45fa9dcfb2952e5b0fec8276686d0ea275619"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_40.glb": {
      "bytes": 291828,
      "sha256": "b000ecc25e2a90d7202690c41b63486bbd0a0f8e74c5f998689b418ce668ce16"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_41.glb": {
      "bytes": 244816,
      "sha256": "5c57209a3a7011890790d24c7245bc2ab25b25ba94e3648d41f9e24e15e7a274"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_42.glb": {
      "bytes": 382268,
      "sha256": "737645e709baed6ca9d7a7bdf5ce0102814e87c42be5bf24fafde57a9bbd7e0f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_43.glb": {
      "bytes": 67964,
      "sha256": "bef5ef5b02035188414ff32ef6a929cb178e747ad8c316856b67e22ffc0d81dc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_44.glb": {
      "bytes": 397068,
      "sha256": "cc2985ba5c663b86ff813a4bb03e873a9ed627c586676888b4a5282a56e70d7b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_45.glb": {
      "bytes": 347500,
      "sha256": "a3aa3c60f3d751973e460c0e944b6bf8c28bae4d1770fb57ddedc699c28a2145"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_46.glb": {
      "bytes": 310528,
      "sha256": "d55c59299b32acf27df6671a9874efa5dc6c05209d74a064b43410c9767e2bd6"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_47.glb": {
      "bytes": 97564,
      "sha256": "e7d757a74a54ef0e5b69a59bd83b7b9bab40b71caf981fe3f8eb5c1b0a0ea97e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_48.glb": {
      "bytes": 404940,
      "sha256": "b37370ed96f7838c9845b7c02092794ca4f9d0927b8f1e7ee3eb8e448b6e4135"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_49.glb": {
      "bytes": 50780,
      "sha256": "1a5bd1cb5c3b5544ade73910ec5faacd81f38e62c3390c1ace15b66edb8d70f9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_5.glb": {
      "bytes": 68900,
      "sha256": "530b57bf60f04bd4331123afdcb5ba7255979a65399ec4da1545a28f456482d8"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_50.glb": {
      "bytes": 121424,
      "sha256": "47548da61df4a1b97bd2fc41766aedfb20d5e5b6551600317661edd1a781b074"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_51.glb": {
      "bytes": 272888,
      "sha256": "a0f62a156c9b4abdd1dee9c64c307dc6dee6e6544790077b17531f9b0b5d7456"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_52.glb": {
      "bytes": 388040,
      "sha256": "267894976bf575789c0361c86f235745123b085b97cb778845febc64e8b1a009"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_53.glb": {
      "bytes": 272000,
      "sha256": "e43e7efa1b20623fb7bf9ffe752e6ab21904a6c44bdf753bec8c4d64140da575"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_54.glb": {
      "bytes": 365584,
      "sha256": "5913b424b0e2ec1d2a71454d0b3f17dea6e1a05a653ef4f743b7a7a7e5d905cb"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_55.glb": {
      "bytes": 279480,
      "sha256": "869e4f02f1bc97c610717b2c39b563634c9b338eb093491c7c1426b4ffa5b27e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_56.glb": {
      "bytes": 214024,
      "sha256": "100c3976a2d311fb35c426feff3e8d8093e77fadb1e4d9baaf5b033a6161178f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_57.glb": {
      "bytes": 475336,
      "sha256": "8dee44263c9015661c8977a7e70fb8899577b5f3b9816ccd7c046fee531dae7d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_58.glb": {
      "bytes": 258200,
      "sha256": "353a863048149161d663561dd2862b562d056c2305adb391406de24c4a4d2179"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_59.glb": {
      "bytes": 285272,
      "sha256": "dcfb01611245c87a4482b9868a0bb78a4282a5db3f3f89e0aed57c71a1a39c68"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_6.glb": {
      "bytes": 204488,
      "sha256": "8197d23248ba49ae16f6d88f9543cbc97db2b5fabec83e163a71720472500f05"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_60.glb": {
      "bytes": 370800,
      "sha256": "eb4071e417c04350270e396818d42f75aa5e0a38fdacdd21a06ede2417288b3e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_61.glb": {
      "bytes": 248264,
      "sha256": "f25e866e4b511452e444f6311dfec7398bbe3a24199ebb19c3ede36c1856e49f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_62.glb": {
      "bytes": 203608,
      "sha256": "e53d0dddaa6c8f4b7053c13c4fd8964efda1b40b0661491d4c8414c3ce057e36"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_63.glb": {
      "bytes": 160764,
      "sha256": "c233cf1173579f2858a631457c11479fca3f945c7ea9e8bd9efe5cf753f08f0b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_64.glb": {
      "bytes": 219884,
      "sha256": "a74bea0716a7a616208846350eaadd256174ac7c6bf54cf54dce7a416246514d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_65.glb": {
      "bytes": 215012,
      "sha256": "ebc36684b4624cab7b70498a8b3fb2f0ad250abda1e67191755cefed07029e77"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_66.glb": {
      "bytes": 102808,
      "sha256": "8c1743ca35e9e364dca5d182351d8da4375ed258919d7cfa99841d7ae9eb1014"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_67.glb": {
      "bytes": 146612,
      "sha256": "566a7c09abbe0207562930bc8a4dfc42179417250fb42b8789a06763727dd9d4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_68.glb": {
      "bytes": 162688,
      "sha256": "962de887354aaf73462cd3fa28948794c3ce33c3212c862b81fced44046339ea"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_69.glb": {
      "bytes": 168700,
      "sha256": "689bf1221dc937cf77553f2da8e4f4be2bd4c2c4190ad708e7ccc98e2e2673c2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_7.glb": {
      "bytes": 195064,
      "sha256": "ab374d454666a1f3aa7ee2e7d19c435b62d64574d32749dd99c0d99b8a86e3aa"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_70.glb": {
      "bytes": 274232,
      "sha256": "c64352e48d6810e7a783ffa2a6ed4542f1b95206209a2350e2ebd501efcd26e5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_71.glb": {
      "bytes": 234060,
      "sha256": "0fd5c4582ca016c066445123f5945d0e830ffbc77b77f65b68a3d6e15225f7cb"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_72.glb": {
      "bytes": 180900,
      "sha256": "805540b3a3229f8a200ef4ebf9562f555ab75cc46359cd6e29a0fa460934fa64"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_73.glb": {
      "bytes": 292060,
      "sha256": "468385a606ff4ceb27019fc90789b2efbfcda72607965721254d64d5ec5ca0f7"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_8.glb": {
      "bytes": 95912,
      "sha256": "9bc218314aafc7257deb19c2204e5039e15988b9173587267cefbc757a7a310e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level25_9.glb": {
      "bytes": 178556,
      "sha256": "fa6a518d9f05a78b1915ac821bd62e0d7f8146e04ded6a4aa4ee1c729ad884f4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_1.glb": {
      "bytes": 107420,
      "sha256": "62a99bacfc4eba1d6d5184f6d47b96d21826a50e5adf3d423953705efba3e501"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_10.glb": {
      "bytes": 190716,
      "sha256": "59774b2742040c3fa432b253d0e8f9232a4ee136ed9e5b174f45159622c7d703"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_11.glb": {
      "bytes": 210080,
      "sha256": "ec1cf0444f6b0221a44502e8fb6595f1e98ed041aadf3f19870e1aaeacd9f731"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_12.glb": {
      "bytes": 115664,
      "sha256": "33705548d927034b646a52040e52196a82644d2fd4dc78a5d3fbc378d85fc20d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_13.glb": {
      "bytes": 129716,
      "sha256": "fc025b918a018d61880179ee17d72e56f4f870895f932b104e9c755fbe573025"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_14.glb": {
      "bytes": 213432,
      "sha256": "2b926b72ea0b20c6a24f3294b62d6988e7dfc48ac09c80002db57a5565b14fa6"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_15.glb": {
      "bytes": 135864,
      "sha256": "fc38c5d22cb67fc04acaf482fed43e719b74ddae03905843f179c0276229f5ea"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_16.glb": {
      "bytes": 308116,
      "sha256": "f21a6906e78a57fa728f59f68ea9cb114e1485b1b471a794c24787ead5add601"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_17.glb": {
      "bytes": 170196,
      "sha256": "81cbea014b742d790eee69908b2399d147479e5530749f4d630015774b844080"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_18.glb": {
      "bytes": 200048,
      "sha256": "e3a126c10fa0d3327500000dd03d4445699c917c752f892b9d014627731bb946"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_19.glb": {
      "bytes": 249556,
      "sha256": "f33a20f7ff1c8a33f5dd057ffa8c866a5c9f5279287568530b6a7de7bbf7ec7c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_2.glb": {
      "bytes": 294700,
      "sha256": "4a51d39c73ef0f5ca62db3133cc9b6af9c610b17bb587b745a81de18275ec5e9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_20.glb": {
      "bytes": 300380,
      "sha256": "9712c54cbb4caf1fbac3c397ace532657a77ae1e71f75d0f20f5da5d5be2c751"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_21.glb": {
      "bytes": 137088,
      "sha256": "76fe23c5d266a2db830aed2dd0b4dd00c9798b0e091dcd7131f76c9f19048438"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_22.glb": {
      "bytes": 436696,
      "sha256": "3009cb7f0e0563d4040e03ec7544a9bced289bea9284e0d7cb1b394b7b1fb438"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_23.glb": {
      "bytes": 110728,
      "sha256": "17ccfc2192462f10458a16701580e97c2632c9744fd875237f5c45d0d9a4aef4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_24.glb": {
      "bytes": 445380,
      "sha256": "ec095c48b2b7a0a57ef1183d981de59e07b8ca059418006524498966759dbc54"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_25.glb": {
      "bytes": 158196,
      "sha256": "63583b39359fdd3e23650b0b6b0b1430eb40205fee963f634e5163c8f0f6db1a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_26.glb": {
      "bytes": 153852,
      "sha256": "11d1c72435bd1494fc95b8da9a26ca9bf449feaacbe1a54c0bb493ba0cf9ab65"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_27.glb": {
      "bytes": 120512,
      "sha256": "37741a3c61649dc5488ec4101dc0b416cd3686f7e95e5eb02da607b6c781cfd4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_28.glb": {
      "bytes": 117212,
      "sha256": "eed8d658f3615bb9108d07e8c6e39d6447bfb2878238c36e9b45bc862da9d86f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_29.glb": {
      "bytes": 125728,
      "sha256": "cf3ba9fa1f2c46fbb5cead5fb1e179a453240963750aef439466dae06a5efe5c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_3.glb": {
      "bytes": 221368,
      "sha256": "af415f98432b5f78a3e155cd566610022ce8d08de5f9689bb8d2d57cef17a587"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_30.glb": {
      "bytes": 163700,
      "sha256": "02b06207c5162b3a88782421c74541d7843a879d479b69ed4eada9394358dba9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_31.glb": {
      "bytes": 64040,
      "sha256": "22fd8b220a51bbdbb30f095ce3c3d54b2f9095ddc9b1622dcd0141285b434ebd"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_32.glb": {
      "bytes": 50856,
      "sha256": "9d76098077dc0119e2271fc0fa3bfba764146a1fdf98813ec57073fd612b12c6"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_33.glb": {
      "bytes": 193648,
      "sha256": "c89698d80aa7e6e11824ca0f50428d5a1bebba3c08b476fcc46b3269b4ade34d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_34.glb": {
      "bytes": 229924,
      "sha256": "6978086171e89574f07f2ed49832ef1d9ba58a9fb70797d2b64f34d0cf238507"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_35.glb": {
      "bytes": 272004,
      "sha256": "9a930b42d21a7e23400f182e1c3b5f26a8adcf35bb5c58f9586f4b43760f1b18"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_36.glb": {
      "bytes": 313460,
      "sha256": "55643d3b189f57688d8e841d74fe70e98a58ef11877601020257c4e3ea024c11"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_37.glb": {
      "bytes": 385396,
      "sha256": "bcad68ceb4c745655609cf206d59a441ea5d208e5f2b0542b467ce44d8088bc5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_38.glb": {
      "bytes": 239620,
      "sha256": "f739337d634de3d526f5a9a91e4871a58e0234ce3e5045d63008a3fb668e57a4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_39.glb": {
      "bytes": 289788,
      "sha256": "64f28e4b2c21f550790626a9dd8eeba82e6100b51036b1aafd6af181447e0f67"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_4.glb": {
      "bytes": 173740,
      "sha256": "741e0ec55f0fbad50a96cdd3a07f1463440cb80d1b73ed2bd89b8a892d903c6c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_40.glb": {
      "bytes": 203216,
      "sha256": "78711a3c31580e65e2f65a236cd4e1f5f7f4454d3fb1d0eb687a64dd9e4cc3f3"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_41.glb": {
      "bytes": 167108,
      "sha256": "99a7da79e4aa29ff16f0e1532af1618a4d2bd0951c33715ad3289e8f013c14af"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_42.glb": {
      "bytes": 313636,
      "sha256": "13112ecd0457390539b91d4912b49fb1853f0ff958b86af4c7a8b519685444d0"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_43.glb": {
      "bytes": 236812,
      "sha256": "87ee22078b56e52cfa126b2469ea7756a4c4f7e50dee8555fdbda3ef98177e02"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_44.glb": {
      "bytes": 94616,
      "sha256": "a138143a7f666538b34bea0f2a4431d8f34e33c648dddb64a48f432b220b6fca"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_45.glb": {
      "bytes": 197380,
      "sha256": "960d7f77d2908f03ece23f888b0bb7c86bce6880a20d39f531c3738de760829c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_46.glb": {
      "bytes": 291924,
      "sha256": "b16b0b501f6b361fb607da8f7c42efacfd0f23fb098cd6e3e2c1205de4eec8b2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_47.glb": {
      "bytes": 307108,
      "sha256": "0e292b66039ef1b884050519e5657995b94e8a423c7f55b8c97b26ef4c55d1d8"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_48.glb": {
      "bytes": 194532,
      "sha256": "be2826dadeaaeefffc013a638d67ac6f9818c3db3005195f1b93766bcde91332"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_49.glb": {
      "bytes": 189340,
      "sha256": "64ed58089d6ed4a896215b8f6b6a911de3c435306a0fc0119a61527d504f2fac"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_5.glb": {
      "bytes": 326812,
      "sha256": "ecd904a5337ad536e8eefb091908800b3fb22cdca0c5582c126f18e6358dfac7"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_50.glb": {
      "bytes": 317972,
      "sha256": "386ab26c0f24f4821acb0b881a7a68bafa9d2364eb95dd8950e9727629eece74"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_51.glb": {
      "bytes": 131560,
      "sha256": "3456d5f0347ab4ea9bec0a74f691f43e977432fc634e3c11ca5295b8981d72b8"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_52.glb": {
      "bytes": 132372,
      "sha256": "cb1a8fa57861b01007f822f37878ccecb6629d060b20a85499ce4179d88d901c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_53.glb": {
      "bytes": 181912,
      "sha256": "288079897b25ef65f4a15969cfd646d9e212b5ece6aab17c2cb1483e9cdd939b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_54.glb": {
      "bytes": 82188,
      "sha256": "0e2202c865222ee1c53e166cc6bd5ebd1e246ce3d0f3a8a907c4abb3b383592b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_55.glb": {
      "bytes": 294012,
      "sha256": "1fcab15445c44b56634260d1078404b0eee58bc955a5d307fe755cd32803712a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_56.glb": {
      "bytes": 246424,
      "sha256": "06c2450893a6aaf9a1e3435e6491115a1f6c023b21f9627132b3a7e9e47faa1a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_57.glb": {
      "bytes": 112792,
      "sha256": "674b0d847d65349202aa7a2a31cac4582accfb766526d8f16474a891b50b0574"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_58.glb": {
      "bytes": 277808,
      "sha256": "17816b245440d571d5b79d34a0e7e4de809e15a86c018f2e366959a034006ad4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_59.glb": {
      "bytes": 367388,
      "sha256": "b3ffa58154c8a2b6ed988bd4499038e4e5cc73e0cfed2d5f8487b2a36bf06d1a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_6.glb": {
      "bytes": 274876,
      "sha256": "d36539a13b18d600da239d5a977e813007257618feae2c09b1adf8e7445f0ad4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_60.glb": {
      "bytes": 146884,
      "sha256": "79c08a7f3063fcdd0424133b954646f18fa84f62d582d82f5504179d5f12d939"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_61.glb": {
      "bytes": 169568,
      "sha256": "d0ba20bcf2c58dfce9176131397595421ba5cada36ee9bff57bdf28761b5d1c9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_62.glb": {
      "bytes": 196736,
      "sha256": "33cad5f2155d5bfc43898a5e7f3ea0b98e4b5ee518b95f3abf6355535b8a50ae"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_63.glb": {
      "bytes": 275832,
      "sha256": "5e300af776d8d0c46706918f89eb049a4859fb35423c3fc4a74d102f68d8fb60"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_64.glb": {
      "bytes": 236608,
      "sha256": "3fde6b04c173f12717cbd92a8b06058eab7bf0d681f3626d89e23d7f1c699a4d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_65.glb": {
      "bytes": 217396,
      "sha256": "7bae78e6f04cb5dbe6d4161582b9157cdcac4f3a93abf39d93a1ad0af450f8c9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_66.glb": {
      "bytes": 221076,
      "sha256": "4686355b756e749de911e6e7b558555697163691bfd2f62c834ed0cea09f529e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_67.glb": {
      "bytes": 123544,
      "sha256": "cf3a93e2552b6887d753c95122d9187107c6e03321ee4dcc9295655e040609be"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_68.glb": {
      "bytes": 124136,
      "sha256": "2a3bfa8045fa25d647c8de0b42e9b07a5bcf38f15dc215bf48aa6c8b7cb8fb19"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_69.glb": {
      "bytes": 147908,
      "sha256": "36695a7dd136256f826475d9ca138da28bd03bcb42b98ea2a677dd7159375f03"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_7.glb": {
      "bytes": 262836,
      "sha256": "c171b36272a665f592a2b3c113cfe69d04c6362b9bd506573ca7515692f07088"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_70.glb": {
      "bytes": 133624,
      "sha256": "b7d7551cfa0ad1c21b48399a69b1db6bd4cae2c2009cb8b4dfd1e59a3e92eab7"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_71.glb": {
      "bytes": 206588,
      "sha256": "0f7333cc455ce7461ac9144ea2f11d5f22486be25d9ca3239ab14762fe96539e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_72.glb": {
      "bytes": 178144,
      "sha256": "82b8f7d86d8ae2f906a2cc0a26c8df5dae04d4f1af745609d073ac2547f64be9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_73.glb": {
      "bytes": 338672,
      "sha256": "8d359058459752dca91ed1ac16d6b75cee2baded5dcea7d1431ad96f137f527b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_74.glb": {
      "bytes": 119504,
      "sha256": "023ef99abd6a4e0051e24fe90760930ef37aaeeeab383ba758ef127833627a98"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_75.glb": {
      "bytes": 234008,
      "sha256": "097ee0c30752aa7bea67820fd415b9db674f1841c04be123a4d8b5dae6bea79a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_76.glb": {
      "bytes": 185324,
      "sha256": "54f871b80f6944b0e6c344a61c0f1591ed8a7f84d8b1b490f6773161d55c6582"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_77.glb": {
      "bytes": 195832,
      "sha256": "b8a7b42841418c588231b40a3ae1e08e0a59ee469db1a5cf1c667812a2f98dbf"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_78.glb": {
      "bytes": 166128,
      "sha256": "4d53bd041fc313189c697facb83203d25e0b18ab74481c89428922552a3bf669"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_79.glb": {
      "bytes": 169740,
      "sha256": "4362eaa694bf87824b874d140d16063785c8e60f0b904c44542991bf970a9d7f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_8.glb": {
      "bytes": 139996,
      "sha256": "1ca0b1c0102c85fc44349901e10c6783e8568848a19a5b298b0d401827bfe562"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_80.glb": {
      "bytes": 191480,
      "sha256": "66f2739010ad77bf27c3baa5e816386c19c1f8e72f28a4b67b992beb44c737f5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_81.glb": {
      "bytes": 266580,
      "sha256": "ab5486fa9043af864650f356a01bf206a8b8428223e8f38f9a94f4a140c92839"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_82.glb": {
      "bytes": 267096,
      "sha256": "0cc2f8844011089f773d81382de878103df500884b3d991ffc458094920ab6a4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_83.glb": {
      "bytes": 255084,
      "sha256": "dd847b6a5a0cf46d2123297f51be30b836dd17b7e6975dcfe183356d4c3a1360"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_84.glb": {
      "bytes": 316584,
      "sha256": "92bdf399e3db80652e2670159000dd03208ef8e856116db60b796913387e7c48"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_85.glb": {
      "bytes": 227812,
      "sha256": "543d6fbbb7aa3c02e44362efd1e7015d3f5b04ec222630ef6ea834317eb1d239"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_86.glb": {
      "bytes": 270712,
      "sha256": "3b55383b342ed075753ee15214922229c618729d01e8a442854be51030d6c937"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_87.glb": {
      "bytes": 151524,
      "sha256": "2246a6c16651e9c64f3f322080225b8e833b01752ca89cd905e346548cb90c37"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_88.glb": {
      "bytes": 353092,
      "sha256": "a60e8404d8fc59c0083d0015faa6986d23c6ada663ca449cd86fd4e2ecc9692c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_89.glb": {
      "bytes": 218336,
      "sha256": "a175d015f478779b107eb9c7322345785c66706f4cac1d7174663649cbaf5725"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_9.glb": {
      "bytes": 292112,
      "sha256": "9702ef7478d0568b0153e4baeb18aed92e9a0dc9cebad343711b09ac2e30ef60"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_90.glb": {
      "bytes": 274588,
      "sha256": "422506882fb4f0baeb2234c361ef46d5102cb2a27f1f4a13e89c76296451f45a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_91.glb": {
      "bytes": 307780,
      "sha256": "34a10c2ff531574d3f64b368d8cd0ecb6d32e1ffdd26ba29af8b3435a4d14f5d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_92.glb": {
      "bytes": 184164,
      "sha256": "9c2c5c6fe5f14ec5e6de4772a99531ae0d4a324b1cc880ee9a123d5a9eb03978"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level26_93.glb": {
      "bytes": 373088,
      "sha256": "3c6445e969ac8b3e813dc3572bbd530b5ae2e3e54964e6a7ad4a8bc48e250005"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_1.glb": {
      "bytes": 150968,
      "sha256": "dc1066977ebbcf78818591d52b96a067035886426dc0d6055ea635ec9e743448"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_10.glb": {
      "bytes": 154388,
      "sha256": "c4f3140afc9b4e9be5e34b489e45ec8bc90198c7678c6da134f297c8452d93aa"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_11.glb": {
      "bytes": 189604,
      "sha256": "f5d1c3171c1fb509622635bc472a44201c433e49445afde9b435b52d77b9bf19"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_12.glb": {
      "bytes": 64324,
      "sha256": "50917fcf086793bdedb5147e3103fa6e3956aa43fd62c19fd29fc0b15985a972"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_13.glb": {
      "bytes": 258828,
      "sha256": "faf6d775481c21e3e75630c997228d4dd8e0b603ae7b20597dcb06a2cca7520f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_14.glb": {
      "bytes": 236272,
      "sha256": "8837e7087e119cf3c615cc59ae4bf6958c42ada48402dd8100b414782ee4c9ab"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_15.glb": {
      "bytes": 180492,
      "sha256": "ba81c3c2610f6df560a80ebb52c832cd96151f4f83d3781a0393deb565fecf03"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_16.glb": {
      "bytes": 160468,
      "sha256": "79b80ece5df49df970ee931966495b8aba5e19170647cc94a10e499304584812"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_17.glb": {
      "bytes": 183484,
      "sha256": "f6e6acc6c0f7e0915b8530ec6105eb5565a1c7ea1a76eac1317af7b8e5f3bc11"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_18.glb": {
      "bytes": 175892,
      "sha256": "326db84311c104fa57ad6090414088c04f2712b60d3b5fb82a668e68dfec2dc1"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_19.glb": {
      "bytes": 98352,
      "sha256": "7535d19492d062f0ab76f3479f7fbc0d0edb6d53a1b5e7d9dbe7cb7c1b663935"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_2.glb": {
      "bytes": 158684,
      "sha256": "3c06a37214b67c8367dfea7d32f95686a5bbc2dd0f4d161904ce046d7c521e1f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_20.glb": {
      "bytes": 202212,
      "sha256": "d965e7db2ca282dc05db921be364299c1d97314ee9fb60d913f3aa855e79efcc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_21.glb": {
      "bytes": 271216,
      "sha256": "88b39568129d2b82dbaff78be2291fa5b8e1b5a4b5d6e4fc391e97cfacb68dcf"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_22.glb": {
      "bytes": 115888,
      "sha256": "51d2ccb8c611443bcbbed8f0653d017775c79a42197626ccddced6d9b11492ab"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_23.glb": {
      "bytes": 227604,
      "sha256": "f0df749b2fdde5b08bda5edaa021ac0479fed2e1a4e1601fab235de232841f9d"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_24.glb": {
      "bytes": 219624,
      "sha256": "cc7056847cc9e02232058eca7843716b43b1d3b3cb3b5e1445527d3728e2dc35"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_25.glb": {
      "bytes": 213104,
      "sha256": "e6fd83c5ee36b72e409867ee7c92d5b123162154ef071deff90095997b785297"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_26.glb": {
      "bytes": 194844,
      "sha256": "d5f42198545fba5752ec0cae9b4caa02b3a124bd9e8cda027677cdf1195ddd15"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_27.glb": {
      "bytes": 239400,
      "sha256": "7a6a804413b38953ce3bb625f7fc6457891e678ad1f59251a719cb111aa22d15"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_28.glb": {
      "bytes": 283528,
      "sha256": "b622d519c085e38a787a0c796061c1e49bb1de00d01820889d4d69c3b85f0da3"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_29.glb": {
      "bytes": 229860,
      "sha256": "8c4074f74d7b1ad5fa437a44866b6b2c3325da83fad6c4a7bfc0bf70951273b5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_3.glb": {
      "bytes": 218608,
      "sha256": "b2a20e80f22b28389b1884d4bdb8b7442d8479878c813907202555785a66bb2c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_30.glb": {
      "bytes": 99884,
      "sha256": "57786e79b19aa899bca90a04eef95760d753d3f332c1873e848477746c2237c6"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_31.glb": {
      "bytes": 193592,
      "sha256": "47f032c5d967ca6c5a7155ec0df576c05ca7ac4fc06e46850b0c20b3a36f5de4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_32.glb": {
      "bytes": 111192,
      "sha256": "55bfb7028758c615a4c0d97778acaafed18a1d65fe505ae6fb40479366ceefe5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_33.glb": {
      "bytes": 134772,
      "sha256": "e8c9c0163bfed941f0f53e7d20b4982ede65a073dc3d159c1256050ff5aca5e0"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_34.glb": {
      "bytes": 160588,
      "sha256": "205d750afc1e00bdeb45449ac4bcabad8152c3d81ef2267484f66f3d01701fd0"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_35.glb": {
      "bytes": 117816,
      "sha256": "7bda3331ae6d72cfc0504c74b81a48a6be116d01eb824aabe7dc8f18761ca312"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_36.glb": {
      "bytes": 217532,
      "sha256": "cdb2dd8c7e5c5848acecc98212bd486cb7bea3ec53f0fcd4c705e95abd37c81f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_37.glb": {
      "bytes": 224088,
      "sha256": "264db2f00f6ff134825b49801cbcd05ef4aab87e6cda42a442348a60c239a03b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_38.glb": {
      "bytes": 192180,
      "sha256": "4cb0b4fa4ce9362771d9569696f43f851a2e9c381c98ec04b495a0b9a5403ea5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_39.glb": {
      "bytes": 209404,
      "sha256": "298171fed2192f58b74a7c1a8e6e37556a816d44c39ba453409855c32dfd77d0"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_4.glb": {
      "bytes": 203916,
      "sha256": "8b3996bd1c733a93dba510bf5a2ce22573e1acae73346b20f6a25ae9f43b715e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_40.glb": {
      "bytes": 125976,
      "sha256": "03b48af3a8ee6c1a3094af71922de9c5f4427eed287a97865d776b32232dd545"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_41.glb": {
      "bytes": 154448,
      "sha256": "0ccc1af529e6a90480681076abe13bad4449a57ee0e75879d993cda2be6acea4"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_42.glb": {
      "bytes": 171520,
      "sha256": "893d8d7d84249d94278fd9428bf2d51546d7aa22ff5975094fff7bbaddcc3e51"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_43.glb": {
      "bytes": 155788,
      "sha256": "96e043a11805f51bb665e1d71087b753f6807a089fb1dab84c017f4fab39fd40"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_44.glb": {
      "bytes": 192000,
      "sha256": "d7376e8eeb1bece236fc8ef68c5bbeadb8c2c9acd75143ae6d97707435f8fad5"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_45.glb": {
      "bytes": 183520,
      "sha256": "5123a4819e044faf2b71db615ae832a64f2a4b0aab3c0d0bc6c44b8bfd217d7e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_46.glb": {
      "bytes": 216452,
      "sha256": "ca3e5a29d43fcf83b75308822d629227ef13c98ba16a089db89b24fb8d5e413f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_47.glb": {
      "bytes": 273552,
      "sha256": "7e464152e83e819835302995a96b764d47385d503157005d959a52dfe23f9a2b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_48.glb": {
      "bytes": 161500,
      "sha256": "8c1754ebd5c7e3623314c8fd0f216988d893a7c53151050f81486e670b61879b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_49.glb": {
      "bytes": 253948,
      "sha256": "ef113111286565e6b08bf1ee6cba678053097f987935723583a38c6e7927a965"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_5.glb": {
      "bytes": 234600,
      "sha256": "f181d2e3505b3f41ceabe2e5693d65a5587b86b89097dd21bbe0b1ea6d61d50b"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_50.glb": {
      "bytes": 232244,
      "sha256": "1e68358f5111773412f3b3aa11ddb11f4720536c1671530d7447116b367d946f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_51.glb": {
      "bytes": 78776,
      "sha256": "1178b016eba5740671f762ad05619f0389f1131c039f717d86a35457abe49eb6"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_52.glb": {
      "bytes": 280144,
      "sha256": "40fd1e6a074b8781e093e8dda0a49c3a99be757257e04b203c2f3d878f45447e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_53.glb": {
      "bytes": 251000,
      "sha256": "902bf658c51bf4527a5cccbb4178dde9bbef54b90493e0ebdec74118ddfb4f1e"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_54.glb": {
      "bytes": 197180,
      "sha256": "523313231ee4c20162e85b99cb65175bcdc897162a9dfc660c9babcd9b21c2b3"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_55.glb": {
      "bytes": 169568,
      "sha256": "d168ad408778c49fd77d5b6e77529685543df545962c7c042b6f7ece60f8af5a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_56.glb": {
      "bytes": 199352,
      "sha256": "0dd644cc65fd84800aa9fe859ac30cfa8c4e23a91d989dfa7a39675aa73468c6"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_57.glb": {
      "bytes": 179552,
      "sha256": "3b55e11b2ba8d7e60da0ab657830081b8ce1050e8f95c00c6d545c78a27ac38c"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_58.glb": {
      "bytes": 132884,
      "sha256": "3495551a17a6626e21330a4ad62caabd984807bfd1b47431b4a0a063832c47d9"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_59.glb": {
      "bytes": 174976,
      "sha256": "21de277a37c2ae4f052bc8b5b8e7ed8e87899f6a9c16cb448adc61d4316f2d03"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_6.glb": {
      "bytes": 179584,
      "sha256": "2ed1a7edd515b41526e594c02a13162cc141c4ccbb193b2b46ca5214d9073939"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_60.glb": {
      "bytes": 150888,
      "sha256": "e6a4d580d73b0df1aa89e06874c895e41859300a682c56030ccafa5ac13d2610"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_61.glb": {
      "bytes": 157276,
      "sha256": "0e764106418d7a5e2c727c3c8752795ae2903d60e001d845c7d246e0e4ddc3cc"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_62.glb": {
      "bytes": 292004,
      "sha256": "85805b1c1094b44ce3ce944393b2210af5cf3374234999e9c812fd63d314136a"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_63.glb": {
      "bytes": 179880,
      "sha256": "81463ac83909c04690d8a9a086df9a94d115a50a911b714c240105108da359bb"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_64.glb": {
      "bytes": 262340,
      "sha256": "78c1a1b7f404d9f422176f62830b826ea401d1b3038605dde08e9296199e511f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_65.glb": {
      "bytes": 201972,
      "sha256": "30eea497fb930546832d15746522f098e0256de729af7b8e2b7be0f3162cb2df"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_66.glb": {
      "bytes": 203100,
      "sha256": "1e475f7712338c3982c7315a82f8a1460d76868c7489b6568b23003bebf83a32"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_7.glb": {
      "bytes": 134616,
      "sha256": "4b091c0a0617fdbb70674116669d33fa0ed2aaf6fd90eab58de7618e8ad92e2f"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_8.glb": {
      "bytes": 200780,
      "sha256": "9f19756e4aa27db4ef83a49bc7df22cc8b2a73f6e74b56c1053c5a31dba49af2"
    },
    "office-delaunay-image/3dtiles/Block_0/Block_0_Level27_9.glb": {
      "bytes": 202644,
      "sha256": "82ae1a227e1fb8f799685d599faab5376e200a648fa0daeea8ff810f67d2d662"
    },
    "office-delaunay-image/3dtiles/Block_0/tileset.json": {
      "bytes": 324976,
      "sha256": "a662401c6f8fcb0e097f271e48ca31c825e94967ccd4d035217a8de785ae8341"
    },
    "office-delaunay-image/3dtiles/coordinate_contract.json": {
      "bytes": 789,
      "sha256": "50166dbd57faad7c5a0665e14c4d84b4920ccd60011581366adeb680a0df9007"
    },
    "office-delaunay-image/3dtiles/tileset.json": {
      "bytes": 1278,
      "sha256": "41971691a7a60d184eaaf4408140a83e13a7dc895c97efffa85c4b33deca1cd3"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level15_1.glb": {
      "bytes": 207112,
      "sha256": "6627c85dccc6e777405daecf02e1099549d9d001b612a11c955297bcf4fc99b7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level16_1.glb": {
      "bytes": 200852,
      "sha256": "51913e6018109e85681afe61f9bf084804d4f5517e189099752f62f1de723d37"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level16_2.glb": {
      "bytes": 190108,
      "sha256": "ef944a21b7fd55af789f4978f1ffce1c9bf378f8f15887bb7318335c5507403c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level16_3.glb": {
      "bytes": 268340,
      "sha256": "9ecf8182173fa55507725e9e53585445c0f17902764110c989fad63ccb15e0d9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level16_4.glb": {
      "bytes": 155704,
      "sha256": "7236002bf4a05b12c643417f64e566ce4c76a3b7bc052b995a1d0b2f8e48a6ea"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level16_5.glb": {
      "bytes": 184188,
      "sha256": "9ccdeb896ab6eb036759f07db24ed612c75853cc1dd7de73cde2c841c6f3af6a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level16_6.glb": {
      "bytes": 227648,
      "sha256": "9d54dae0c0122fd7800459ccb84da4a84434daa6dfd94c202d9d8f5275673d2f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_1.glb": {
      "bytes": 62092,
      "sha256": "0e475ffb61f2ac95b695c7d21c3713218902c8960919b543fd7e08cd4e8db896"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_10.glb": {
      "bytes": 272884,
      "sha256": "cd9233112a5a84db501521be13d42f33de380df9fd9e546765aa3c4b0f843f6e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_2.glb": {
      "bytes": 112044,
      "sha256": "dcdc451beb5ba538d54e5c3cc56efde7388c016077268ed09e6e0a4c1ee7bb6f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_3.glb": {
      "bytes": 246772,
      "sha256": "f6f79176321f6509f4ced5b19b0a324376b3c242e9730b85787be99b5c34e9a4"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_4.glb": {
      "bytes": 35756,
      "sha256": "aa9dd0371106871f3b2c0dcd6eee99ec4e70bdf038c2392954c8c93efb538f53"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_5.glb": {
      "bytes": 256932,
      "sha256": "32dde7ae7027d539aa57b509ae13d5ed847de45b7cd5adc4445502f6f3123871"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_6.glb": {
      "bytes": 106512,
      "sha256": "e9a5ec6fb3266f9114a438a94d8a99e527dbfa60cf24f13aefb5604000801bc7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_7.glb": {
      "bytes": 215048,
      "sha256": "36bc2f00326d214baeb865748c4317a02ebe217c989db11a3cc255c8e7db886d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_8.glb": {
      "bytes": 172612,
      "sha256": "2098168d7eb094a5941c6ea1ede920863452b27d5b7c800deb2f7ba44d12e3b6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level17_9.glb": {
      "bytes": 156992,
      "sha256": "8e0481a4b21c83c175606bfd027e0ac1fa72d17179da9c8c68a9633c09cfd9e9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_1.glb": {
      "bytes": 86132,
      "sha256": "5087a8509ef418dbd479489e94b0b8d520275f55523415aa982a371fd46d8610"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_10.glb": {
      "bytes": 266028,
      "sha256": "514df294f643d5f1f3b3ab5728b845d8c29f07c0a7bcb8335d46648f59190618"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_11.glb": {
      "bytes": 262060,
      "sha256": "7c5b8cf0338dbaa788d0f63059c503dfcd0e70623be6008e63d4cdf98f9779fc"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_12.glb": {
      "bytes": 202972,
      "sha256": "39b30289e20259ac2c42b748f5fa4cbfa4b19eae4249a645bdac4710c6aa76b3"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_13.glb": {
      "bytes": 223284,
      "sha256": "f06e92e899633e3310a246caa9ac8ff094d11a559874d605f30c58ded824cc4e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_14.glb": {
      "bytes": 122148,
      "sha256": "29e03ec6a74e5292331e5ed8b5d9910739a82b0b5311de15b9ce4a9ef80c97df"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_15.glb": {
      "bytes": 98760,
      "sha256": "effb74237b100929cec3e84f15c502f142a63a8f2e71bf8315a5c42b9d613139"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_16.glb": {
      "bytes": 212512,
      "sha256": "52121ddfd964777e8dbf33fc8f6e69725056d8318f4f402cd5c80c0a26624933"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_17.glb": {
      "bytes": 236780,
      "sha256": "b53a5226163589ea8bce96ed81240c812ab4f65dfe70fcfd95ae6453fd1a4beb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_18.glb": {
      "bytes": 203980,
      "sha256": "0438afd9ce694f87f85881500a4c7e1e3383eb66f5b13aa6486f868041fa56ae"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_19.glb": {
      "bytes": 85784,
      "sha256": "6214e16d9bbb25346622b62da911ae32a4b0a10651e7e01fe82f18983f8ec3cc"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_2.glb": {
      "bytes": 172296,
      "sha256": "7222b66261f153cf2519dfe7261cc912ed50563e0340027634616bcb5b45e5b6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_3.glb": {
      "bytes": 138416,
      "sha256": "d3871fb939761b76971990d072f9be77daa2f9ae69ec66a23f8e5ef97bffdfd9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_4.glb": {
      "bytes": 131748,
      "sha256": "ecbe6f78a46d21e40c4aa33585731656a188b5538c136bf6f2db43d84e41a7b2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_5.glb": {
      "bytes": 154212,
      "sha256": "9af809d263a20e217df07687dc29ada1e905705175516ab452cc41664bd04993"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_6.glb": {
      "bytes": 42716,
      "sha256": "f0539218b276b39d1cf97816b49b8a8e206278b507f0305292fbeb3cb5831b42"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_7.glb": {
      "bytes": 228912,
      "sha256": "3c2a4d3a457d4e8d6800aa933727398110e7393660a0fa2ff7c1719cb41371e6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_8.glb": {
      "bytes": 174608,
      "sha256": "51568d30396104d834fb53d28ee8c1d8085788e9d533835095182de26c219252"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level19_9.glb": {
      "bytes": 141480,
      "sha256": "90ee1687ff4b41bc312f5c7926bdaa7b17429319df0c5882702c92c990a488cd"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_1.glb": {
      "bytes": 107192,
      "sha256": "5b09f8bd24a6ce92c37d9c7d6da50b9b3377ecb8b88c1d37272de1ae7b0ef5b9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_10.glb": {
      "bytes": 227784,
      "sha256": "d3a6dee6cd871ab97eba20f1e8dc6fc89e184092e4751e9313dbe5bc2f133a8a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_11.glb": {
      "bytes": 190152,
      "sha256": "493e6de75c89374f134b79b7cd1b98a469c997a3e1f8fcf41bf29ab01c6858b6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_12.glb": {
      "bytes": 133404,
      "sha256": "ad9fa3c34d676225cc89e4e72b23a7d68a8e1f2c812ae47a01f4892fc5e10450"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_13.glb": {
      "bytes": 209620,
      "sha256": "32cb3db80c1d7fe58cdfae3172c977856b4fe3c2a713c2edf59d945047f571b2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_14.glb": {
      "bytes": 93976,
      "sha256": "505e803bec0c6ff70e4e4749b43ef57bfd1177dd30afdc47c2790f91791f70e1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_15.glb": {
      "bytes": 208996,
      "sha256": "d9fb17ea80ce634201c7e674ff3aa7e2e6af77abd6158b1e6a4a87d70e9bba38"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_16.glb": {
      "bytes": 131360,
      "sha256": "cab7056bce5acdd68dd77559063afa065b14f5dfd421db70b84f7ae65f766654"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_17.glb": {
      "bytes": 183608,
      "sha256": "8f502a8966f792544bb4ab90f8c598a6d8a302f71960b6ca9eb0f0dd09a2ef56"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_18.glb": {
      "bytes": 115228,
      "sha256": "9237c3e15b58ebdbefa75408ae8b9cb2f2aec0d8ac130afff7645093f3e2cc1f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_19.glb": {
      "bytes": 117640,
      "sha256": "b25b7f2df63d5f4788f4a99200f307ceada27dac7b490bbab6c9e6b96ff68ee1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_2.glb": {
      "bytes": 176564,
      "sha256": "062d42cbfa7babdbb1d9bb3ac97f56627b50ba029ed87e33fc9607ec5e61bcdb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_20.glb": {
      "bytes": 204016,
      "sha256": "059506e1a652787a7ebe4981e7337c0c93ffa2b6e2659d0381cd0c6634a200d4"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_21.glb": {
      "bytes": 227328,
      "sha256": "04c98e6420b33c6a518f2313d5eb461852c72998d4fdff7df763156abfb2e611"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_22.glb": {
      "bytes": 63244,
      "sha256": "2d98fe4c507754efad2d6555552c270bcefc4fd45aaf050d4f04670245b61f3a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_23.glb": {
      "bytes": 250228,
      "sha256": "b5da62c88894434b596a4fff8cfb61f93d724a1d87826f28e8814d74410ce8bf"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_24.glb": {
      "bytes": 24616,
      "sha256": "d08e0b8371282d2c3b775aa225c844dfca2e1938718fcec8b8c44eb5448bf9a7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_25.glb": {
      "bytes": 218992,
      "sha256": "97db1a623e394f2aa00ea45c97a1191c26f9c622b04fc3b8ac3c2ad6025796cb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_26.glb": {
      "bytes": 239924,
      "sha256": "608398c654046b7ce97e8dd0ed77390e4bc7ae79235dcecdd56d3e426d3a2722"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_27.glb": {
      "bytes": 216988,
      "sha256": "867ea50002b60e2c2b054830ff6b97d859af8dd6782c802f77e0cc84842c2969"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_28.glb": {
      "bytes": 129336,
      "sha256": "c61e71a99ba56572c5bc22389ece9f654ab9a4c8721ffcc5e92f78c453ca3e92"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_29.glb": {
      "bytes": 233680,
      "sha256": "2f1e08a58dceed79403a3b348b1a64382d1b9dd084c109542bd4e8ea0d360b7b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_3.glb": {
      "bytes": 147988,
      "sha256": "dd3b98e9e183194e3fcb6ca9e6cbdfb2992f4ea99a83d3cafb97c381452d9374"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_30.glb": {
      "bytes": 59532,
      "sha256": "a65474db697bd94ebee53d10984c81db3885a208d247f7a725ce382c8fa3c6eb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_31.glb": {
      "bytes": 126424,
      "sha256": "18e8e1bc4c40f92e32fcf9f8d4bd8d54af99122954116d6fd137c7a92f13b499"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_32.glb": {
      "bytes": 181888,
      "sha256": "f85047cb51b5afe2994b9ccb83090802ba3deabe757311792f0409ed51d4aebc"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_33.glb": {
      "bytes": 108844,
      "sha256": "59c503381e588c1a607615e26a714ac6bb905274783fb2463bdb2a090cc6478a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_34.glb": {
      "bytes": 176384,
      "sha256": "1cc26d43dd86e133c452e31939f65cf1b846f2065e91eed05e218f65efae6122"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_35.glb": {
      "bytes": 104436,
      "sha256": "0105d0229bf24626d4d4b3cbd03f148ab7b319a9ceca98ed2a26aa674f7b5dc1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_36.glb": {
      "bytes": 195724,
      "sha256": "64f9cb5cc8b871105558b3c2a983e968318844d79c0f48c8a470968861a1d05d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_37.glb": {
      "bytes": 153300,
      "sha256": "99bd114ef713c10240269ddbe77b2aebcfadac981e7ebb740a0c47beb62d349c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_38.glb": {
      "bytes": 223796,
      "sha256": "8bc731c3bc4717cb49e268ecd5c750a038a93bd81bbb9348314c934180777759"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_39.glb": {
      "bytes": 167916,
      "sha256": "016a8c6e9f1db09771f18f2452c27824381a96ce39b7e65132f55dbefd4ee65d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_4.glb": {
      "bytes": 168268,
      "sha256": "a16c12a09bfb974ce91cb2d7680a05972ae99cded5f9e10ac005f3e3fa14e62a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_5.glb": {
      "bytes": 162040,
      "sha256": "4a39f94f245b9b2ff8aa2a0e2ec874f145aebe445ed7432eb902eb43f74d4339"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_6.glb": {
      "bytes": 184888,
      "sha256": "88704a61fc7cd70f3b731910903417188de97051c453f7c7e4a0944ac6187a39"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_7.glb": {
      "bytes": 52464,
      "sha256": "9d81f984beea32b48c92e5943716f8085c45d1baf5ae8d880f2d7490af47edad"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_8.glb": {
      "bytes": 177212,
      "sha256": "e6b6493791dd9687cd4f10823aee7d877007e0648ea6d7e671ee54cc5f10285b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level20_9.glb": {
      "bytes": 194736,
      "sha256": "e17d2b27f0ae11616e09c933c83f70a3cfe9e922f6d5addcb2276dda38cff347"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_1.glb": {
      "bytes": 136908,
      "sha256": "9d89421a02a67a75c13cb49cc0a7c3689da4a9d18382bd1d201cb01337ada8d5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_10.glb": {
      "bytes": 64872,
      "sha256": "c3a9802e9d34e8fd0f2a710cf13c9186ce55afd273a40d89821ede6e10dbce3b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_11.glb": {
      "bytes": 215376,
      "sha256": "4af9ef48d254c82ef3d7f5b8e4c82a4bea49fcd8022f24c4e49ede290962b21c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_12.glb": {
      "bytes": 67148,
      "sha256": "4dfac8c1a6d61731c88bbe6351d05068cc5641fd201cce267c186d3af878a8d2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_13.glb": {
      "bytes": 51336,
      "sha256": "f2bc231e9c33da7359ec529ad30e7e88dcdf81dfc05150bea56eb0d23267e4be"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_14.glb": {
      "bytes": 199488,
      "sha256": "a08153bbc474b7fcf4eb9d47b005b2a2aae668d29b325ac57f9fab21610598fb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_15.glb": {
      "bytes": 99692,
      "sha256": "981beed9d0da0e1dfff59a4d0dc31b31ba7109a3ac242bf786ea22b6fb74e15b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_16.glb": {
      "bytes": 46288,
      "sha256": "d2cc6e549a309dcf69820e9e78461edd4d5f0f131b25236240691f8bccf28275"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_17.glb": {
      "bytes": 156564,
      "sha256": "2abdf9f278f4d1e593a012248a559a93a4096ddb1979856b0a4aba133eace926"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_18.glb": {
      "bytes": 130032,
      "sha256": "4a071b985d465db1bb534bae4cd0a2835aa2ec11d054dbcddff0b4f732aa775c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_19.glb": {
      "bytes": 58932,
      "sha256": "2c8f2eab0d0b98f8542b9210a9ca120bd190ef1582167ac17c313a7e0876e469"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_2.glb": {
      "bytes": 125724,
      "sha256": "7146c9947ccac2cfe0a10a0589629ad905dfbb09307640e395a43327a77bc569"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_20.glb": {
      "bytes": 107232,
      "sha256": "9779154ebd8d7df2a8d792b1a3207a5af2b3da6c9b7e3d6d21332a889ee2815e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_21.glb": {
      "bytes": 183080,
      "sha256": "8cd457834f03490073d9a9482fcadfab233d3350891f655afb3c5f1da89dd974"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_22.glb": {
      "bytes": 28828,
      "sha256": "0f73556789a9b8fbec47d537af2b4cc2a9dd54a1802bacd54c66503116b765f5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_23.glb": {
      "bytes": 88572,
      "sha256": "f6f6f4cc3dfe3a31997caaa7e3a581f127dbdfe03d14014d47a8d95a43ce3e25"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_24.glb": {
      "bytes": 206356,
      "sha256": "c03ab5c4418d9cf8887ccf8582ae531f4a5ecae4d62c83b9bb5754d95b3d2617"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_25.glb": {
      "bytes": 95384,
      "sha256": "32457bdf5cb14be4a135ee89ba64c87391af7383ee4d6e4184811054519cea69"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_26.glb": {
      "bytes": 165224,
      "sha256": "fdaa089112da019a57d31aee6e8fd94f32c65663346c04e7ebc7d0a12a77dea0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_27.glb": {
      "bytes": 196848,
      "sha256": "49e8cabc926f258dc64a17ab19330c5c7dfcaf5b184ea37ae31c2d8512776728"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_28.glb": {
      "bytes": 198424,
      "sha256": "77917e0f48cada9620f91b0d7372a0666ce89222a86df8f6074e49be840bcef7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_29.glb": {
      "bytes": 144200,
      "sha256": "51ce2cbeb10b0b575c78cdf85cfe63a5a86b1db295f23d4dcb4404ccaedcc479"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_3.glb": {
      "bytes": 187528,
      "sha256": "a420b362ea7e8efdf002f1ebc818237d1837f09566a20ac4e1eb0248531c1032"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_30.glb": {
      "bytes": 160108,
      "sha256": "ebcd3de5e3daaec2bf24b87500a8039aaa650e136b66d0924dbbea10b07c4125"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_31.glb": {
      "bytes": 124580,
      "sha256": "f39e387742824f8f9eee1c957cc3a3734d75a47f9c6943f42491c5be0a24e726"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_32.glb": {
      "bytes": 199284,
      "sha256": "2b3f6419709045d956f457bdd0ae8cd89856b03d455552adfd26f8d0d846a716"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_33.glb": {
      "bytes": 170544,
      "sha256": "5a7b2b0be66bf0870cb1caf1467815ae8c8668ed25908b426ddaa65a0ec65a23"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_34.glb": {
      "bytes": 102404,
      "sha256": "0666aff407cd44a055c058369c6f83c82fa359f60565a8a549ee3bd918790a3f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_35.glb": {
      "bytes": 240332,
      "sha256": "b41ac134c66256065dd337cbebbdf2c04c867ce234579442d21bedbad89d2881"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_36.glb": {
      "bytes": 226476,
      "sha256": "ddcc76eba46ccf628832fcd716c063f8cdc29461f1230beedd318163e31b9768"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_37.glb": {
      "bytes": 174928,
      "sha256": "8868d4642b07e0f98fa84d47466b89f80de9aa87a195c327fa1a54caab8f5be1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_38.glb": {
      "bytes": 118416,
      "sha256": "3b5a8d2e644fae54be6cdab7e5ca7571cbcd7aa2aaf5ed392e35fa7c8765ccc7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_39.glb": {
      "bytes": 170124,
      "sha256": "0f55a2a484cdc1d893f91587f76db51ff147b0917ef53b5ecb6c3bf422edf034"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_4.glb": {
      "bytes": 236720,
      "sha256": "0d91c146d233a68cfbf6bd9153ea11736d50824c0b3b81193935f928992852a8"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_40.glb": {
      "bytes": 247484,
      "sha256": "202e52b8ce90a1e5b191883f0afa3296dce5f9f16812ce036b43cebc156593da"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_41.glb": {
      "bytes": 221668,
      "sha256": "c32b5311af99343271f7d406d9760ebfe2106492b0a5ff79996ed0f5833ae1d8"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_42.glb": {
      "bytes": 119684,
      "sha256": "94a673ca35951ee65418ef368e660f0ae418ac5d841ad5551117352c9d2c22dd"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_43.glb": {
      "bytes": 165556,
      "sha256": "630cefa8ce4ef50566d029fcd28b5b8ab6a4ec53b2c054ecffe38c69d7bdec16"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_44.glb": {
      "bytes": 125012,
      "sha256": "f3df613e298f8df4db2a5135bf2508e903cad89c3e8b0767b58837674bdbd942"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_45.glb": {
      "bytes": 168816,
      "sha256": "bc4aceb6ffdb7a7eafbbe218d23729cd252e1e00946176ecda59d60fd592ef6c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_46.glb": {
      "bytes": 139752,
      "sha256": "4f9514d6652304da913c2fcab1904902d8ad6b0bfc595c6614f68d4046f5696d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_47.glb": {
      "bytes": 115788,
      "sha256": "5c0f2df16f9a782331ae0aa291913d156222606f020a6da050a90e438d311d6e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_48.glb": {
      "bytes": 194284,
      "sha256": "772579cf21bc2cd90761c003b8d66f7ff7449ade48f2b0e0be9ae29f4b0dfaa6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_49.glb": {
      "bytes": 29148,
      "sha256": "5b6aa6975c2001573db2674e25cb2879f0e6644ffa0b63710bce5b7f6c1362a7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_5.glb": {
      "bytes": 40276,
      "sha256": "e6a6bea4d69dc18896ad4ccee7389222bdfe83b8439611e8940322fb7d2d683c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_50.glb": {
      "bytes": 134000,
      "sha256": "88e67180d9fd49db5bc9e7a76085543a461551bfca1c33f8cf9c9d5247c52bb0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_51.glb": {
      "bytes": 136888,
      "sha256": "8f60193c3c6c2e35acf5f1d3ae823fb83c4ffd19e103a3e92aeb810512425dce"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_52.glb": {
      "bytes": 173064,
      "sha256": "6fd17595aef876fdf79227b54cb24000541f90398596a56965e5497272cee673"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_53.glb": {
      "bytes": 141868,
      "sha256": "d3ab1a6158d05151707eff7f75a2fa2cdcfd97a70ff5aedfcf2268e8014e74d4"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_54.glb": {
      "bytes": 232684,
      "sha256": "51dfb28b03f3f127645d74e8d5ee17093e3ff61d4b4ff5909a39656e88f1fd35"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_55.glb": {
      "bytes": 140564,
      "sha256": "733764d564a2829fe4f3823f81563fed8ef46fb63b246b63242629499d0b2b84"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_56.glb": {
      "bytes": 165416,
      "sha256": "fc6c56c36bb2dc5e0ead5c01b93d126ace47204d97e7d167a6cc53c531bd2875"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_57.glb": {
      "bytes": 156308,
      "sha256": "87eb4c45a0a42140bb3edff68a2d5eba4cecbdcbdb041123fdfb30b008cd41be"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_58.glb": {
      "bytes": 147208,
      "sha256": "2a615de4f350a1db5872e4c9e9d5263d1068d97485bbca4034c4a8524128cbda"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_59.glb": {
      "bytes": 137520,
      "sha256": "cf3dca75215ea2044989dec332388b730c5ee3713dc38da6f772401ca840faf0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_6.glb": {
      "bytes": 220344,
      "sha256": "ef9c4d5c564b91914bc6f1ae0c5123aca56572b3a503d39a71a055f0bba2026a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_60.glb": {
      "bytes": 240520,
      "sha256": "ff9f1edfa8ab941fb53962552c2c92e28ddbe9027abc11b828a094d0e526ce00"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_61.glb": {
      "bytes": 183144,
      "sha256": "7f1302b81c9805bf103067b1929efaf7ac642434552b33646ca6d68162d24f10"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_62.glb": {
      "bytes": 154176,
      "sha256": "8a8fbed5c7e80e93ea835f8fcca5d160b5008f98928accbafae4e464202bcb73"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_63.glb": {
      "bytes": 225772,
      "sha256": "d50ac7282a9b68f1ac7da6a58793931bdeb4ba36f12c0daf1615ed382fd0f9d5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_64.glb": {
      "bytes": 122452,
      "sha256": "b6ec08b5bd323167f6fbf9b1879bb0b068d7688e20272247ba580bb0c42a3970"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_65.glb": {
      "bytes": 216416,
      "sha256": "6557f500975987926e999b611ec96ce24912b27b9f7fea6a633cae2f0d58df49"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_66.glb": {
      "bytes": 82944,
      "sha256": "dbbe3bc2583926cb33aade08a06f0dec8524f2bbb80811aacf20fe0c84032ea7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_67.glb": {
      "bytes": 246072,
      "sha256": "b24ab202d28e88910bce4c4d685aaa4a996a4d781e45a0e6da52da02b07b8b22"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_68.glb": {
      "bytes": 196648,
      "sha256": "42916c4ca443a595e8576e45ed690a7d9bcf67a6fb1c343d284d3f9f340625de"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_69.glb": {
      "bytes": 19156,
      "sha256": "3fa9a542bdcb0a163281a4d45c948f418db70df3301e17b6b32e74bd77040fe3"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_7.glb": {
      "bytes": 219044,
      "sha256": "55eb04aaae12c74c194d76ba0b0bd0c1232cf67da1d2d72a2397cb55c5b408af"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_70.glb": {
      "bytes": 119164,
      "sha256": "0cebd0da2f8a8509f21aa5079f1e37e7b2fee13ea53e3b6f53887b61e1977293"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_71.glb": {
      "bytes": 176676,
      "sha256": "b6ceb687d8ed8ca9a4e607e3e39e0d600ba6cf2af586055ed8b647e80003c05c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_72.glb": {
      "bytes": 162772,
      "sha256": "97efc92062e123e640a4454ddb583453cffff4d9d516dd849d74233da7c27c8c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_73.glb": {
      "bytes": 153668,
      "sha256": "32b39bd6aea39291c4a05d17c50b7b6249b4d7a5a713136274bb4161adacefdf"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_74.glb": {
      "bytes": 94844,
      "sha256": "35a2e08cd1ee5b2fd9ab82bf1ffe42f6d39b5a96a4db0cbc2f54cc7892ba1882"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_75.glb": {
      "bytes": 182188,
      "sha256": "14b3cc6dd51de54187cee17c05ddc03338c234c534ec7ecb68e3eb384d144b7b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_76.glb": {
      "bytes": 243932,
      "sha256": "b3d2aa1de87042e452bbd5814bf264f71ddae2e3aed3a00e28c6e45e5e1efbb5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_77.glb": {
      "bytes": 189008,
      "sha256": "c1a3ed9d6afb36a097d40aada131738da5a7c970b1bebceeb8f9ed8bc1360738"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_78.glb": {
      "bytes": 232552,
      "sha256": "0d4d20d62f3116f7ad7abd91d32ca02c14fe8e8210e5913b7321f5f2942f6c56"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_79.glb": {
      "bytes": 65940,
      "sha256": "02f47651787780ca3e135cea15cc6a90214932d5b5ea1ec49e766200283b533d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_8.glb": {
      "bytes": 115144,
      "sha256": "7ae675825f5453b158081b75ef7116d9ceb0935056c52f2d7a0e98844aa8d7a5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_80.glb": {
      "bytes": 194724,
      "sha256": "8dcbf24dd574aee42421f03a40b595bb4d830ac262f698695af71047ebdcba96"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_81.glb": {
      "bytes": 123488,
      "sha256": "089dc00356acc77c22eadea727398170cd9000f4603250c6d1c23cb6700f2bc4"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level21_9.glb": {
      "bytes": 156568,
      "sha256": "f8c2791e259981fa38f5d9d6ef2070761305bb6210e02c89bf2ac1344b1b0b5a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_1.glb": {
      "bytes": 192920,
      "sha256": "68bc2c40eeda936309eca37782392d1094dae5a54c27f2bc034b88a14ea2812c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_10.glb": {
      "bytes": 168156,
      "sha256": "c081f0da35e0da5b5570e0f337840c5d2539ac254bd69ed9b427f18941faf1f7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_100.glb": {
      "bytes": 199664,
      "sha256": "a5ca59555e28906b02be2f724eeb69f174af20f639bbf2576c8e711a3fcb7a9d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_101.glb": {
      "bytes": 160104,
      "sha256": "0ab71c3b82250c5a7602ac6c51e82c3b0f89feebaadca6bb1c087a23dca21f92"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_102.glb": {
      "bytes": 128440,
      "sha256": "484ea4319f310978e8eb65dec9d78508d91001c6c5c895e67bd00bf465d37831"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_103.glb": {
      "bytes": 161720,
      "sha256": "d509b3c4561d9c2bee8b3e3cb96dc13883eae5535fec50d3c19f6ff140a0e6da"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_104.glb": {
      "bytes": 174868,
      "sha256": "c7bd851f03ec99c01f4925b4c96cfdb2dfbe85b31969a4ede9cbf042254e656f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_105.glb": {
      "bytes": 204584,
      "sha256": "80748ffa2c2889ecba1dfafb585182b0676ecad788fd0909d2be0e819cfe6c0b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_106.glb": {
      "bytes": 100044,
      "sha256": "30434c31afc3781114fa8a49e1d66168afffd470b257c462d6ce571917a58011"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_107.glb": {
      "bytes": 162408,
      "sha256": "b6b4862428cb986adbc597a58a186f5d9f7cbbc80d54ff55b5f6e4c3e82e78e2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_108.glb": {
      "bytes": 178892,
      "sha256": "fb03ea2ab0a8d25a650c8d7618ed98bcc105108322f43d30ed02d453839ab410"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_109.glb": {
      "bytes": 172032,
      "sha256": "f661a671cda8563d4604aeb95a57e405d83b0a60bc55fc68401ce9e53e63b982"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_11.glb": {
      "bytes": 192584,
      "sha256": "ab10d31ce4bd17168901c78e31dd45d2acc6396eb8f006b5daff10030355d188"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_110.glb": {
      "bytes": 190928,
      "sha256": "091ec31223df9f60437d4ba884f85d0d1de0b13ea35026e6f6b51e2e1185e4a4"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_111.glb": {
      "bytes": 102524,
      "sha256": "624c4566a31992a71aa14d1fc94002afd15690d292750187a0c20b1529e61b53"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_112.glb": {
      "bytes": 252052,
      "sha256": "8152c13db9f244d2c098052d09a231db95fd081059c0e6f110b37b806033c54f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_113.glb": {
      "bytes": 231700,
      "sha256": "7a3bfd3573cb6ee54d199c650434c3db1954206d1be04d3235df7f65b922907e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_114.glb": {
      "bytes": 188228,
      "sha256": "f34cfc1d294fb4fe1fa7bc1a08ef07823daf963f4509e68e705ccc7ba7ab5c84"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_115.glb": {
      "bytes": 181796,
      "sha256": "08d46e4e930dd25145f9c115e5080cd3623a40a10b4d41477eb610e1ec5b1d1a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_116.glb": {
      "bytes": 129016,
      "sha256": "1afe2ecceadefa455df4c16d8f4f945c2c522a392712dba04f413118d7e31fee"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_117.glb": {
      "bytes": 184904,
      "sha256": "fc6f292963e9157194b5778e8ab8de0018c71c95725dbee3f40509e5243f2edc"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_118.glb": {
      "bytes": 191420,
      "sha256": "9922e6958085f7506d15653d2974842ef1369fadee9c8547389a2820ab48e059"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_119.glb": {
      "bytes": 159404,
      "sha256": "7d4b273add4bf86bc9e895278e953904e4a9a87b94a295aaccc24d704db61a44"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_12.glb": {
      "bytes": 151716,
      "sha256": "d3447a5ea8bcc35c15c077fb58730d3d9e67c0cc0b7b504d4876ced7144b2f19"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_120.glb": {
      "bytes": 173928,
      "sha256": "c7ef6cf29008cc12c91df6965848a2fe42b86cc398ca433c5a9fdf9cb6711922"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_121.glb": {
      "bytes": 64384,
      "sha256": "a352098b743cd285717b355914dfcba8e3159ee85538312cec268cc0ded51f7d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_122.glb": {
      "bytes": 248848,
      "sha256": "9f0d154200032358d829916abdf94c2c5eb0cedf4baababeef3b65ec9148c544"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_123.glb": {
      "bytes": 232104,
      "sha256": "16645d62310871fa8ce1d4284ab4fd9c4feb3f228cce29cc5671d7e0eee48ec6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_124.glb": {
      "bytes": 176332,
      "sha256": "57eeb30af5caad30f104d490b7955a51caf306e9642f1b8d85d17be1da5a5229"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_125.glb": {
      "bytes": 128188,
      "sha256": "ac7808aee43f7b45386ab36df3ac225cb0fb2b249ae94453558e246414dca981"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_126.glb": {
      "bytes": 132260,
      "sha256": "abab844926b9a0e0f207f06e22cf4e814e1ce32d6e00313f82fd6039d2226ff0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_127.glb": {
      "bytes": 82232,
      "sha256": "a6e76adc8c782cfd0b8dbf43947073b1adb00d3a5990d3148e015b130dd45077"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_128.glb": {
      "bytes": 238640,
      "sha256": "cec161f909dafe3e69375bfa0c48dc3e46a70a199c12fe7ac8c90ede266a718e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_129.glb": {
      "bytes": 132184,
      "sha256": "540270ff5ae953955dc27d714bc7f9a5061451d26c252ab9b209b01b888d8077"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_13.glb": {
      "bytes": 173252,
      "sha256": "7d404e6b81ba3eceb247335219edf562188f37dadc1ca27b14d0f4de6a5946bf"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_130.glb": {
      "bytes": 69452,
      "sha256": "852dc1a94eaf01cf857800c670113f4e157747157c91150d06cb7b4ebd90e9e7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_131.glb": {
      "bytes": 206888,
      "sha256": "6df11f038a174665abff864eb3893c19498e6548f65a546343235bf90a6ce896"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_132.glb": {
      "bytes": 148336,
      "sha256": "771a4e34becbfafed6b741a0eca3778b9b28cadad8392d1a25b73d46c8e156df"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_133.glb": {
      "bytes": 104964,
      "sha256": "c076d15ac4a22277d47a895e222ddfebc95ddc7e7ba6d41b8772fa83fa8a1874"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_134.glb": {
      "bytes": 112036,
      "sha256": "7d7c32504e05b6e4105f27a64fe05ecc5e6d17cff93eeb5cc24f5d2336090009"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_135.glb": {
      "bytes": 203588,
      "sha256": "b5ccbd933401236bc6e926c7e2ccb77c2d836bfcd496d9bd3568772877242ffd"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_136.glb": {
      "bytes": 19168,
      "sha256": "32e9a676cd0be7a01ce7a7626522f744fce265b8601829d7253366eec8cb9d34"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_137.glb": {
      "bytes": 205700,
      "sha256": "845598dbcc4ccf686bc99ae742c4ed6b351b9397ffb7710deedc1d3743ba0969"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_138.glb": {
      "bytes": 149892,
      "sha256": "519a47e224c03f17bd0dbf6d900ad943f1b986a3ac0f803863dd2d43fe2bc224"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_139.glb": {
      "bytes": 209408,
      "sha256": "e2574816ad90095c269af27a2e0a0e2835fb8553f280966b702c7991432cfd6d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_14.glb": {
      "bytes": 223296,
      "sha256": "b88f2d948eaad402bc9d06485615910b856a151d6f4ea5f8b8fe696cce7aba67"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_140.glb": {
      "bytes": 261480,
      "sha256": "ffbc0d66649fa02c4cb40865320987ea2ff5963bf086fd97b26e767f535f1d38"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_141.glb": {
      "bytes": 138028,
      "sha256": "1a77289788a01a251b802e9b114a26bb49aafc8df3805374de8b708df542ea32"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_142.glb": {
      "bytes": 246344,
      "sha256": "cd10f182969d173a475114c667432838ba8dfb45fc6dae5d56b5abfa435c6480"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_143.glb": {
      "bytes": 154696,
      "sha256": "6c740f50c7b73cb4df9b162958e0e8b5315b798382195d4723a4a310364b97e2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_144.glb": {
      "bytes": 146064,
      "sha256": "b69ff78aaf3e3f0762e16d4f32daf3a39597d40399b4cf3537c2fa247c679aa6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_145.glb": {
      "bytes": 178420,
      "sha256": "8a98bd82a655013e936f592ad65298d367525252f76320b88e0936fb769c6a84"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_146.glb": {
      "bytes": 131212,
      "sha256": "c063a000587a332077009d5a1ec0230852f9e4b73684bd6b0abceaea8934e60d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_147.glb": {
      "bytes": 216100,
      "sha256": "30256ed9faad458f742790c2523b723a6e4c1dff2f2eca990855394ca33aa4d6"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_148.glb": {
      "bytes": 215188,
      "sha256": "b19eee08923d99c8bdccfc2267adccb5b80025565f354f0638d4ce14cbfd7aed"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_149.glb": {
      "bytes": 92220,
      "sha256": "998b23c4bc9a6bf5d2747fd5a3a2fe0506d0d8c195d3766f1f250077b7064269"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_15.glb": {
      "bytes": 84780,
      "sha256": "0bdd3f49d39177dd6732d2e8562efe45200ee6700f3ddc0cc8a1dfd6fcef547d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_150.glb": {
      "bytes": 136972,
      "sha256": "21fee5ad54cd5361f72b5ca417cc66c19596d087b904046faa8b97ab30e0f492"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_151.glb": {
      "bytes": 266140,
      "sha256": "6c080be3bd34edcfac3777f0d21c463b9a39f51521ccba9cb83c7392b9623aea"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_152.glb": {
      "bytes": 82076,
      "sha256": "a1217d36027ea802e1a7e22b76e281863f6edc9d1788e25c0122758ffd8731a4"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_153.glb": {
      "bytes": 117900,
      "sha256": "0f33239d53323d6255196f72846773a466c9d5b147fdb0523f8ead532a59e82f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_154.glb": {
      "bytes": 139020,
      "sha256": "4a9d242ba44d00bfa96dfd1b41decfa62c81f2f0beff206e86dff1fbc0317bb5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_155.glb": {
      "bytes": 162500,
      "sha256": "d9ea0a9d9df513bfed0aafd5cb7af63928f543c3d70db24a1946a9b1e9089bf9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_156.glb": {
      "bytes": 100852,
      "sha256": "e82c557f0449b5942d74bf712b46f70389a5629a81aca5bf193e9f4128d295bb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_157.glb": {
      "bytes": 74044,
      "sha256": "08b75a3382124a76f34de6c819772851d033ca5edd480e8822e4d30d9dc5b9a9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_158.glb": {
      "bytes": 115032,
      "sha256": "5e834ba7d59ff929f14c17a530df8107a0b6373bfa2ce78cc76dd99b37aa60cd"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_159.glb": {
      "bytes": 192588,
      "sha256": "062f9e1ae4c9c5daac07c6793e1d324c071196d1c33235f4959cbe08760bd01b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_16.glb": {
      "bytes": 191968,
      "sha256": "8aa8980c6df0d2252707d4ce58123a977d043ab59c8d6821c91eb44c3a8084f5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_160.glb": {
      "bytes": 205960,
      "sha256": "b4377189f737780d9946c58e0e02d77dd4266a28adac005cff8cf1bc8e3ce235"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_17.glb": {
      "bytes": 201424,
      "sha256": "83635a6f75160fa00e8abc16a6ad3592505c7a081332f0d10e55e64ad6b50156"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_18.glb": {
      "bytes": 109052,
      "sha256": "5f34318a065ffaf2b50f2d8588df85a8865bd72c3d758289be1610f3a139a798"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_19.glb": {
      "bytes": 57632,
      "sha256": "2f22e1c4630bd6917dc8e50ee85cbe7e6dfebe6f86f825c2645a2dadf83a09a7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_2.glb": {
      "bytes": 216500,
      "sha256": "8e80f85c8ef103fe8dfb33c7c01ed9e5286365bbd98ba3a61374bc42dba09eb2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_20.glb": {
      "bytes": 145548,
      "sha256": "9b736a5cddd9024d6b34e7fb78f2f5f0bc3fccd5b1a29cdb15ef2921e254d79f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_21.glb": {
      "bytes": 204160,
      "sha256": "0c068f51b3caf1eb3451e90fddadde21844d883d604f69b62a97dd835466f58f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_22.glb": {
      "bytes": 158720,
      "sha256": "969648c550585de5cb512446452d007f99837d0dec339ae42ba7e832f5390f02"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_23.glb": {
      "bytes": 58888,
      "sha256": "18d24e0f5435de53978cb52d1265501b996796c4bbc8c3b7a3397019bdcb5cc3"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_24.glb": {
      "bytes": 204228,
      "sha256": "ede9ad1f395ab4f71e540268c2e6dd1bb5fb31e67151a20e9204360851bb765a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_25.glb": {
      "bytes": 165448,
      "sha256": "3a1ea96326e650a84554ee5bbef066c6ba14fbcc3a5548c0c6d0f5c518cacba1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_26.glb": {
      "bytes": 68632,
      "sha256": "51ab8c3c8c41cc5a7634c7635c150fbeb30d6929d0fc11930ef92669d864f7ec"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_27.glb": {
      "bytes": 169080,
      "sha256": "80219e054ed5bd1730e365908c6eeff1c4a53c54e786139e6f720ed4c7404faf"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_28.glb": {
      "bytes": 226260,
      "sha256": "1ff98eb8406eba09ca7369b1b9b985dd44ff2b3b2f8f9b15945c6a0146fce3b8"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_29.glb": {
      "bytes": 80872,
      "sha256": "95dcd1b99c2dcfcdb243f563b193b22663ba71bc37ee9005cfdaa873265741a0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_3.glb": {
      "bytes": 188184,
      "sha256": "ad4db2f01ceb6dee7de9d3212b6ce4a192516772b551b67850beb949a3b1ca43"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_30.glb": {
      "bytes": 30480,
      "sha256": "d87015a675d568ac587e1d88c6f90e36df85d37fbf6ca2648299b2adcfe0294d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_31.glb": {
      "bytes": 206880,
      "sha256": "ce190a033242aa84884d0128f93cd1b4aadda415f95227001664822e22dacac9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_32.glb": {
      "bytes": 35932,
      "sha256": "fd62b3bc74c284dc3be9e052a731b347fd9c40426f82424bc2f957b00d85c63d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_33.glb": {
      "bytes": 118608,
      "sha256": "bf47764cbc84e967cc283ed59d8e9bb892fe0282897d325f7eca8356962409dc"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_34.glb": {
      "bytes": 198192,
      "sha256": "524ec8b56b3ea811a8d1cf7e5aac2bfd04ace7aeb539afe70b77dfc47d2c4c25"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_35.glb": {
      "bytes": 175576,
      "sha256": "01a9506e393edf8657fc43d90fdd574cd8568885b4ba31244267419320b9ee55"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_36.glb": {
      "bytes": 148280,
      "sha256": "54185e0605a452c38e834141fc7a461083be6521171966722274d5bfd389077f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_37.glb": {
      "bytes": 182384,
      "sha256": "396cde8618867a3ddf73a0cd2fa1acdb01cac25f0bb091b0f926cd7064bf777e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_38.glb": {
      "bytes": 205304,
      "sha256": "31a1ac2d70dceac781e2e413fd55d01732007134c23c64cc318570fa72b62bb5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_39.glb": {
      "bytes": 261820,
      "sha256": "de7643f3e1bb348d76f7a00f7a059c5988206035d7970e13c552fd2136ea889e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_4.glb": {
      "bytes": 156836,
      "sha256": "734b6a8525745d7d6a577811fe9d56eabd86e537a99474fc50b50bb341e48f7e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_40.glb": {
      "bytes": 222020,
      "sha256": "e04bdab8479ec6e636c8e04a9b9e3cc469e84dc870707d09d0424f40ef602262"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_41.glb": {
      "bytes": 191480,
      "sha256": "ea0dee8e015b83a5c4cd895b805985698336ebdf1a8e71e56b0c961315eab7e2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_42.glb": {
      "bytes": 191832,
      "sha256": "81690a502ab2a4c277949800610398ca3bf22cfa9b78ac8265cb253bb08d3c32"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_43.glb": {
      "bytes": 151180,
      "sha256": "36b9d9b57b07fef6a23045e159283f0a96ffbefe48dc395d61bd748efd9fd50a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_44.glb": {
      "bytes": 134816,
      "sha256": "5e84735f77ea6e0b41738f59f067d41b3196dce68bf3ff630671a56f48bf5e5a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_45.glb": {
      "bytes": 153452,
      "sha256": "350fe9d2a8e0ab92edc9509de78e8d2de864da9c826e581b53be8e9c3fa43e81"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_46.glb": {
      "bytes": 120852,
      "sha256": "13e08671f17d195f229fdddcacf03bf63f5edb8414a9e9fedfa23ba9a5588539"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_47.glb": {
      "bytes": 182144,
      "sha256": "e3f8096c5548c74444d8b117846b1e6c6f34f0f022896f60aa116a1ddd1baf3e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_48.glb": {
      "bytes": 152352,
      "sha256": "cbb5f2c513b397f22c58a64d595430cb642edf6b9b92991e6071075178697105"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_49.glb": {
      "bytes": 169124,
      "sha256": "35e29b71d6abc62026901a410da6707c75449a10e8b160d54de28d357c0c44f0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_5.glb": {
      "bytes": 202964,
      "sha256": "aa07ab070f6c2e33d9a860190cd0e53d32c510942ed5b21671cbb27ea1f2c250"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_50.glb": {
      "bytes": 176472,
      "sha256": "63b923dc75c51cbd526b9039ddc9f4990258b32053983d521f05247b9f3c2dd9"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_51.glb": {
      "bytes": 181064,
      "sha256": "823247c798b6f49a3b01807c8bc1f34d94cefca9704a34693942b6e2fd048c63"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_52.glb": {
      "bytes": 180460,
      "sha256": "8122755f5cbf551a3a71802440304975413dccf1471ea8bea2947343e5b5ed1d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_53.glb": {
      "bytes": 163272,
      "sha256": "77398b953cadab6d8d9b64e8bc07e32451a22de6a115bded5f1e3ebcbd6d75a1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_54.glb": {
      "bytes": 153608,
      "sha256": "bb5ced09c473089a778581a76ed28a98c75ecbf5c69ae5e7a038ae3f2d5e4672"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_55.glb": {
      "bytes": 178732,
      "sha256": "498a1c55ebbc2176fa1496836dab1fba2dbe874f0fe21ee8d7c1955825bb1dc2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_56.glb": {
      "bytes": 194012,
      "sha256": "d78255e3a364827d342fd2676cadd3a3e033b86e2c4dfd0995a541584ea0f439"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_57.glb": {
      "bytes": 140752,
      "sha256": "bdb3332489c051a09a5dd48ddcba035027fa93c854b107f9f2f85c33d9f0a560"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_58.glb": {
      "bytes": 141068,
      "sha256": "a7a10597293b40101184f56922c031b9ff223019d3c16eef2690fddb0b983d1f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_59.glb": {
      "bytes": 63288,
      "sha256": "6f3c28962e5d9333290a6ea0c1851d9f747ada4b353347794302a1bdaff5d864"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_6.glb": {
      "bytes": 198668,
      "sha256": "07c92bae3c0e9b227c8d39e40b2c8cfa264de47df56a9170cdc13c90b081464e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_60.glb": {
      "bytes": 171592,
      "sha256": "6ce2079ac6061e7dacd03868d42c20d83d8032347ed996ddcd1b7c7e67175532"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_61.glb": {
      "bytes": 227612,
      "sha256": "8ed7ce2e6f322a5ccb9bd6b11ff7d7de6e7d6e2af6649d093ed6adeb44ab15ef"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_62.glb": {
      "bytes": 252660,
      "sha256": "c7c422b8bd951fc5260a1150ef50b22802eec39d47b2c986bc3b3f926a3bbe0c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_63.glb": {
      "bytes": 102108,
      "sha256": "bc160306a3c2417191b2e0a82d4de0c0669ef2dd594635a2ea997795ce26cd53"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_64.glb": {
      "bytes": 61832,
      "sha256": "005e64ab9260e761cf800660797daaeb6460084edbdcf74db1ae7d57cbed28e5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_65.glb": {
      "bytes": 250436,
      "sha256": "19703805abce58113df76fcc9339ff8283a68bf3296a2e447c0fe9d73046d8a0"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_66.glb": {
      "bytes": 264320,
      "sha256": "e2c7769b066be569b1cebbe0ef3ad9dc81aeab0a01260c335cbe5c06f37cf3b5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_67.glb": {
      "bytes": 104192,
      "sha256": "c139e0aadce5d2702161e8d805803471ba8538cbcd283e6a02a677e2f4ee3cfe"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_68.glb": {
      "bytes": 143680,
      "sha256": "32e3678789a368da97659a3ee07fade0905e1cc9bfef2c3b2d8c239253a5b569"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_69.glb": {
      "bytes": 193580,
      "sha256": "dc608fd11a2cf61fe4f575136285cc1baced4f2e2b74d025313e62ed38a2775b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_7.glb": {
      "bytes": 98536,
      "sha256": "f25eab2e6eb552f2351cebfad39c2ec19970fa8011f340634fafba0aef920e32"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_70.glb": {
      "bytes": 135652,
      "sha256": "a8d51503d970e27feaed27ed7045390891f4d2ccc8a260642bd159f8a67c89fb"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_71.glb": {
      "bytes": 175908,
      "sha256": "f79f62b0295279c7e83a4a1aeb3445bf78935a1e95fae18b442d0be76b60c19a"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_72.glb": {
      "bytes": 100680,
      "sha256": "06b01b70e2170cc466125e3630219d0ca25fbe590527092f43b6f55868187994"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_73.glb": {
      "bytes": 171140,
      "sha256": "ee8cf96d965673d648e48f313dfa14e95fea7f18ef5bdf5f5d4d6e19b0db7c26"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_74.glb": {
      "bytes": 144836,
      "sha256": "0818ef3af3fa0183bbe1e37e7bb1613c3fb8580e50d03e0d3f27db9a9689be7e"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_75.glb": {
      "bytes": 247668,
      "sha256": "e3cc47bf1584428d4451a9d7dc5db1d851fc86875e56c5f3b8784e108226d0f2"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_76.glb": {
      "bytes": 200432,
      "sha256": "ed852a5f2a6a82f56c00e4bb2daf973c62289fe7b0a33b1606d5d057002376e5"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_77.glb": {
      "bytes": 143828,
      "sha256": "a50942487220e9af5bf07e50fe84dde7c7d3b63beaa6b01e140d338a81181b19"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_78.glb": {
      "bytes": 164976,
      "sha256": "f0d87c00d3cfd7c54320862d75740489933a6f2689a24c51aee3e62c0f4bd0ac"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_79.glb": {
      "bytes": 172744,
      "sha256": "dc0fab78321633079dac8d1febac69ff17f8f7344147a6c0881091badc9dbbdd"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_8.glb": {
      "bytes": 44592,
      "sha256": "0a7f74a1956a994283338f66cfecdbf00e219e9fee47db23a99c8ced08584f06"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_80.glb": {
      "bytes": 201204,
      "sha256": "0bb63b8ad9d6793b5418b3f11536870ebec17638309ca3ccbd3ca2b01fb1664d"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_81.glb": {
      "bytes": 126616,
      "sha256": "4f95761f2ff119caedca3b6c5fc1471873635fc3874b744d1fa59f124f8d1b5b"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_82.glb": {
      "bytes": 182412,
      "sha256": "d3ac1227dbdb15cdfa921351dc8b79c9e764e08b69d12f562366cc6ee8f0d257"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_83.glb": {
      "bytes": 123764,
      "sha256": "c42d4d2930326a55f19b78aaf5588831e34b43231a38d71855e367e56478d513"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_84.glb": {
      "bytes": 172948,
      "sha256": "0f39a00c80adf63a0cd1aab4aa1b247a00582f6f27654392f9b356e5b497d5b7"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_85.glb": {
      "bytes": 173664,
      "sha256": "2b89a3355d42d491f3c5a2d7f74582904a73c8f0fb1d39fb2172a3ac1298d497"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_86.glb": {
      "bytes": 133060,
      "sha256": "a60c4aad38ec32e6754e7d076a8159134fa5a41bf1f82062f1c82bce4b9a3a51"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_87.glb": {
      "bytes": 196196,
      "sha256": "c06a96720a1e780ac18840a8d19df297bb4fa57148e3e97af8abe57f6bf2a347"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_88.glb": {
      "bytes": 199724,
      "sha256": "6c7aea14381a2833a77ca89c650a2eb2041ae84580a13abf4ed3ed011b3c8935"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_89.glb": {
      "bytes": 170636,
      "sha256": "c9a018128320b94ccbfa3b01ab4d51cc303d612ae7ad76ecd4b4f4a3010091b1"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_9.glb": {
      "bytes": 159704,
      "sha256": "f46fb45032d1d7c99cc6b0cff44f029fd2fc5094dfbbc0ab5065a3c3552d667f"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_90.glb": {
      "bytes": 228660,
      "sha256": "f449be7dd0a205a73ec5b638755e3636f772233d27b5ea6da9f6c674d871abe8"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_91.glb": {
      "bytes": 42716,
      "sha256": "7b3a3fef1f03713059e6f7675b11a18ea359bfec13a8f5c1e76f80fb28766221"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_92.glb": {
      "bytes": 193060,
      "sha256": "7e819edc9ae0cdc60daa609b05eb1db805d0be23cf7b318506479b0bc3efa507"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_93.glb": {
      "bytes": 146168,
      "sha256": "80229e1650d32343ab342a067d4e765cd3e82a63969360fc438c87f3f5e6a8d8"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_94.glb": {
      "bytes": 258932,
      "sha256": "55e6ce2b96a4db92e2a3520bdbeaf409ca0367a1c130731ca53736793c5ad6af"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_95.glb": {
      "bytes": 194708,
      "sha256": "06dd41a6a95dbfb89026150598d4c3e9da0b3f840dca47155ec0487b6e83e11c"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_96.glb": {
      "bytes": 151984,
      "sha256": "a76cd19d4da5381fd8028f630c8da0fa37b577f2ace1f09a893b185efc529c72"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_97.glb": {
      "bytes": 192956,
      "sha256": "ce981c71f96d54504044ea618f512860e3a14b6a800778f97ed6e4c7b89c8766"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_98.glb": {
      "bytes": 135920,
      "sha256": "35e7199399fc66cf4f5bafa650b982ef8d15be864ca24fa71ed212b1efa2ddc3"
    },
    "office-poisson-las/3dtiles/Block_00000/Block_00000_Level23_99.glb": {
      "bytes": 83176,
      "sha256": "2b01f5e39cff02add4a42ce5bb993d56c7ad54ae2396fd997b7784f91fe8a54c"
    },
    "office-poisson-las/3dtiles/Block_00000/tileset.json": {
      "bytes": 364480,
      "sha256": "cffed63fc85342ac09d08929a477ae9f6fe60948592d08ca252e6f039bf186fb"
    },
    "office-poisson-las/3dtiles/coordinate_contract.json": {
      "bytes": 789,
      "sha256": "50166dbd57faad7c5a0665e14c4d84b4920ccd60011581366adeb680a0df9007"
    },
    "office-poisson-las/3dtiles/tileset.json": {
      "bytes": 1284,
      "sha256": "3c20ac56606a47b79d8f6563e5faa4f3675a7a9fe31303c0d3942b97043e1183"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level18_1.glb": {
      "bytes": 235976,
      "sha256": "563d45975e7d66617c0ea8bfc709a02881b6de7af170ae7acaaa52d2d8aa4f12"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level19_1.glb": {
      "bytes": 132220,
      "sha256": "ca5b2a4118e1c2d80d0fc714034a3146fffd9713c845b64c05f18673f7b51e1b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level19_2.glb": {
      "bytes": 233768,
      "sha256": "57cdb599c51d54325dbca1b97852e6a7c2298289fa5ff4b41f8bed1a53b54629"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level20_1.glb": {
      "bytes": 58128,
      "sha256": "ca8f67c15b0b301ca1297d00440761d3552f2db5f4f9cb34c0d77adef0fc8162"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level20_2.glb": {
      "bytes": 34788,
      "sha256": "3af55502fd2b4c3ab7a14b063e5574363a20069f649b50833d40899bf8465ba4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level20_3.glb": {
      "bytes": 222524,
      "sha256": "920ef8460366ed1598ae1265a11d92b20837c4403736a6e121884fe317ab7b4e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level20_4.glb": {
      "bytes": 59556,
      "sha256": "bd0707dc30bfa7ea6f9373148d2e72b9ee5ba7ebf91eb50a2ff7e5bd0e738eb0"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level21_1.glb": {
      "bytes": 69408,
      "sha256": "7de3bba669476088815edb426f530a6197adb008705541d8822c637255bf338a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level21_2.glb": {
      "bytes": 41140,
      "sha256": "bb0b892af900059b57d011ff0cb0aa248ff76f93cc3340add1b44e1e052cd1e2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level21_3.glb": {
      "bytes": 73188,
      "sha256": "b9a74484e1c1f6b181ed2bf417be994faadcd3b5b2f2ecbeb2152c944f9c7026"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_1.glb": {
      "bytes": 80568,
      "sha256": "48602b653585e73e82f6aa8e6eec92e2793c363e3b64c47cad0a927c09beb218"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_2.glb": {
      "bytes": 51804,
      "sha256": "e9c816d184eb63bd830cc1783983ec1186e02fb1251007433cdd0639d0f3b64c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_3.glb": {
      "bytes": 105900,
      "sha256": "4637b907c289ec180a755729a7c7ac8488427f325cdb7eef8a35ae573973fa80"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_4.glb": {
      "bytes": 19180,
      "sha256": "8f2c005952a7d04207bb553aaa8205f8e69b482e9b60d7f9e03f4c6e23143eb9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_5.glb": {
      "bytes": 134652,
      "sha256": "adc92748e865241a9aba7e3ece2149dc04b07c0c946bb7d69272a011cdc08e36"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_6.glb": {
      "bytes": 19328,
      "sha256": "ff63f4eef4a05db86f297911155fbc945f7a1245db86defc61747abcfadc771a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_7.glb": {
      "bytes": 214668,
      "sha256": "f464dc43ad622a0fcbd6eb9c66e6966a7e03d214613e8e2ccc91c79ce428b95b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level22_8.glb": {
      "bytes": 289844,
      "sha256": "0a76ca17dca0e02d16b008f83cec3e0cb4ad03dbb98cf12fbef884a4f4416d03"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_1.glb": {
      "bytes": 101072,
      "sha256": "7a5ca4bae5b0396dae4afe40f729e5836a4ffc12e0bdb445928d7f1f05d9d5ab"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_10.glb": {
      "bytes": 50048,
      "sha256": "17c59dd9b2887879496f90f6192ecbe11b20d1bade02acd2adfb7540a0781f60"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_11.glb": {
      "bytes": 100984,
      "sha256": "20559076e2ce2232220f7310a49432f21ff7662a097b01bbdf9bde7f771e2c0c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_12.glb": {
      "bytes": 216896,
      "sha256": "3f481820baa86c4d08e6c7074bbb47366ff84d93950bd25b37086a18fcffd650"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_13.glb": {
      "bytes": 72252,
      "sha256": "46a3a91307adb033f74be514348d4ead71abd7c1f593a55d86eddcb2f57723fb"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_14.glb": {
      "bytes": 286188,
      "sha256": "8239613475e2a44fa6feb5bed2f565235df39e61c9a5910c37f5aab9cc3a17d0"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_15.glb": {
      "bytes": 84316,
      "sha256": "ebe11b14c04985820b8f6482648c9941e550fa207e65395c3e3557c57744004d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_16.glb": {
      "bytes": 218704,
      "sha256": "8b97e47966a7e18ed421dedfbe8fce090dda12ed6da22cc200aacec8f9b2063c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_17.glb": {
      "bytes": 210904,
      "sha256": "e6dbfa2f5b14c264e9007f16f0cefc51747aed8deef15eed45e8cf34ea77974a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_18.glb": {
      "bytes": 137060,
      "sha256": "37cd502405d26d5202186048f5d30ab68fffc6b20e39bf1b06f0b7d554bff828"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_19.glb": {
      "bytes": 176544,
      "sha256": "004369ca2e16175fcdc918391bcdc0eb0e11d4ba7a9de017baf563417d6d3cb8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_2.glb": {
      "bytes": 72828,
      "sha256": "ebbdba7aeb66d8abfda4fafed19203ed48657df81a82e2eb1b1ab6a7256fd177"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_20.glb": {
      "bytes": 160720,
      "sha256": "799baf62022fac1b94a0668ba797b258b759e683e5b1debb8e33310c49d6f2af"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_21.glb": {
      "bytes": 214916,
      "sha256": "e26057faf584ccbd191dd1e0ebad0253db8121464a24f7681cc337b6444cd3b2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_22.glb": {
      "bytes": 237252,
      "sha256": "aaccb1355b9c5ed65f2d314c6c7e85e37e965e14ba5550b48768fe797fe3c8ce"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_3.glb": {
      "bytes": 55888,
      "sha256": "15b7a41db2485d9245b69f7345eeac0510f90918c1c122ae376d1a09214baa28"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_4.glb": {
      "bytes": 93580,
      "sha256": "7ebac6d7b7417673f074f4c8de2b9e56d4837d871c2dca00b2bce66ba6480559"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_5.glb": {
      "bytes": 149680,
      "sha256": "120d98e7e5ea0828a8221de7a135d42c79988f08b9d92e676014c7d19cdb7c2f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_6.glb": {
      "bytes": 164640,
      "sha256": "f259d888cd9b732ed9bfe1dd16cc733b1dfc732272713c1cc7804bfdcf0edead"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_7.glb": {
      "bytes": 29592,
      "sha256": "e8f4fcd6707faa073b52e111cd6b66fc7bf381220063105c3e84c5ce6add09a7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_8.glb": {
      "bytes": 320584,
      "sha256": "2a1d28d78d5d5d36c7689e0320417880b6940eb4039fc6a2e05b6a21d628ae43"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level23_9.glb": {
      "bytes": 175468,
      "sha256": "3a78edd99a7e9d260f755acc5ca536349fc6beed21a533a65bfd365c3a4a20c1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_1.glb": {
      "bytes": 233776,
      "sha256": "f04264554ac00220a71ce056b37f2227f7e41fbf5901dc744d69ef5921632e41"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_10.glb": {
      "bytes": 53348,
      "sha256": "cf52e499e89075c723221cb4977ee4ad9f02210c036c26030fea85b3b4503dc6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_11.glb": {
      "bytes": 65180,
      "sha256": "1a83158f5e96527a48146c2cf37c53dfa85d9043d4ab84a255a56c6615016526"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_12.glb": {
      "bytes": 210412,
      "sha256": "473a99ff05a21763a79d710eff94bbe7e9bcf07c0ef47ee769f94fffa2a4b51d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_13.glb": {
      "bytes": 291788,
      "sha256": "2cd8e45e4a48952ddf66ef45dc2258320cd782fa603557cf44a5c66240560561"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_14.glb": {
      "bytes": 241380,
      "sha256": "80f43e22da0788cba21de78118244cd790d23cf284387b2d8500d429e5b102d7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_15.glb": {
      "bytes": 84648,
      "sha256": "802cd1f04e08b8abce46445f4185dfc906df46d11cc0b4b84f6f26ca1ed52b27"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_16.glb": {
      "bytes": 162256,
      "sha256": "24fe86659ab4911fb83d08f7194b3f1d1d3943430bac80813b1d9edbab693f21"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_17.glb": {
      "bytes": 251276,
      "sha256": "92089aa1e83738dcaf2b4bb465ab526ba1811ec864560db41811a771a3693301"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_18.glb": {
      "bytes": 136412,
      "sha256": "a4c670a4870d9c7b62650cd0d9dd0c1d92216b572d16e4e15dead9cc4f5a3873"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_19.glb": {
      "bytes": 125852,
      "sha256": "e545ae8178fdca6b30a299da94a85dc0faba841c737ff278a52d6d0b03e718c0"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_2.glb": {
      "bytes": 186100,
      "sha256": "6537d6098e4e4fea435476fb7456c2749c172511b505276e2a9fc0d3952e7a03"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_20.glb": {
      "bytes": 264260,
      "sha256": "f9732875193bc9dd12f1e9976bbd8202e69011231fca4497f2cbc9cc91598187"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_21.glb": {
      "bytes": 262740,
      "sha256": "d1056cbdf154abccac354cd4cc5ad79994e89aad7caad07b52908110e5027f81"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_22.glb": {
      "bytes": 151424,
      "sha256": "d0a464be62aacd237ac88924570b650d360851cbf5b93875f2672e98a0a9277d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_23.glb": {
      "bytes": 205432,
      "sha256": "812ab21b73aa6d8d2bf66c8e3e2b58cb443bccece42d0a27a72f7430c032cbd5"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_24.glb": {
      "bytes": 191540,
      "sha256": "0ccbb503adbee2b49a74c7d43a83f7a32011ed8a31dd7cfdfbe1c089b80c5ac8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_25.glb": {
      "bytes": 262980,
      "sha256": "a197543c9a5b115d3a408d8aa0702b9494c4177ef09ff32fc93e946903cbbfa7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_26.glb": {
      "bytes": 203684,
      "sha256": "5af3bdec1417e85cc52bdc71c7d8e560d66bd4b713684c119078a181cc58f247"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_27.glb": {
      "bytes": 124660,
      "sha256": "20e4f27e6833fb88220b2f1942dd097541e5c4c9f413073ada5849fe293e1e03"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_28.glb": {
      "bytes": 287136,
      "sha256": "e24ef7a386d5435d397dc3c2f033ad890a72a320a0ce681583e983131cd40883"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_29.glb": {
      "bytes": 194524,
      "sha256": "e2c98819bf3b35656a446621fe340d2689490cabbfdc4825b7fe30d66a4fe3a2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_3.glb": {
      "bytes": 35532,
      "sha256": "030bef8a3ddcee8b32c72eb760cb30a13652a73332b2d193c2813f9b7a376f5d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_30.glb": {
      "bytes": 160384,
      "sha256": "9983d7dd9cd1994fd95199b2dff822fa898f9fdf92a9867f13b3ced2af86ced4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_31.glb": {
      "bytes": 208576,
      "sha256": "6befd0084a886820b78e7e7652ace2caae806f629d22213e43dddddcdbad746f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_32.glb": {
      "bytes": 257092,
      "sha256": "a38ee2125da6a74942d537ec30648e5020ef1624671787dad2db389bff163fa2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_33.glb": {
      "bytes": 255400,
      "sha256": "1faecc4fcf52ae4cd4487311c7dce7cd4fdd646f5efb83c5d0b70906e179c8d7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_4.glb": {
      "bytes": 151192,
      "sha256": "058d8a7f302aa29f2234f93867f78209af58bbf8c6b2f0b0410143c7d75e7a5b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_5.glb": {
      "bytes": 155856,
      "sha256": "17e2a847a3d43dc2cdd7674a1625a65fecec4caca66b3362ac34f8cb36194748"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_6.glb": {
      "bytes": 237124,
      "sha256": "50fa56341b2f2d3958c36a225ee1e626eb241618499f05263be7233f4e43cc22"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_7.glb": {
      "bytes": 250220,
      "sha256": "58c669687aab11f618079490fdc7e391ebe3fdad8ef7efeb34cff6f95930fa46"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_8.glb": {
      "bytes": 208968,
      "sha256": "1bae8fa918c7c79185c4d8b84afe853042acae9c65c08fdc8860571d85e309f1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level24_9.glb": {
      "bytes": 86160,
      "sha256": "d57a1ad85176520e23e7dcf7e0b42c890a67e3e9af5436b36683a376a4fe096b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_1.glb": {
      "bytes": 44768,
      "sha256": "50a2616052b94277949ffa873f4ea74691552f365626d9fd11a0f1212442b114"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_10.glb": {
      "bytes": 115676,
      "sha256": "baf4ee507f4f01abf3ba4b227b7ce0cd81d0e38eb94eeedfcf80926aab91fe43"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_11.glb": {
      "bytes": 225220,
      "sha256": "71a98e57108d75af0229ad5c5e34824565ebdc8d0e026f3c2b8279b7255fa76d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_12.glb": {
      "bytes": 189852,
      "sha256": "b0ac581f8b64bbb4c503fa5df9c865ee86448a6db09111e12aa5a68dd2546ef6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_13.glb": {
      "bytes": 153672,
      "sha256": "fa62e79e7da78ccf34ea5c7bbaa3f7255b5c1d19e93b996a38ab11b06940f7e2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_14.glb": {
      "bytes": 127008,
      "sha256": "8333aef94a180f945692bbdc7e348a6ca7f8b23ca11fcc46394a5fcc0db3fb35"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_15.glb": {
      "bytes": 232044,
      "sha256": "6c9f82eff7fd43e26e86985062590b8266093a3329ae835ad7f4ff84580984c8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_16.glb": {
      "bytes": 80004,
      "sha256": "bd5056199c787d477e3216ba23a3ec25c03aa60577f1177b66784933e7c0f7ab"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_17.glb": {
      "bytes": 86128,
      "sha256": "b17b658bbf03208e1b23ff07f554513afc08ad9b7bcacbe49cd9b468a66a7dae"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_18.glb": {
      "bytes": 181956,
      "sha256": "f1e7dd1e846d263c058e6581ef1dee5659c50498351e97579016e6324cea48b7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_19.glb": {
      "bytes": 77856,
      "sha256": "e7ed2461961101f95fbe0793b9da406f7c0183e795cf60f244f299fac57234b0"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_2.glb": {
      "bytes": 103604,
      "sha256": "9c1a541da9065e6e2f40dca89ace17c4e16c79d937ed3bd199f14ff1276dae93"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_20.glb": {
      "bytes": 77896,
      "sha256": "e46a591685c4b89339ac3e7d730cedd70fadb2ded6f0e38bed7a2fdd1bd25c99"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_21.glb": {
      "bytes": 158560,
      "sha256": "78fe3e20f5a8a3fc7c63915b40a5f2c6ce07d20cf048dee50732f1526af72592"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_22.glb": {
      "bytes": 249780,
      "sha256": "bd79c1dbd766e230bd5e5c13a086b97b791d6083c8de1d525e8a1aa1b341e7ce"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_23.glb": {
      "bytes": 315608,
      "sha256": "b13679e18e3d22c31be0523c907fb5dea0afff9dbf1ba506c0d1154b15f8a679"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_24.glb": {
      "bytes": 174928,
      "sha256": "eff0c331eb5b3fee3d7efcce19c6b707da318596eac5f05f37141342f7de331e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_25.glb": {
      "bytes": 45468,
      "sha256": "71695f621b74658828db02f422cef71bf63f2a40d8d9e12276a5bd77ad0296dc"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_26.glb": {
      "bytes": 96636,
      "sha256": "9b133796026d0cacc9ddd7a70764878b1189c8e90c938269f4275b2cbc558950"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_27.glb": {
      "bytes": 95332,
      "sha256": "050c59640d31388d21fc44da4510d116a3a7a509328c280782947c57bf351500"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_28.glb": {
      "bytes": 71968,
      "sha256": "4063119b28e2e9209493ff92b9763adf9e139a6161376e7fb254f91436c628f5"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_29.glb": {
      "bytes": 268844,
      "sha256": "f3611069225fb4064ab8d4d82a9acecee3e9946fdd667e33478d764179ff0ddb"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_3.glb": {
      "bytes": 190512,
      "sha256": "feb30cd636c785ef207a769dadc79f8f27a3b6492921e52590a043cb48aaadac"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_30.glb": {
      "bytes": 163780,
      "sha256": "30d15c4b69493080eb872ab372a0a23f6d3f44c59f2771c4cf7741e817ffbf4e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_31.glb": {
      "bytes": 226316,
      "sha256": "1dc8d288d42b7920cb90e920277bf7a390f7020cdc72910b70fd0584013d6196"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_32.glb": {
      "bytes": 89928,
      "sha256": "382443650162b9514f329638d1f53ba029c9558b68ad944d8a9ca53ce017a40f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_33.glb": {
      "bytes": 228556,
      "sha256": "576b6e7f65eb5f81437e755d352faca72c5e8e1173ba2a6d793bb9a6eec2cb40"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_34.glb": {
      "bytes": 214040,
      "sha256": "11eb10f848b0d78c10f90bd0529e1477b3127a147de8f0ba237f852e9ae1708f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_35.glb": {
      "bytes": 285468,
      "sha256": "f25c19adf1b0a9fa57d6fa397e47e79713f07d321b8505d5e56994c9b9b1ad11"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_36.glb": {
      "bytes": 166988,
      "sha256": "4d1374872aae147a18d268216dca79bd884c68ae3fac25e4dc88c2ad59d0e0b5"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_37.glb": {
      "bytes": 348636,
      "sha256": "da2763e9168132ff07bef012a31fb7a34ba98966337fc3ebc877f6831f5110c8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_38.glb": {
      "bytes": 281340,
      "sha256": "ef77d090f624aa514addced0565ebe0356609417f0e986fb30d10d52f64c3a8d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_39.glb": {
      "bytes": 301948,
      "sha256": "091dce84cac6d66620209107d944bbba22df30ea191f3b4a18ad168f3c1e6cdf"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_4.glb": {
      "bytes": 168340,
      "sha256": "c9c1a48fd3efeed332c27543e81129e0491a87b1ab7ef914ab2c20efa1af6b91"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_40.glb": {
      "bytes": 232328,
      "sha256": "457ee33094abd4d109c2c8158229ac74eb39328718c3c7ed4c7b6f57374ae38e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_41.glb": {
      "bytes": 210424,
      "sha256": "49538ea95a28b26a29f088d45d24ae268c90052e9cada7ce7ef6fc9a2b0cc2b9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_42.glb": {
      "bytes": 281180,
      "sha256": "4cded15d1a17bfb64ee9e56718c835640487be52aba7b5aff20e8dd2656c2ff7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_43.glb": {
      "bytes": 50264,
      "sha256": "f041484db347151530a1eab9a213c94bea298bd8159ecd47d3abbc59c401eaf8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_44.glb": {
      "bytes": 288912,
      "sha256": "20ca4ce902d61c01c934aa8e2c499f3838bf4f4e6e31e6d2ff83412c5d227089"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_45.glb": {
      "bytes": 286980,
      "sha256": "a536a258701026db2a6abe366489e21aee265bee2943edef702ffea134a2125f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_46.glb": {
      "bytes": 262292,
      "sha256": "6a3b323c51c800f16614238c0b18390132c3b0e88494da53d99d660f08035429"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_47.glb": {
      "bytes": 75108,
      "sha256": "9bc2bd63d7b1a33e90648c193dff797cfdd2b853951e225c1e76cdd152119f86"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_48.glb": {
      "bytes": 296940,
      "sha256": "1b0136b348588e69d030b25d73efd9037f07d5e8c2c83ca84c91f322ce8ed817"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_49.glb": {
      "bytes": 31432,
      "sha256": "1539eadbcb5bb3c06150be75dafeab8078946d637144051cd2babd42a48e31ce"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_5.glb": {
      "bytes": 48120,
      "sha256": "750f213cc77091eba2efa45ef8c9d300751cd792b105b770b1e478d7f66e6401"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_50.glb": {
      "bytes": 98588,
      "sha256": "5cd6ec349691316f8727cba5bd8b6244f39fa7f7521887afc13491244699a295"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_51.glb": {
      "bytes": 235188,
      "sha256": "fb8161a7e3629690e59da5ed1e58cbff0f4df2cdb510dec5c035044e0778a05c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_52.glb": {
      "bytes": 295604,
      "sha256": "b3299140ae444766a49f404ddfb5823a180f62c561d1a0e2e3785f15e6b24f09"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_53.glb": {
      "bytes": 223012,
      "sha256": "d483daf6ab314e1f0731cfa1b8f8e616737e27260b386fd0dfc218ddf956a004"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_54.glb": {
      "bytes": 322404,
      "sha256": "650d226455c7b9f176094673bfacd6e8b15774495cbbf9de75b22af4de792a8a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_55.glb": {
      "bytes": 236028,
      "sha256": "232d97ae28ea9d03ee54c237ed4eebb4aed83c8efc4613ebe60d4980dfcb9080"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_56.glb": {
      "bytes": 185484,
      "sha256": "9d64725b2fcbf6833d5e43d40702359ab6a42f32b05f4cae0d4c313794c3cb9e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_57.glb": {
      "bytes": 365776,
      "sha256": "d3b64e7b8e1bbe23559a88b565a5dfc8f529a5a8d6cf6d286c9c03906659b9e9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_58.glb": {
      "bytes": 217584,
      "sha256": "2a71f0844f17c8f3acddc88766081d71ef94b66e6792d3436d6f0f2b7e60b095"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_59.glb": {
      "bytes": 208268,
      "sha256": "1d195d23ec812323579cf85af0eb6e4fa9e2b899044474b317a00cbfaf07d20c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_6.glb": {
      "bytes": 180228,
      "sha256": "f5f18079bd8bc9e36b6d2f7c9e3c371ce0ae1b5c9ae626d39f06c5cc36eb00dc"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_60.glb": {
      "bytes": 304440,
      "sha256": "94ca62a67222d421bd2d82342f570142e961f2c369f35fde715484bb58ce4d11"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_61.glb": {
      "bytes": 192860,
      "sha256": "9a480033e98beed7ada32bb6b49c706a7fb6ba8249f4dae8c0bab3de797b0619"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_62.glb": {
      "bytes": 178340,
      "sha256": "bac266cb8af0e09a67b58e836c1e899ec4b00b3c58cd24c5f690a6b2b5534535"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_63.glb": {
      "bytes": 137596,
      "sha256": "e8b46506fd526368f56ea1d3727854b4ef62b7cbfb903bf5aa796b9cfcfe375c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_64.glb": {
      "bytes": 201392,
      "sha256": "f8095dbd4fc0de1dd7467007324a81891af62f5ec0c0dfbe7185ba4016c11eb4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_65.glb": {
      "bytes": 192492,
      "sha256": "e578d70cda43a4c5b9b992fa965ec044c4c05c181b1e1897dcf0cba9d6db7a73"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_66.glb": {
      "bytes": 88352,
      "sha256": "604a41c83f12a4fa2335a0b483429cd6f8ee24cfd7c1491c548c748379e40d1b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_67.glb": {
      "bytes": 127444,
      "sha256": "316aa787807ada0469fa01ac4491603c1181054e03cb2d6a3120eb5ab85d030e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_68.glb": {
      "bytes": 147060,
      "sha256": "224d6093048a623b1d767578812b2a451dd1ed7a8c6ac6e980c8d13656de0f65"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_69.glb": {
      "bytes": 134936,
      "sha256": "a9a589b4d3b6a95749dac5b5fcc9d88358b8b3fc73a63c89baba506c37e680b8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_7.glb": {
      "bytes": 169804,
      "sha256": "690ea7d634e6f6db1ad3107b89283e26fc69850f4b8a9be003e3fac315ceb8a3"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_70.glb": {
      "bytes": 234040,
      "sha256": "02f4ee64d4977d29cf21d13bed1b04a76a7862499c7016f7e2d1629e03adcbe4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_71.glb": {
      "bytes": 199032,
      "sha256": "4511ccd68b15c4e39d36d0b3dead2cb4fb44b41ff03eaee28cdaaa33926462aa"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_72.glb": {
      "bytes": 145128,
      "sha256": "1d41d37da6db4d3eb1db3f2fe8ae53c8d2cdf44f26ae3b26b5abc7b24e8402fe"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_73.glb": {
      "bytes": 247768,
      "sha256": "5fdadb97a75b8d94cc3e329f599037a834bee5d142754ebfbaee273c358335cc"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_8.glb": {
      "bytes": 76968,
      "sha256": "0f7ac9aca0a778a1fd81fc776391c26be97b327d2d0bb09e29567f02a1e9a086"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level25_9.glb": {
      "bytes": 155612,
      "sha256": "26376095509f5d9eaad62743eed9fd05cdd4ca368615c9759a1571fc1bd98938"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_1.glb": {
      "bytes": 87976,
      "sha256": "826e08f32849ec8615e38afa63cdcfb615f35fb43efac348633bc6f96dc26e86"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_10.glb": {
      "bytes": 173748,
      "sha256": "60e8138c618e7e968d0a58c27cab678795360b7b696370141493b049d37bd244"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_11.glb": {
      "bytes": 193652,
      "sha256": "404c649ca8e9b6a4d627d24929ec0c2e944f1a8078ed4e79146ed03cb93d9f2d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_12.glb": {
      "bytes": 97596,
      "sha256": "720ff7b548b7ff8a2afe653dac540435a89367abfda9240e8d11d37dc0f470b3"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_13.glb": {
      "bytes": 109528,
      "sha256": "e1ea3a7dfbbe370bba53b2cc11b868b05f0e9e7867cd6a19f99853703f8ad4de"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_14.glb": {
      "bytes": 191964,
      "sha256": "828aed85552a2410136d45f33570ba7086d7f5cc30e377bcad627ce217195a9c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_15.glb": {
      "bytes": 115580,
      "sha256": "4160566f2f38ed0f0c1fc3f6e8727aa541f9b109d8a3a798dff9f2f2f9b90a22"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_16.glb": {
      "bytes": 266760,
      "sha256": "442d7bc4b067bc17e9eaaf8e97144f783da842e9db9bfa868457dfa1601c1e63"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_17.glb": {
      "bytes": 144172,
      "sha256": "c159e5b55abf7fa37ce1e13a69bd57ae59a394b6ed7172ee6edbdadff2fcd4ca"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_18.glb": {
      "bytes": 180152,
      "sha256": "70810ee52a049f90761a086ccb04ecdac35c7bdb871a22a59513bdf87194b696"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_19.glb": {
      "bytes": 213996,
      "sha256": "769a51adf0ff88c6313f72c7dc3c748a507dc0bf313c8014d5d4d3fbe639373e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_2.glb": {
      "bytes": 256556,
      "sha256": "68580674fa1b7e0ebe9c87a23f4b899e65e324e535396fc06804a2bc972e7b4e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_20.glb": {
      "bytes": 267384,
      "sha256": "7c4037d6db3b26527786161f0766244fdfb4beebfe0cdcf52ae4698bdfe903a9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_21.glb": {
      "bytes": 117364,
      "sha256": "53a0be5089567396481a33b63fc535eb749789ebc3e6bd2e3ac8e51f89d925dd"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_22.glb": {
      "bytes": 328316,
      "sha256": "faa407c0aa7579b31723c0192a3cb7b05aa2936bb2282d3face06c8aaffda3ee"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_23.glb": {
      "bytes": 76036,
      "sha256": "6d0e0e46f5d97bf14feb210c2bd119efd0a7f5d97b6d2f4d364a439c08d7b3bd"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_24.glb": {
      "bytes": 338372,
      "sha256": "84b7e701f3ac8c655a7194db9db0bfae234eae4d7e589acbf16b594902a618f6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_25.glb": {
      "bytes": 128008,
      "sha256": "c5c83151e5f21bd2685d53ecb5ff5bbe5215de96a4e096d99b31347f87aeaf3d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_26.glb": {
      "bytes": 133624,
      "sha256": "e7f8f30943ac43af581ead2cce14768bb55cf64334135b90b5bc9c440146e202"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_27.glb": {
      "bytes": 96088,
      "sha256": "4c4ec6093c9e9dde0d15935b99b8c57e7c7fa60f4b2d755c05be17d78557a312"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_28.glb": {
      "bytes": 92096,
      "sha256": "89d7d611827a8275cf1a1765d65c6f4abc3b43b80a37960b19539a6742d31125"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_29.glb": {
      "bytes": 107808,
      "sha256": "82ed9df68e6814ab260f1a520350a907c5507c1025124f61987af1b2db8fe044"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_3.glb": {
      "bytes": 201692,
      "sha256": "a87515e93a19b2224fbbce8c148e0783e57e4d751e810041a85af25114e70781"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_30.glb": {
      "bytes": 139968,
      "sha256": "9f3f366646fd8371d8cdf6472bbf3333d4d1044e40a225a1b9a0cafc2f3e85bb"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_31.glb": {
      "bytes": 48628,
      "sha256": "432ef92f72684ded41d7792f4be50409eda1bda98557ddc7ed4dfa80442dd2e9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_32.glb": {
      "bytes": 35008,
      "sha256": "e15fe5353b07e2f4c0a5f9784eff6e46d3ac372a8288139f83255b3d9bf68474"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_33.glb": {
      "bytes": 165912,
      "sha256": "5200b97f8e637337383ca25d47537e4ee465e6d44eb2681c53d44eea4ddc3caa"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_34.glb": {
      "bytes": 208536,
      "sha256": "c6f2e587ad6769be956889138aad3c0a5d2a199606d8c7df0437069d395babff"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_35.glb": {
      "bytes": 227532,
      "sha256": "bd0646cfa557448f6a38587ab82843a35de8374c8e684b8c05f04505dd05fda6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_36.glb": {
      "bytes": 234148,
      "sha256": "8b9f3bdce343df41df9e8c86db27ebaba940a8561dd7ded30e1d8854c4dc06f6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_37.glb": {
      "bytes": 288324,
      "sha256": "da1e759615aae012f48e425319460f53e758a3782f54582256bd55ea998f538b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_38.glb": {
      "bytes": 216480,
      "sha256": "d773c864e43c9ef66469890286f02ea84c580762312a3498e809a199c7c4ee57"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_39.glb": {
      "bytes": 271528,
      "sha256": "a970e772c7b6679a347bb2d7e64f391a0071b5356b120dbfd6ab0735f959b9cf"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_4.glb": {
      "bytes": 155140,
      "sha256": "6ceac8c34eb0c0080a20be4fcf58eeb053c8d67cd902f760724e1bd90e08a446"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_40.glb": {
      "bytes": 183916,
      "sha256": "fc10c390a5d73672e35125ed53422d11a6217431325fb2fe41c576aab29e832c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_41.glb": {
      "bytes": 146008,
      "sha256": "381fe5e601d382b8ae9f0eb5dfa3c85f87bdcf3b93c5eb3623c1a013d681c29a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_42.glb": {
      "bytes": 266448,
      "sha256": "5239faca153b768305341bb04dd1b2515fc6778949701327d401239a67f4a50d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_43.glb": {
      "bytes": 206032,
      "sha256": "9517948b43b4cff1b3174bcece105fdd7c83652b8801e72bd2f7e47878c2ecc4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_44.glb": {
      "bytes": 78268,
      "sha256": "1485f3942c7bb07d1c3227ecaceb802fd3160582bb8fe8682102d8bc6c568d20"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_45.glb": {
      "bytes": 159376,
      "sha256": "71ff9ce6c470191e815df380cb9c323f5eb39cb638052ffc13c989b798f892d2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_46.glb": {
      "bytes": 265232,
      "sha256": "3dc338c2d61e206a13d5f8711cd82deee647b6ab432daf38073a9af4aae8feb2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_47.glb": {
      "bytes": 225964,
      "sha256": "76fa60385066c2c8d977c7dc8dcae48d9eab69edba9bce37eefc7ececf03f16b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_48.glb": {
      "bytes": 166152,
      "sha256": "3d82a09eefec8ad7985f908652914da6fda60948cab884b9ecdba1b513571c0d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_49.glb": {
      "bytes": 170772,
      "sha256": "f7f23afb966d4b49f9d4d838e8d193b1d5f36c467c3885806b764cc9e7a1e4de"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_5.glb": {
      "bytes": 269920,
      "sha256": "9ad98dbb7535dca3cef7b2911c6d0a00b4c58c4f031f5eff14c3b340aa4d8e54"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_50.glb": {
      "bytes": 241804,
      "sha256": "ce25bcc6e7e10070ec297b282080522b4eb2bf0a421605caa8908e3af9a9a815"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_51.glb": {
      "bytes": 105460,
      "sha256": "8b3bf346f0bd02060858c03ce10d15bc2a29d4105fe36e52653781e0a12a54f6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_52.glb": {
      "bytes": 120044,
      "sha256": "aa4e161f516df3ccb974453d494ea5a47b75d710b7cb27643322ba2b34194bc2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_53.glb": {
      "bytes": 165576,
      "sha256": "2a51fa2c5f934c5e70e832d9ddb0c738bd688b6fb10907d6afdaaeeb20b0528c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_54.glb": {
      "bytes": 68136,
      "sha256": "a9451563733dab72dc13f4e37ab778c4ec5676afe3f1fa9128e3d89c9807b5a0"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_55.glb": {
      "bytes": 266944,
      "sha256": "3d420505ba70debcdc34970909be8e6c46202a18de45ae4c457be9055c1304ce"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_56.glb": {
      "bytes": 232120,
      "sha256": "5395a5cb226841c01ee486d66441060226b996aa4d462813cfbc9300b516de8c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_57.glb": {
      "bytes": 98272,
      "sha256": "e927dc93f8d0487862b70435eed430d9e386ca926f07e81ce179c93c11e33d52"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_58.glb": {
      "bytes": 261964,
      "sha256": "c272a709f175e54ba61ba10852ab7307022dd1b22501a98b4140b9ecda79ab00"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_59.glb": {
      "bytes": 303532,
      "sha256": "2c5a9c4caa78da68f00e9cfdabf7a2bd529b50f560b747bdce82fff5c9e832e2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_6.glb": {
      "bytes": 240544,
      "sha256": "b545037ddf600606a8e1f036f101c43f32fc2790a9e88a4dc4353cc082334746"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_60.glb": {
      "bytes": 130896,
      "sha256": "21aa7c461f9b91119be62564955a2c187385e880953526d096687eb1e6d4273a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_61.glb": {
      "bytes": 154152,
      "sha256": "2591b8da631d20e6437c3d18710df2886a07a73b287d79c58e36c3bbf64ffa70"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_62.glb": {
      "bytes": 178704,
      "sha256": "c3cde4b01d7ff69b28f18a753fe0496c43ed346b29e2bd91087df0f2f162b3d1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_63.glb": {
      "bytes": 233204,
      "sha256": "d56f40970ad9b4fc3439f2d0f1eaddc5e9bc278e0eaee67bb1ec5cf8f0752f97"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_64.glb": {
      "bytes": 207740,
      "sha256": "372c52332e6221571f6a3c293d1e041593ef59401fcbadb35390f256ca3cde54"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_65.glb": {
      "bytes": 187708,
      "sha256": "01edcb605f13a43812488fe8ac96174ede33178654ae6c8c7a5f9d14c01cc90e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_66.glb": {
      "bytes": 198096,
      "sha256": "e0e45fce68f950296ffd8c5e91a96f19747b5d47d22d62c828a1e74949b02221"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_67.glb": {
      "bytes": 106468,
      "sha256": "466ef7a3c3ef82e9be8db08502ba80a89b60a8ab272b1bd865278f883d4e5d2c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_68.glb": {
      "bytes": 95604,
      "sha256": "a88e9e3fd42fe5cdb603c605421d84e98e3ea809cc4ba4669b1585ec42b06c1d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_69.glb": {
      "bytes": 129300,
      "sha256": "fadd8b11407b7d6f9c66504d2384d2887fc248384c15b7bca459a252745b4659"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_7.glb": {
      "bytes": 194984,
      "sha256": "81f0f6174a1682e55dab2c3c074cffb5ee834b26d73d70ba14b7c3d33013237d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_70.glb": {
      "bytes": 115900,
      "sha256": "2b8b7dde99db0c3aef9e66262b4c83ab3cfac5ab837e1e55534898b2d1b854e7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_71.glb": {
      "bytes": 173608,
      "sha256": "2282f7ace618eaaebb2c5311c3b25ab9ffd4950660683244ff4068d44f30dee2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_72.glb": {
      "bytes": 144444,
      "sha256": "f7ef7c2c4fc8282922b573953fe7e1d48d7b5f66fa60ed415522729f985dfe31"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_73.glb": {
      "bytes": 267036,
      "sha256": "0044cf914ed44694ed3d73871d71b1d7c7615c9af0eac45af89ffc0178d4b0b1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_74.glb": {
      "bytes": 104484,
      "sha256": "e32464eb9091086085c5c49fa54a61d6453dd772e4ef08ade98f1b27f76114c2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_75.glb": {
      "bytes": 213736,
      "sha256": "18e875c111a2059dd61eb49ecba45ca66b394a382e6ff3b6e1d2c41424ffda0b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_76.glb": {
      "bytes": 153012,
      "sha256": "6d6450d2ae79b491ceab7ad298d7c6dd7e67da33301de9875468208808999314"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_77.glb": {
      "bytes": 178272,
      "sha256": "baf5398c6afa13d087974443fb85557ff3306496e728ffb4de42b44dca590885"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_78.glb": {
      "bytes": 148536,
      "sha256": "795841d9011bcfce9308b43ac27c22ebff7df8b9a7aed4cad08eb332147639a1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_79.glb": {
      "bytes": 146656,
      "sha256": "8a5ed523ffad35dbf7f35578b0768ebe0969d9df156ccb594c487ed4f8fc3ab3"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_8.glb": {
      "bytes": 123208,
      "sha256": "d35031b860309ffeaa25c13978d75e129d069e3c203ab2d70b763ecc799ad5c8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_80.glb": {
      "bytes": 154048,
      "sha256": "776dc186278e828505b04fe215379791c52717868579f45e42ac16b364676a00"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_81.glb": {
      "bytes": 227500,
      "sha256": "d7da3f163f513e11410f52dfb2667fdbc6928b624368c0929949089e7a7975a3"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_82.glb": {
      "bytes": 226076,
      "sha256": "6eac97f44409d2b9ed2c0561ce6359cc4c9618ef941b610b78490052370f402f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_83.glb": {
      "bytes": 217928,
      "sha256": "fe3eb9d306c387cf87088d37bec0b73ccbfcac0efd8502fadca6945185366fa4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_84.glb": {
      "bytes": 277492,
      "sha256": "0dd2e2a64f377ff1c554698bec4559d574aeafbac45798edb4e9ff6dae796a62"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_85.glb": {
      "bytes": 180032,
      "sha256": "19ff863ba82ecda410b6035ba9e2652934ed29a84f33866ccac2e9d683fb64ee"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_86.glb": {
      "bytes": 220980,
      "sha256": "7b07399faef5c815682507510c20c0a1f9e8b5ad84a36ba275d65da5259ec007"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_87.glb": {
      "bytes": 127556,
      "sha256": "5fc5f3c82bea0a4357bd54d4cc0deb698b7b3d4ac3ee8e134b6c6dca0fff6efa"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_88.glb": {
      "bytes": 248832,
      "sha256": "87f7bb2d6fb7c1551c9a0df766c379db0eb2c67245cb18c7636c9f3dfc167bcf"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_89.glb": {
      "bytes": 180988,
      "sha256": "db642d05065d720988ee35eb15f2d9840bfdf62969a254a01e9e42ec48b3390a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_9.glb": {
      "bytes": 243472,
      "sha256": "98cfa31b87c10b2217430f03e5aa0e6d90882fe316a8f04fb54221430afb9014"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_90.glb": {
      "bytes": 242488,
      "sha256": "70ecad2b5f4b3918a6d477fb26bab1876312db18412e9587811111b20deb6ab7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_91.glb": {
      "bytes": 258772,
      "sha256": "f9d149b7b9c830906191237f6bc8075efb43cd3e3bce605227481f06c05ab4d2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_92.glb": {
      "bytes": 160808,
      "sha256": "332295cc7ed3b092d134116afc95dd00665ed9c03b84d3cb160a36066e8f2a3f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level26_93.glb": {
      "bytes": 305436,
      "sha256": "fa8bfd9848a67dc8aeabf9bfc0a178643f2589427f95c76769628fe8b4deade1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_1.glb": {
      "bytes": 115336,
      "sha256": "cb8819d9e5b561b617c74596a33285db40da806952c50c376db93a9d249248c7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_10.glb": {
      "bytes": 134012,
      "sha256": "99b837e5bc8398288d040f80bdd034fb597be6162dea582407fe969dbb4296ce"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_11.glb": {
      "bytes": 165628,
      "sha256": "e4349f7366d4ba775322a68154416cae0d07b8828300aef842853e29b512a092"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_12.glb": {
      "bytes": 49036,
      "sha256": "40f403b4d871f357b49ae5a0b65d5430aa64e3864d48363c1a20de10e6a29433"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_13.glb": {
      "bytes": 223252,
      "sha256": "aa68de365bfd72914088511ff57ce07e90e27eec8131c7bd47d5b70759f3d047"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_14.glb": {
      "bytes": 209392,
      "sha256": "4aff831982727a6879cb94895dd374c04b828ad9f1035e570fa1f45c1d2bf6a4"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_15.glb": {
      "bytes": 162424,
      "sha256": "75cf97c6dbe3ae428d53f5ce5e5154ce8413c9e67e4f3b6d1ab2162b01bba52e"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_16.glb": {
      "bytes": 131188,
      "sha256": "4e23919554001b709a9e431360b7934a1178260638266f593fa88d740a1c18ae"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_17.glb": {
      "bytes": 165956,
      "sha256": "c7852a9351ce44c184752b6a73e616da79d21642c053f235a733e59957cfbc96"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_18.glb": {
      "bytes": 159224,
      "sha256": "dc9252f0ea2d3dc3cab18dcc02be4c573343e94d9765bd824ef69c3f6b312425"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_19.glb": {
      "bytes": 84356,
      "sha256": "a07132404a6bdc95e31128567c506c2fe1fc2983549049f102cedbb28b8bea23"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_2.glb": {
      "bytes": 131968,
      "sha256": "097b8b504c17d03ca538c7e42168e082183a6b81db79cecbd84ffabb05fc1afe"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_20.glb": {
      "bytes": 185216,
      "sha256": "69fb9d96e7251a526fff3b2776c067ac274c41eed06c12c47873c108bbfd3fb1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_21.glb": {
      "bytes": 236256,
      "sha256": "2a7ca0843d279ca0b7a3ce685fd804f33f8e3ad119a95d7047f18df3a5483025"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_22.glb": {
      "bytes": 85880,
      "sha256": "8cecf052e174d5ffb7cee9fb5b6a2505f68a637d83c51bc0f709b1e51d7a3a2d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_23.glb": {
      "bytes": 204388,
      "sha256": "e713d7903a4505bc567b5919f0f5b6ba76bec68f2b05fbe5d03ef3e303387f51"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_24.glb": {
      "bytes": 182460,
      "sha256": "0f0222a9781bfbf918cb9316d77f3bb7ee45d480074f20a3439d2adf6ea4e71b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_25.glb": {
      "bytes": 195568,
      "sha256": "19042c848eb0f28fc46473e88c3ca3006f25f315f4400f877c0c94fa0d9d401d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_26.glb": {
      "bytes": 178536,
      "sha256": "85af1d1979a611d0d41fa82f6273f9e72bdfccb39649bd7ca0c65bc99a4ccb80"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_27.glb": {
      "bytes": 219560,
      "sha256": "e62c4313bbad91e4c41017a50bb50969ac62544e80f25b4ee5677b545ab0d34d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_28.glb": {
      "bytes": 237476,
      "sha256": "025e7c807c91318f9968e2e5583afc47b378a3440a17566307ba4bea6dd954e3"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_29.glb": {
      "bytes": 211216,
      "sha256": "5934b7036547542b2faceb32fd9f23fe40eceda7cf982b385fe66d7ac3f7f4af"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_3.glb": {
      "bytes": 191844,
      "sha256": "e6dd8f9809b4e21123242ccdbae0d55c795a95bdab9802508f12782bfac60ef2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_30.glb": {
      "bytes": 83964,
      "sha256": "3256ddc5236d5afbbf3e85edb77bc14e4bf704d77d966b6f3097cae877f63228"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_31.glb": {
      "bytes": 176296,
      "sha256": "844746d185fe891f45e09ef4b7893ae8f2c8fe7c13c5eba12e8299ea3e907df5"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_32.glb": {
      "bytes": 95780,
      "sha256": "d63a5ea9ad07d1983c92649997d67c2fd0799427f68b3a2a6d59d415ec5666d0"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_33.glb": {
      "bytes": 119864,
      "sha256": "17e4128c1b6c1abc9569349faf454f7cb024a173258d7acb5ba8f5dd9198fcd5"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_34.glb": {
      "bytes": 140168,
      "sha256": "a0ff41b85efd32fa8e029c71fa015368f2a5fa4274e5de75d93bd7c3cf101c12"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_35.glb": {
      "bytes": 88068,
      "sha256": "7dd19106f3c8ceca0c09cb2918395143a17365b92957c19789e2a0ed77040e3a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_36.glb": {
      "bytes": 194608,
      "sha256": "497afbc01a65c1145967d228b6ce235c1a3ee0cb6cc85027deb877eadd71811a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_37.glb": {
      "bytes": 196896,
      "sha256": "6f644751c8acd3638bc585d44628d48722af9002c91da398b1becd05f73ce4c9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_38.glb": {
      "bytes": 172920,
      "sha256": "87d414c97c0d00f1669a3062cfc9d63e5d414253f122b487d175e4f3261f6de2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_39.glb": {
      "bytes": 188752,
      "sha256": "2e66d9630970472f48c52e576d49f3ae14f300edff60fa3dcebe2d214bf6262f"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_4.glb": {
      "bytes": 172756,
      "sha256": "c63415649705a6e310e53e0f1d2eec152b59387ffb94466772125f43c1da8b60"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_40.glb": {
      "bytes": 93048,
      "sha256": "8b85367e7b91acddfe4271052b2cbec412522047bcb593db3619ecb1f13f7212"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_41.glb": {
      "bytes": 136552,
      "sha256": "8a370083687182aa2ab3d5743ca13e0834a0c20539c1d671be9dab584b311182"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_42.glb": {
      "bytes": 148016,
      "sha256": "067cf4c8bcab2bb6409b5842be7eeeeddf312b725c88e355a429425678ae01da"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_43.glb": {
      "bytes": 134520,
      "sha256": "28f4046316463ca8919490d0b79ea77d1931f7ae27a933f0d08cfd51f439a781"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_44.glb": {
      "bytes": 169572,
      "sha256": "93dbc6d27fda306637b46c17f7546cd7af9070e37060ecac593293079d87d56d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_45.glb": {
      "bytes": 161152,
      "sha256": "4202d7ebaf4ae7f95b219ac4407c4ad0a52f39433d3ea1a1e9f7495e6ad7267a"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_46.glb": {
      "bytes": 185396,
      "sha256": "72a07c9c6da33d08392658270ca38b81c6bbd20a3e8576e752628668867f45c6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_47.glb": {
      "bytes": 233080,
      "sha256": "25f82f182175f993869e9f9a569a5da4390c426ac27f3adb92d1794b7d9a50e8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_48.glb": {
      "bytes": 143604,
      "sha256": "50b85526eba099d3368d4c7cd11281ae16e1e3d0a5e9c7a906ff2f2317144ea9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_49.glb": {
      "bytes": 210908,
      "sha256": "0f74a14811a94ba38460f64c8005ffdf4842a97716e622ed8e41d25368fb2c28"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_5.glb": {
      "bytes": 213844,
      "sha256": "e126c611929b4bd108952235749bc1c7523566f65c49df4bb66baadf9c3affd8"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_50.glb": {
      "bytes": 212668,
      "sha256": "6f0fb3dfbb384a005378a7214f66176c78d7b2d4b179329fe5b66050238483dc"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_51.glb": {
      "bytes": 65632,
      "sha256": "6d9191482b398e7abf72bebcc6fe43876bcc71a07cac49805282575682ff74d5"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_52.glb": {
      "bytes": 240396,
      "sha256": "e11c8bbfa55fdf52089de63ade6c7e167d465722eb41dd63dd451bfe971b3338"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_53.glb": {
      "bytes": 204972,
      "sha256": "72530bbfdcd8246601be32161d6d94e37816ea1851cb709fb1c319e02dbf18b7"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_54.glb": {
      "bytes": 162924,
      "sha256": "bcccd8753931b27442f8467679fbf2860dc8d1487b0874b12d91cb0ab2a64485"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_55.glb": {
      "bytes": 143620,
      "sha256": "f37a54e6f0102e65ad2959ff33818c352d2cc5bd91e62a12e45f4d1f52fef7d6"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_56.glb": {
      "bytes": 154740,
      "sha256": "7b1849e3c89a0bc910c7e80c4aa228c18dc4525fe8959c4f140ccbd829f34b68"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_57.glb": {
      "bytes": 161980,
      "sha256": "b43932e7feb77fbb55e5736aa523dba6b1d6a713109818315cd0ec0698f6dc80"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_58.glb": {
      "bytes": 119120,
      "sha256": "79f77e1760a1b0db2a6a716ee757dc2d43021226c4c09401623a7b196d28dcf1"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_59.glb": {
      "bytes": 157716,
      "sha256": "05091ef865d87f2eeeb9d603f07bda624ffe31fa5cdd36e5beac85d64eb5c44b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_6.glb": {
      "bytes": 161340,
      "sha256": "6e19ad93a1eba1e6e4479c386753ca67f8ee5c009e41a14eacdce29eb9376e4c"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_60.glb": {
      "bytes": 132288,
      "sha256": "6e8bc4c6bbd3ab6d6fffc9fa8dd1ac4c11bf48e8ecdbd740480f378cceffb354"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_61.glb": {
      "bytes": 143396,
      "sha256": "08eb72e90507c59d2e1113a83169de626efbaa03c811f15b1d1eb04134fb73d9"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_62.glb": {
      "bytes": 248672,
      "sha256": "e7b01dd1c0d0d55dd315a6bea45102d8930386a19a1a05d49ddac7bc7c25b9df"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_63.glb": {
      "bytes": 138344,
      "sha256": "9c22ebc4c9241a385f58d142e2c917211b78f9b70f5133f85a15ea8c469e8839"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_64.glb": {
      "bytes": 218352,
      "sha256": "b4f68a643c11e2daf56911b16745ec521e08c9b93ec99771df9de89212f41ea2"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_65.glb": {
      "bytes": 160028,
      "sha256": "1b938afb9605d48dd0702daa0e2362692d27673be64e7e3ebdc36e3aa5c55382"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_66.glb": {
      "bytes": 191328,
      "sha256": "c759b0ef0489cb6563ca9f02be3c951600e8a570b2d41a8d3de3d9e71bbb4b2b"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_7.glb": {
      "bytes": 115564,
      "sha256": "8f2e747de8014e4cfdf60c0f7500b363aa09b233a84d427ef18f5548276075aa"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_8.glb": {
      "bytes": 162080,
      "sha256": "7b017677bbf6db02387c4d931af8db9603d8e1631b2354f2bd89b763f395fe3d"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/Block_0_Level27_9.glb": {
      "bytes": 167080,
      "sha256": "f981aa6ef22536205de1292f811c7644828b0be3dbc7b110b82dc9431364e833"
    },
    "office-delaunay-image-ktx2/3dtiles/Block_0/tileset.json": {
      "bytes": 324976,
      "sha256": "a662401c6f8fcb0e097f271e48ca31c825e94967ccd4d035217a8de785ae8341"
    },
    "office-delaunay-image-ktx2/3dtiles/coordinate_contract.json": {
      "bytes": 789,
      "sha256": "50166dbd57faad7c5a0665e14c4d84b4920ccd60011581366adeb680a0df9007"
    },
    "office-delaunay-image-ktx2/3dtiles/tileset.json": {
      "bytes": 1278,
      "sha256": "41971691a7a60d184eaaf4408140a83e13a7dc895c97efffa85c4b33deca1cd3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level15_1.glb": {
      "bytes": 167884,
      "sha256": "e724f582a00bcb3f7aec24591f7344828098514c072a1aefd78f37d1ea74ec48"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level16_1.glb": {
      "bytes": 165276,
      "sha256": "680373006a580d7045ca2c7a957c6b5ef4a37dab65258754902ba3a309b5caa3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level16_2.glb": {
      "bytes": 155380,
      "sha256": "53946d6eac87332fde6cafe81cc828dcf3b24c39f0249de6682ebd3facf65243"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level16_3.glb": {
      "bytes": 226136,
      "sha256": "ead395da66d3445156f02914ce3f894e6acfd431fa7675262dd6ca5391748327"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level16_4.glb": {
      "bytes": 126008,
      "sha256": "adcdced404a321594fa865028682908e6f9b59bc225a2a81b02346554c0e0286"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level16_5.glb": {
      "bytes": 148072,
      "sha256": "0042503b79d55591f94764e8639b86aa68a383ecde32d1b64225711b15bd85ad"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level16_6.glb": {
      "bytes": 187852,
      "sha256": "8e1382b95606acd2f6e1d5c0cefcb5f3acf4045e5fbc618f1a7f3116b38c5b36"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_1.glb": {
      "bytes": 42796,
      "sha256": "e9cd65a7bb247284d8a9be8460a61e82f7958481f7574a31df88475ab9417d18"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_10.glb": {
      "bytes": 233736,
      "sha256": "678cb3abfae17f7f4e122dd7152655dbad4354e4b31949a9f101497c124bccff"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_2.glb": {
      "bytes": 86780,
      "sha256": "83face8fa4f8301bea1ab53e96771a32412926955f77632df7c0f56cc287c593"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_3.glb": {
      "bytes": 208996,
      "sha256": "eced37991255b2c69a5b2ab49840d48c4225f8c136d7b508820cca9bf5ed17d4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_4.glb": {
      "bytes": 18484,
      "sha256": "308db5786f668ce332a98d01a7d819fb43709aeae068136b3321ff2aed0479cd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_5.glb": {
      "bytes": 218384,
      "sha256": "826b00cca525ac55675f92ed2198b9773771cd2835929614834a7a7cddf88643"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_6.glb": {
      "bytes": 83108,
      "sha256": "1823cf7ad72e0f33755d4529f57a55e8b185a4ba3ec96dd02dbc350c5355bb3e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_7.glb": {
      "bytes": 181380,
      "sha256": "efaa5ab651a472fa83ba9571687b4509d5d1d1e6abb2c9eaa08fa59c0fed1b87"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_8.glb": {
      "bytes": 144228,
      "sha256": "9ffbc809eda4a514eb46ddedb0a17b3a395eecffacd52f036dee24eae474b525"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level17_9.glb": {
      "bytes": 128104,
      "sha256": "f5df0907b06c5146a2aa1ee07da14a9c0e2fdf7b21b7281a553fa251dbcdb996"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_1.glb": {
      "bytes": 65416,
      "sha256": "3dc2dd5e68037fa600ba3b058d2ae3f78bb84bf157bf8199ca4416cbcfbae596"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_10.glb": {
      "bytes": 230144,
      "sha256": "d426fb4788217deb75f16d0f89544f0da19497b0218c3834251da5e63c140bae"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_11.glb": {
      "bytes": 228700,
      "sha256": "ac3fdbb45caac2f9686aec83996849f2f978c5b4d9c1698e8dd0f45ce019d2a3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_12.glb": {
      "bytes": 173060,
      "sha256": "d0da93eda30b2315292318ed50ca2f52b67dccf2de58d2360194a67148529ed7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_13.glb": {
      "bytes": 196828,
      "sha256": "9e0c558c64171f7742518c324a01ef2b9eefa2dd2864dae318c00a39de855bf2"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_14.glb": {
      "bytes": 96296,
      "sha256": "a1b57cc440b0c5238f2cfcc18d4f20b2bd4227a94d60366d1080eab547a3986d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_15.glb": {
      "bytes": 76696,
      "sha256": "a1184c23b3f95b72d8f602afa98c2d7a8ba6984792f79b3c5fa0cc4369a1b316"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_16.glb": {
      "bytes": 183896,
      "sha256": "8e7bf93d1cd83dff1a4148e7e831524e4480260a083b4eeb591953302e7b9020"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_17.glb": {
      "bytes": 204092,
      "sha256": "0713130307e9ad576399b4955d541dbe08296ccd86abbd6439721d3a165f26ad"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_18.glb": {
      "bytes": 176792,
      "sha256": "008cc40328d8bb36e4673b040839de7a418529a05b3c61c72154809a7dc20b92"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_19.glb": {
      "bytes": 64232,
      "sha256": "2f018ce87b1ffa7ce51c601fe0fa3e7b26aa4583b0e241a32f810b1a6514ebc8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_2.glb": {
      "bytes": 143996,
      "sha256": "e57452a72ce22258e2a2418c8b988a7072ca12b8cde806b9772e387933559beb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_3.glb": {
      "bytes": 114616,
      "sha256": "2be02c17e9d8b6abec17faca7a6c04f88d484928f1034f02139a4e2a848d8325"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_4.glb": {
      "bytes": 107752,
      "sha256": "d9a7a8a4e92c4e60e96c56eedef412220d8aba525d6ff0ac677ed1d6339340fd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_5.glb": {
      "bytes": 129672,
      "sha256": "978e385439e793cece651597fb6f921e5f54f024251f7a2cf63ddd6a173bc8e6"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_6.glb": {
      "bytes": 25208,
      "sha256": "b364c3514492313db8a179559b133943aee81599b8fd72098f713321aedc6096"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_7.glb": {
      "bytes": 195452,
      "sha256": "a526d02f500139f790de7fee110ffc72fd074e61ac2dda6cd0e864cd32e4b705"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_8.glb": {
      "bytes": 148112,
      "sha256": "45df5532bd9b49cd9197a717c53d23e73b09803bbbc8d24e609b04b7f8597ef0"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level19_9.glb": {
      "bytes": 117512,
      "sha256": "de6956c4dc6f0c51739c54ace378d45ea7d494517fe3d706280ca8189d9bd05f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_1.glb": {
      "bytes": 87380,
      "sha256": "36285a131c676c0967395650efbce33122c2f8f77b97b3cd4f939b9a0d8ed4c9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_10.glb": {
      "bytes": 203036,
      "sha256": "3bae55d291a656ea76fb494ee9288e1d678a93c3d6896f2899be92efeaa39ff6"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_11.glb": {
      "bytes": 164652,
      "sha256": "0b4aeb72689217fe66b3c0a91ee1200f9cf6ff49385459761d1b46cb27721538"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_12.glb": {
      "bytes": 111924,
      "sha256": "c793611feb63265db420cd83f3f600672e3f1fb03cca381067ffbd5226e0c52f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_13.glb": {
      "bytes": 185268,
      "sha256": "8eebf3f03dbd3c448bbb1a9a2d9d1c8db51498a8fc802b29a9810c37ad4742c5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_14.glb": {
      "bytes": 73544,
      "sha256": "567c9175cb1508a34c74b1ca656a8d2f81778891cb326dab6eba5b4baa331b35"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_15.glb": {
      "bytes": 178936,
      "sha256": "cfc2f09cec6f370a09a1c9b64658818f5596080f96d341fbf34dbf01b7ab41cb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_16.glb": {
      "bytes": 111840,
      "sha256": "a8c82d3b8067d52e4b19c057ab5b1fcb5c792d299a787a1293b0d427c7772cf7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_17.glb": {
      "bytes": 160632,
      "sha256": "9556ce180d5d1988daf9ddc4b0c37f59d5e51e2ed833e1be0a1a071488ceb345"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_18.glb": {
      "bytes": 94908,
      "sha256": "d3cebf6e44774fa4bc57e5cc78b3323b48b5e3545235883bf5b1a14c3de71595"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_19.glb": {
      "bytes": 97280,
      "sha256": "3a51f03eff49345d2bcc2137dac5d054e8eb9b4453cdc1f25973f0a2b685d5ce"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_2.glb": {
      "bytes": 151420,
      "sha256": "2ef486a8f29d3243c00e9d80ae4a8843388ae416649bc64d6524c57b823f308e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_20.glb": {
      "bytes": 175824,
      "sha256": "b504ee3d14e3ef75883a767acc4765662bb5d775f2864b3932b81ba1a3f6bbe4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_21.glb": {
      "bytes": 198604,
      "sha256": "f89d40036f3c07df3a4edf55597ebf3529a9f1ba644992c996a1ddf5428739c3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_22.glb": {
      "bytes": 45692,
      "sha256": "b302f548c2964f3d85a924897bf4c9f7545436e940db1742d8037d0767a8399b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_23.glb": {
      "bytes": 223892,
      "sha256": "f8d24aa086406567b1cc44a636e0284691ae6d5522f2c2dc471425a2cc1eda6b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_24.glb": {
      "bytes": 8128,
      "sha256": "0d4681f63f842bc2d997297b9ae18e68400c23be0dc1486935ca08d57bb5d6c7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_25.glb": {
      "bytes": 193120,
      "sha256": "7ca001a913bec0f760f3980b5b1fedf1ac411114adf4cd8e857885e2089b5835"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_26.glb": {
      "bytes": 216624,
      "sha256": "e18010a0fd339471e06b74b1c5fdb85acd33421af6d66705361d7dc2284d7439"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_27.glb": {
      "bytes": 186680,
      "sha256": "f2aa8aa6119655dce3cd143818d34fa3be45d8d6c9ca8c10f543222d9486722d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_28.glb": {
      "bytes": 106928,
      "sha256": "2f462d76f32e35de27322011891ba333663285e9a003d7e4ead69f49250466ad"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_29.glb": {
      "bytes": 205584,
      "sha256": "24e455ad45ac07d37c9435c4ebae3185a0d62c46fae1656844133e50e3c6e454"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_3.glb": {
      "bytes": 123416,
      "sha256": "0cd33e0372728b1b3f1f1d22672001c254851ab052bfc1ebb1bda134300c709b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_30.glb": {
      "bytes": 41804,
      "sha256": "1f2545601889a0ddc40aefa3fa8d1252a410a15f4701a5660d58c0c96054055f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_31.glb": {
      "bytes": 105396,
      "sha256": "fc2d3757534189144dda470fb031b8ab891cac8da3edd358e91fa775edfcfc66"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_32.glb": {
      "bytes": 159868,
      "sha256": "a840596a8a6490427c196bccd4aa55e42ca15b7b9a0ad22e9df82feb3b9f3def"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_33.glb": {
      "bytes": 88492,
      "sha256": "adefc26521e1cd1bc2b1dcaef1fbd7bc0080ba614a59d4f030e469ae320891e4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_34.glb": {
      "bytes": 151988,
      "sha256": "c0d25a22c114c7861553f825c128d10ded8442fa9872881b42a68af673c0f9d3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_35.glb": {
      "bytes": 84052,
      "sha256": "8fbcdf2a108a406264bfeff71b8049ede792bc97f42c08969352d35dfe6d3387"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_36.glb": {
      "bytes": 169188,
      "sha256": "323cc4f5e99f099b60af8a5149bdb82ac0938d3dd3d4f839150673dae5d538d8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_37.glb": {
      "bytes": 132932,
      "sha256": "d123d6bd34e7089c90ec15021cc5c388a7de095d30da2c48b20cd7f01d23e3c9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_38.glb": {
      "bytes": 194788,
      "sha256": "72db36351241077b096017b17d754eb79f0ff31bed34f27d8874015e8aad7700"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_39.glb": {
      "bytes": 141600,
      "sha256": "4ac00bb14181bef351782bd2a9e3b6829303ba817b191ecefe4049d70c1abe3f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_4.glb": {
      "bytes": 145636,
      "sha256": "3a83be082a5d354128e7942d6b9838b190a7a05ce9518676a9cbfff18b522805"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_5.glb": {
      "bytes": 139420,
      "sha256": "79f9a645f5103a7df26efdaa1d8169a9c6a7f5f8d425c859170258fd1ab7a7ff"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_6.glb": {
      "bytes": 161288,
      "sha256": "a4a0854d6740a2e5d99744070522ad63d24a0e035e0a45564b6f4afe4c7dfa53"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_7.glb": {
      "bytes": 35044,
      "sha256": "6ecbbd967c26e8f9f9167ae1d8a74a954b6a5925649e57eb06bc4873c891db4d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_8.glb": {
      "bytes": 151684,
      "sha256": "b2085958573012545d791b2004c97084989ce00bd1012443d6f4020ce79a2fbd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level20_9.glb": {
      "bytes": 167252,
      "sha256": "ff2639a0d4e67c0dfa577bad95436e104dd90549849ae39386e708ed8dc2de34"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_1.glb": {
      "bytes": 116648,
      "sha256": "910073efd8935add0c3115e9490c07aa6e3c0d097efc4d468e6d67743aa250e8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_10.glb": {
      "bytes": 46976,
      "sha256": "0086d329fe12a9d27c68528959a8d241e0326ba0cc0837d6fa470eeefe0b8a4e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_11.glb": {
      "bytes": 189868,
      "sha256": "78836c064af77cd1bc6201a1a911cc42102932253b3d3c21266ec86a9c38a46d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_12.glb": {
      "bytes": 48728,
      "sha256": "c3cba94b9a7048f9f671044513ebf12cfbc37279a5f92b516bdffbe0b6163df7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_13.glb": {
      "bytes": 33348,
      "sha256": "7a6b5dc157db28a8ae7cc73c0ae5b7b6923bcbbb43c05ad54d2d90a133fbaedb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_14.glb": {
      "bytes": 175092,
      "sha256": "b38f29913ebbad4489f76f0477fe5e7163f9ad22f0afd47f2f97802e7887319d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_15.glb": {
      "bytes": 79336,
      "sha256": "33c367450a7694a85caa0c945166cf76607ab3828c57cca9d16a528e325128a0"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_16.glb": {
      "bytes": 29216,
      "sha256": "998616aa2c3ff4068d7477e9f4e4b34ea5ad0d2f85c79c17eacbfe3984215620"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_17.glb": {
      "bytes": 133056,
      "sha256": "e87837ad45829077b4eaffec01026e59e90996005e6abf393d5651e7a6c56e6a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_18.glb": {
      "bytes": 108948,
      "sha256": "ad37b6238a62e7114dba899ad503ab3788b69ce8ff27a3f14c8b58dfb303d9ee"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_19.glb": {
      "bytes": 41212,
      "sha256": "7dfdb48c7f2f7a71074c4c673d282d89232f1ae1a91295f82335f2276a8562ce"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_2.glb": {
      "bytes": 105320,
      "sha256": "a46ed6213fc1637cc8db38534abed0ce8f9bcd71d311f83a602f67f0c8ba37d1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_20.glb": {
      "bytes": 86804,
      "sha256": "291f9c0bedb7dbde630cf292e51f995f6a19620763d9f7d11ea1f2fe9f70579d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_21.glb": {
      "bytes": 160384,
      "sha256": "71357e49f600fb9693cad0a37d1be8ca924b87dc1a39ae71d33362bc8172bec5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_22.glb": {
      "bytes": 12112,
      "sha256": "aeadd6483a6302de7c1b5a666b8c45b97c8a9c6b507a66cf378ab43709070cf3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_23.glb": {
      "bytes": 69488,
      "sha256": "9ca22c31a9bc5218b46cc18dabadcb15dc09b2fbdc17dcebb98462e0a8d87945"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_24.glb": {
      "bytes": 184540,
      "sha256": "2ae8dbd8836af973425e359d86263b12427646b04fbe30ff15fa7748863049bb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_25.glb": {
      "bytes": 77940,
      "sha256": "78638a8bb4a89777770079e778af66ee34d9887686e4418354b6e7b6b0d1257f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_26.glb": {
      "bytes": 143916,
      "sha256": "5340187140c7c1756da8b9a05e98338eaa680b75c982f6e5efc144c58cc54486"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_27.glb": {
      "bytes": 176388,
      "sha256": "570d4f4e9d9f22200e997bf2e76893c54cceea4a547aa6a40bfca754c40aa55d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_28.glb": {
      "bytes": 177068,
      "sha256": "5ea261d7fb5106cb100d8901bd2678335dd3c397e427a198cb6abccc47d8fae5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_29.glb": {
      "bytes": 122328,
      "sha256": "e061b7edd96489aea9c390c8708fbeb38ae85a6005f1ff89ea6bfb2b2b7ff74d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_3.glb": {
      "bytes": 164988,
      "sha256": "0734bc258a7fddcfdcc6451686c09a7c69df5635f51998e22fa3e8f111c7c436"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_30.glb": {
      "bytes": 135984,
      "sha256": "39dc884a985477cfea72aba67b11fc4745d4528835e2663b0f0b4d7469bec3f2"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_31.glb": {
      "bytes": 104880,
      "sha256": "04d93cda715ec978c01c61e78d6fbcd0bd1bea9cdcf256fc929b9c1b7b84f051"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_32.glb": {
      "bytes": 180748,
      "sha256": "a590eb17fbd5964333e632201a625bee95e657cbeeaa7f562dd9e8b0b6071d0d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_33.glb": {
      "bytes": 151324,
      "sha256": "500d549376c6ef9b86bf5e6fba928ed0da7e0fd157b6f7bdcca5b8bf32a67f81"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_34.glb": {
      "bytes": 84324,
      "sha256": "10609335789a70d655551d236790b14959866c801ed27d15b44ccafe1b01f8d1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_35.glb": {
      "bytes": 217296,
      "sha256": "9a1d72395160cb895b7fe5f32f863d042f95444ef68f2e3de5be27bce9ad027a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_36.glb": {
      "bytes": 205520,
      "sha256": "260dece5ed0d4a83da7becec4e44922cf8d025e2cd065013c9a5b0aadc90f1b9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_37.glb": {
      "bytes": 154300,
      "sha256": "72397e77695a6d75e9cc5b08f1c68062d4bb3a4a244f3252e5271f696d499d93"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_38.glb": {
      "bytes": 98952,
      "sha256": "dc875dcc63989b9db59bf230494ae372d80fc9b7f6754b7314b8c12ce9408790"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_39.glb": {
      "bytes": 149756,
      "sha256": "91b53c3d765bf61e7fbd264592b1b3f56062aecdb679c70207cab6f63e36cecd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_4.glb": {
      "bytes": 211696,
      "sha256": "4185fb66061f8689d49484e2294b006e8dd900c8241ea09f82542dc140b8e2f8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_40.glb": {
      "bytes": 223392,
      "sha256": "0ea4e7d0ac992e77285021a7d8f3785d9872d6312ae9b907b932ad8ad5af84d9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_41.glb": {
      "bytes": 199632,
      "sha256": "1956ebc8cf78e0540f7f54404f5a2b8a957daae8b6b2b57f5f7ef2a545d3f5d1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_42.glb": {
      "bytes": 98816,
      "sha256": "f86118871c1aa423345b1eeba7ec42586b83177f258932a1b544b3e3b6dc52b8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_43.glb": {
      "bytes": 144172,
      "sha256": "bbc70622d09b5763def2e7f7ee1a50e5acfe70c7372b4e5eeaca1921d5077b27"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_44.glb": {
      "bytes": 107344,
      "sha256": "02661ade7364576e7285f31443131fbbd0c405267a28deb84cdaadd94a838789"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_45.glb": {
      "bytes": 151212,
      "sha256": "b088fa0e3f51344ade2eae4aba92b0a8473f6c4d023f5f74946781048e9d4cda"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_46.glb": {
      "bytes": 120480,
      "sha256": "36132d6a7a585620fde37a374cb791efb21a4a13a62d9b9a9e0aec989c3c70a1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_47.glb": {
      "bytes": 96512,
      "sha256": "fd03240d2673426b51278def62c7ad932a7cf560104c39370f1cc6520d6a241e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_48.glb": {
      "bytes": 171844,
      "sha256": "f6b756f1b7f0a68e9d64ae3ea05dc907eaadfc688b046f14a94561a32ba74536"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_49.glb": {
      "bytes": 13072,
      "sha256": "b8872573db7b5a0598c41159bb93f7397b4e08b89bc90d7368a91f39f63cdb22"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_5.glb": {
      "bytes": 23676,
      "sha256": "fede6f40205e989705a4cc4701cc041d32112bd0661c51cdec5ac5a50d3a5f94"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_50.glb": {
      "bytes": 111476,
      "sha256": "d423f5f36ea86b24bc5bc7dff1a2cff32c7275be242369c6618d777110000336"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_51.glb": {
      "bytes": 117996,
      "sha256": "311ccd8cb1b8304772d0812c92a61d434b3dd7fa25d5d260734526ebde6b3f54"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_52.glb": {
      "bytes": 151664,
      "sha256": "0d5107b00ff64eb6efe0ac24caecb06ed53bbed91afe7bef1935c4959820a5df"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_53.glb": {
      "bytes": 119972,
      "sha256": "1531a897284ea8ceadcb199dd1ab34bc7b788241b7b902785f1265fc068b4b44"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_54.glb": {
      "bytes": 212744,
      "sha256": "b4d719e8ff083b233aafe7550909c7e000fd82ccf0add979141de38ffa98263a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_55.glb": {
      "bytes": 121824,
      "sha256": "3c980fc676aad301d9b9cb9a91d0dee6205033edaafaab04635bcb1c4c862268"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_56.glb": {
      "bytes": 144276,
      "sha256": "5e59cc99e3a55d01387db617adc60681399f4a62b083224f5f0718ec2ee875ae"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_57.glb": {
      "bytes": 134280,
      "sha256": "34d3e329526a75b5a28bcbcef526ee92a3d380b03ca997f9cc2fd018035bcbf5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_58.glb": {
      "bytes": 126612,
      "sha256": "a11f8e0bb89862ae4a5f67d0fcd71b07ad7b12a8252fe47a9b27905a36cd48c4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_59.glb": {
      "bytes": 116884,
      "sha256": "a9b14fbe204e247987b631c20f4650c76efdb4ae1af337b12dbc4e38d587807b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_6.glb": {
      "bytes": 196044,
      "sha256": "6eeb3a6bba253b917dbd30d98819ce5029a3fa42bfdc3114155ded723506502c"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_60.glb": {
      "bytes": 214804,
      "sha256": "a578dd691326c309b93f02f41c580a01f2f63b3db7f5796520c82a28236f5673"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_61.glb": {
      "bytes": 163896,
      "sha256": "eaca7ffd751b974e71c04751beac3632aa7842ac644d40bfda219cb07a0930a1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_62.glb": {
      "bytes": 132060,
      "sha256": "172866a9bc16bb1f6cfa61f2e670d52743db55f2e760cc24f6d843981d815d7f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_63.glb": {
      "bytes": 202732,
      "sha256": "1a04293270b72a05f68c30d39a2ab77804748b0371841cc27b0da0b167bca5e8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_64.glb": {
      "bytes": 103700,
      "sha256": "60c2465ae784fa60123cdc09b42a5cd8068a1c360f62d812c77ceeaaaea4ab39"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_65.glb": {
      "bytes": 194580,
      "sha256": "08af16db6e7a15036819e4f6c3361f3ffc9e66d168dbb3d9aa5d287cb341d9de"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_66.glb": {
      "bytes": 64780,
      "sha256": "8aaf6d7b3c0f8250282e17820a4ee1a1bf8d4dc17706a9a3b4819b9bd3d36d6b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_67.glb": {
      "bytes": 222632,
      "sha256": "c9b9e06fedf6fe448221ed31a7dd97223d9f813418d6344e31c075f388809b94"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_68.glb": {
      "bytes": 174884,
      "sha256": "51814e99f384c71506f7c320b94dc2b876da7fcff87dca59df8f94d8360a22db"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_69.glb": {
      "bytes": 3088,
      "sha256": "d63f8c0911fadcf8cea0b0feeed6ee9f495e562d7c1d585116186e95cf43e095"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_7.glb": {
      "bytes": 194468,
      "sha256": "6818cda3e74cf5dc76ca401898f22bd1487aea8723cfda8c2b6363af59a85cd4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_70.glb": {
      "bytes": 98480,
      "sha256": "7c8912609f1b6b2f35304a3b28c1e0b07ff3eead5e664226ffef81391e8d1b24"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_71.glb": {
      "bytes": 154780,
      "sha256": "a1732b7e04146706930d42c289e33a055b689e5c3a33a729573264d056720ae7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_72.glb": {
      "bytes": 140292,
      "sha256": "d5daa7b8196a1272ed53c0201395094e3d2be53c93f21a3c622873f509ac1e3b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_73.glb": {
      "bytes": 132092,
      "sha256": "5c9f2e75985c5dc17f9dea71c1938cf8e3fc89006cbd7c43b569f0881ec519e9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_74.glb": {
      "bytes": 75352,
      "sha256": "72ece545f04fafa6d8208ea817fdc5f1db68579fc6d08a1b388f5c69dbabca8f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_75.glb": {
      "bytes": 160972,
      "sha256": "ff79d40b30aec35e1305d30f7864a065c542171264e67dc967f670d3cfcafd2e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_76.glb": {
      "bytes": 222412,
      "sha256": "73b59d4ba71374ea6ed357235299dd7733974e61a8a5f38f604051fe95bc8728"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_77.glb": {
      "bytes": 166216,
      "sha256": "37b4570e72ab5135b5bb87aca367c1ee22b2f7df5ac213c54e6b7584b54a7cfc"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_78.glb": {
      "bytes": 208308,
      "sha256": "bff681c0c28e2fbbd696cc152e5d073825811a63d2ce7de9313627eafcbaa701"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_79.glb": {
      "bytes": 47484,
      "sha256": "241d0bc50235f21bdd0c9a9c6a26efe187d02475f05123e5887916c50efaf436"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_8.glb": {
      "bytes": 94972,
      "sha256": "bfc5386430598a7851a8d330f93a0103be7423d1174b985a715003f9c97c01d2"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_80.glb": {
      "bytes": 172916,
      "sha256": "eb9435c7e2f28117de683573208c435dd6d9eda4c613b2c6bd675c0ce8084499"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_81.glb": {
      "bytes": 103376,
      "sha256": "1ab53f746b437e7c3cd627cc40e68faa017d2d024c5b1e0ff21726cdf2b71741"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level21_9.glb": {
      "bytes": 133908,
      "sha256": "d3b63178e90f923cc15b743142945939ca9cff9f9ea8055abae50029f73fec1b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_1.glb": {
      "bytes": 173596,
      "sha256": "6c0e6c0a61a08fe22e9e2412fea412d86d24c820cb6686b1415aa0d6af425541"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_10.glb": {
      "bytes": 147096,
      "sha256": "d8bf41e63c4b96efc169a60de2b4b602b69bb9b801d755fc71cd8949b2d732c9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_100.glb": {
      "bytes": 181956,
      "sha256": "4f3a749b2d13755a415f8188eaa1a409674ca799baf00b580340ee3105bc72c7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_101.glb": {
      "bytes": 143572,
      "sha256": "079a3ee568f8ae49a2760c328fcfdb1e4c0b985a00f75720f75a7e212edf4710"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_102.glb": {
      "bytes": 112148,
      "sha256": "e0bf950dc8e6e6be1330123ee62df7029c0b2ecee0745a16f9d6a93f108c149d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_103.glb": {
      "bytes": 144164,
      "sha256": "750726ec1f30c47759c33a15dab894f24e605ae32e096419e1309e0a747f3123"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_104.glb": {
      "bytes": 155600,
      "sha256": "c999e44b2ac4c59372a1c5351db45c2ebb489310f6c2385637243b70fac3e77e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_105.glb": {
      "bytes": 182648,
      "sha256": "f492f5381061d0333d9421f1259fa1a5d88c31d9209e2724379c64c3027ec52b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_106.glb": {
      "bytes": 85128,
      "sha256": "948ff757675703d0a5ca853050af920dc495ddba6c5f07d96d900d04e7fc08b4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_107.glb": {
      "bytes": 137464,
      "sha256": "a15532cd1d2bda62dd6d8698049fce605ca7692c9c4e6c805964d942b7362531"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_108.glb": {
      "bytes": 155716,
      "sha256": "45507d775124c434fc63a26c8dc4f8dec81d12fbd33a22a507aa3947dd94a3db"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_109.glb": {
      "bytes": 153600,
      "sha256": "780ba0ce15698aa704dbc17739bc597d51bc1099129cc0bb9462b8ed917534d3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_11.glb": {
      "bytes": 173652,
      "sha256": "0214e1b815b4d1a295856828b6e62e9e4d9ec942cab896215ab388ccb214d190"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_110.glb": {
      "bytes": 169492,
      "sha256": "c8208a5f6582000ab34037db3c08f5c11152adc2c4582362cdb0e1669acc6569"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_111.glb": {
      "bytes": 88108,
      "sha256": "7dd70d6289481b2e97b37e1b8434cf965fa051e0a6ecac6b19fd26e9eeb28d0a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_112.glb": {
      "bytes": 227288,
      "sha256": "56f7141e419cfdd07e36b65e2975dc1215ba8ee81cb53420a48e7276a74ca733"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_113.glb": {
      "bytes": 211424,
      "sha256": "5eb07f357b7de68873c7b53443ba8bdd7b65de63663eba0f6d8e3f2be0f0335a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_114.glb": {
      "bytes": 168052,
      "sha256": "a491bb223ecc1e7dd3f583e069d38176c6689bc6c6d7dee8641bfb73ccf997e9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_115.glb": {
      "bytes": 163680,
      "sha256": "4a2cf1f9adc6b2d71cb6acdbb07805bc1e63b162974f6e19c0214155a09af58f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_116.glb": {
      "bytes": 114776,
      "sha256": "990deed7407bc5f3a1f48b93e4813afd43fd7641a34e4c465fc7264816fe47b4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_117.glb": {
      "bytes": 166956,
      "sha256": "226815636595224e150b054beaa3fae1c8848a04eef57c638cd703eea4093fe9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_118.glb": {
      "bytes": 179296,
      "sha256": "e90f780a40c15e95af2665057f5fc571e8ac64ed721cae0179bf203b1c33e82d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_119.glb": {
      "bytes": 138132,
      "sha256": "936907c8711f8ce2ec9acb2bae07a11e383da24177ef1fe6431c645a6bc500a5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_12.glb": {
      "bytes": 132284,
      "sha256": "85f92e7194f87e1dc60a01b9bf9b5f0f6b882aea94e714a14733348e20243519"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_120.glb": {
      "bytes": 153708,
      "sha256": "d8efc9c1e2788465ad2cd24dcfd86d2368c8e023986af57b9886b3567bf9b982"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_121.glb": {
      "bytes": 48216,
      "sha256": "bec75dc109fc57d3a543f888613b0ffccf3f3a728fde09bd221e22982e7fd0d5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_122.glb": {
      "bytes": 230064,
      "sha256": "921c1cbfb810aeecb67332f558c5e62d881b5cb7cc05cd8cd67b8a5f143c794b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_123.glb": {
      "bytes": 210632,
      "sha256": "9da147042140b3932673120de413d52b807096b6c4871752ec9d21284f8abb7b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_124.glb": {
      "bytes": 157952,
      "sha256": "d9d204034b7bbb9cc8e2247d5e365aa76087332eab6983d586a292dfc0c4a619"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_125.glb": {
      "bytes": 110772,
      "sha256": "5a5d33627ae1115226354fa55b44a41915f8e2d42787d8a78932f24bf629f431"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_126.glb": {
      "bytes": 117800,
      "sha256": "e477755c2eb9ca76a60662e29ec17d2fb81d741627fdc72574a74d346c0e231e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_127.glb": {
      "bytes": 63920,
      "sha256": "89ec176949671d800dd807e1082aea8aa20454bd573a11c3ee48b088c7718841"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_128.glb": {
      "bytes": 221756,
      "sha256": "a9d973954f268054cd5ee76fb99d71ae8b4b63e32a0b14ab6dc400bdaf980e42"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_129.glb": {
      "bytes": 116672,
      "sha256": "30d4a76c7f1f12bacfba393c58f306aa5a584e7ea2f1ddfa74a346c099a590e5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_13.glb": {
      "bytes": 152692,
      "sha256": "67354f32116f3cb6c8389ac6501ce32b7621264d57303865a2f0eb6f7cf7073b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_130.glb": {
      "bytes": 53740,
      "sha256": "531a28179d6fa05f5fb7557a0ae9395d55750cac29bb90fff15ff050be6d6b31"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_131.glb": {
      "bytes": 193484,
      "sha256": "89714f92cc7c473b1037225eaaea031e8e7a5ed4914e20cdbb9b2d152941ef7c"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_132.glb": {
      "bytes": 133344,
      "sha256": "fbf0ee373c69ba44218827ded1761c95a7e90d47fa6c30ad0a70664c5b7453fb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_133.glb": {
      "bytes": 88472,
      "sha256": "80a549cceeea6540899f69a5b72fe0aae933c1bcde324c0cfe79f8fac1a62682"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_134.glb": {
      "bytes": 92028,
      "sha256": "5561d8ed9b10909ffda31c4fb3f4af212f439dcb337be46885ed21505d6b2961"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_135.glb": {
      "bytes": 186180,
      "sha256": "c50f74a5c923e28cd4ef64ab4ea1f6238819632a1c0271870c92b8257cce113f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_136.glb": {
      "bytes": 3236,
      "sha256": "58034c1d6618e4856b22c31c67cd7f39ce10ee9e52d45c79980dd4a7f3fdfb50"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_137.glb": {
      "bytes": 183872,
      "sha256": "484b6a966003abccc38254b248fa52091ce9d4784307d19dc5eebe2525449902"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_138.glb": {
      "bytes": 132188,
      "sha256": "be9aeaa45a1c6302da956d26de7365d2b3e4f90bc0ae4ac89e046b36a0554509"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_139.glb": {
      "bytes": 188656,
      "sha256": "4ba56b6dddc665c8976c982d24526a864e0f15fce274cf657ef7fa2702205c86"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_14.glb": {
      "bytes": 207528,
      "sha256": "b7853d1c421018a69d6bdffc53c1806060b18a62db77bd63ec5388e5dc9789fd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_140.glb": {
      "bytes": 238224,
      "sha256": "55605c75d1f408db92517b31db048d291babfa188e24456b7e06f0c99c588a54"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_141.glb": {
      "bytes": 118628,
      "sha256": "a94a1c2ed494b5cde68d1b2823f9046e0f92cd06aa1c711ad3c693828b607332"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_142.glb": {
      "bytes": 223880,
      "sha256": "f6bd21ded32a6ed76e938a78723c608fdf2db5aec9680e6bc3274cc653372ae3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_143.glb": {
      "bytes": 136576,
      "sha256": "f9d23bac6b7f8bcd71214aa183451b59dddbec451aec10320c5539fd12c94dcc"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_144.glb": {
      "bytes": 127056,
      "sha256": "63baec4022592b5a0bc15c3f13230561984bf7e7451d545d2e78bfe9621f2a60"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_145.glb": {
      "bytes": 159476,
      "sha256": "db207040891ed92378ec33017f32793570990daa6f3243314324f401db781fc3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_146.glb": {
      "bytes": 113792,
      "sha256": "2c4ea3c35123b5e7814fb8bda7276579fbc08d3e42053add511799938e78ec55"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_147.glb": {
      "bytes": 199376,
      "sha256": "fd28a8d6eec38a5038e7ac977e908efec70e43aa4c40563d6bbc14b4e98c5d6c"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_148.glb": {
      "bytes": 199076,
      "sha256": "21f82e50206c806a9483b36c56734d5f39f5b880d9e13ff6d13c378861a689d3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_149.glb": {
      "bytes": 74324,
      "sha256": "8ced417fcdbd117231496de171fe7f469a959bbca53943ed3b7b2b6d9f7f61d4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_15.glb": {
      "bytes": 65944,
      "sha256": "2f669750cb8fbe03a73836955c5a0ab722839e1e5c71e8bd1b1a5ecdeb36eae4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_150.glb": {
      "bytes": 121268,
      "sha256": "ba3fab2b01e692e310db98a9258ac379860864f4e725bce9431685f724fb20fa"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_151.glb": {
      "bytes": 243200,
      "sha256": "7adff020791c4dea4f640d2fbb4c5fcf75a3214d0c30ca200b06fff56ccfdf08"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_152.glb": {
      "bytes": 65056,
      "sha256": "545f0d9814650ca75a9770114511fa577753e2e7278193d01c1a735e3acb1d0d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_153.glb": {
      "bytes": 100092,
      "sha256": "35ea2f4ede8bf6443d8b8775a8c4ed6028020b38f01ba810b8bee64a9f4f906f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_154.glb": {
      "bytes": 121116,
      "sha256": "f064b4b26ed0997fea0c460e191c55a8d088804b2c8c6adcd38e95e6800ef081"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_155.glb": {
      "bytes": 145916,
      "sha256": "e2f39f3d855329d36e33c2f069d43fc41603c27784ef58c1b95af8defea51520"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_156.glb": {
      "bytes": 84088,
      "sha256": "7fdbe0e9486b8f8a04636611f7da744fbeb2e8baa5a1f1fdad2514e007e93189"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_157.glb": {
      "bytes": 56068,
      "sha256": "c19cb67c8cc4d401c2e4bde67923e63c0dfdf1cac183a1696f747ed9e8380cad"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_158.glb": {
      "bytes": 97620,
      "sha256": "43c57fca9299f7830bc5bdfd267ff8c261063d4be753971b2056208e7aac1f22"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_159.glb": {
      "bytes": 174392,
      "sha256": "173595c10003c944d8f97050b7bc4da7279d08dd2325daf4f8806f6cdccc8aa9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_16.glb": {
      "bytes": 176220,
      "sha256": "9aed389349257312e9f5a82dcd52f3dca5ab17320575a490d4194034f701ecdd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_160.glb": {
      "bytes": 192460,
      "sha256": "4ff4d17264ab9cf151fe401e906920a0ffa3de5be06a1ccb727b78c21bc8c352"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_17.glb": {
      "bytes": 183036,
      "sha256": "efa8e6ff98f74254db84d6e7a516ef6b5e855b34e1e972ea0f7b458c5737ee81"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_18.glb": {
      "bytes": 90732,
      "sha256": "51c5377356c8e30090d1cac9b9f775b5b53eb3461fd620c95b9a8848a2b11152"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_19.glb": {
      "bytes": 40096,
      "sha256": "a634370dd4e87f237404948e2b53af2bf4de0cc984e28287707d4c5c62951013"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_2.glb": {
      "bytes": 197324,
      "sha256": "a689d2be178d4bd3246506865c71cbd73b77ca85121f73bd4e14b02af7470489"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_20.glb": {
      "bytes": 126632,
      "sha256": "fdc81e26f80aac0d76c8b69a96cea5bfdae8353b12baee909331fb8023c5dee6"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_21.glb": {
      "bytes": 185104,
      "sha256": "0959e1200d5cbe1e4a503fd4cf012d45620a70990cd3cacb0edb531cfb138dbc"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_22.glb": {
      "bytes": 140596,
      "sha256": "2581b8bcb96adc284a0913a627d28f3ee76ca27e0f4d7c88fabced6b15b046be"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_23.glb": {
      "bytes": 41528,
      "sha256": "da5a2a989939da033f18a355108cb250dc9374744a64aaa84ae2a0e0d628d6a1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_24.glb": {
      "bytes": 184352,
      "sha256": "756df8c6de860c41fd33e3df39f2b4b21ce6678ce1a625586d6ab84110f97cbc"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_25.glb": {
      "bytes": 144012,
      "sha256": "e3e3e1cb55a770929c91ce3218028a13b1f448cc694da134ebfa598a53c1d17f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_26.glb": {
      "bytes": 49280,
      "sha256": "a5f3a141285380958872d567aecbb63045d03c5f3b2593d4675622eaa64cb96b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_27.glb": {
      "bytes": 152008,
      "sha256": "4c34b50d35414fd9504c26833bf2fa038bc2c3ef2ea7afecaa83a2b0d23f5910"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_28.glb": {
      "bytes": 202564,
      "sha256": "fa97c23925627a663cd132b0bc00489cde80394dcf9996dd8cd47cda5eee5503"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_29.glb": {
      "bytes": 61368,
      "sha256": "6d34fd16af29860f0542695ffb2a52823d610aa58c47f65c2bdc8413b3cf9194"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_3.glb": {
      "bytes": 169212,
      "sha256": "adaaa0b8c6314d598f2284fc609ec31bfd0da45372fbf15f21a76d97a511cd08"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_30.glb": {
      "bytes": 14072,
      "sha256": "3852e561406caad10f27d939e983e83fac319fb6f3f890e32748085ac32f6a3b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_31.glb": {
      "bytes": 184212,
      "sha256": "5c41d1164d3b8dc1cac4dfda9226561c8cc321cebcfdaa4fe39e06f43225538f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_32.glb": {
      "bytes": 18836,
      "sha256": "92af5fcca239eefd9c8fc52324789d4b2dfc899da9c003377a40a7b11657f547"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_33.glb": {
      "bytes": 96960,
      "sha256": "407433f381c2f16ee2e58183c41903946773471459afd9459cfe933ca802518f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_34.glb": {
      "bytes": 177992,
      "sha256": "04e912718c8b6c8a07d855e458cad566cca2ddd570c1eca42d78c7a47d38d969"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_35.glb": {
      "bytes": 158396,
      "sha256": "5cf39ca2cb97a7dab729f6fe4f8ff3683d513b8f34f498cc362a712bf0df06d1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_36.glb": {
      "bytes": 132020,
      "sha256": "91992c1b78bfa1918bbe99ee783a512ee828c6dcc235cef26cb8c4c4202c6a3f"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_37.glb": {
      "bytes": 160508,
      "sha256": "8e6b86b5310193b4b951e9f749d67e1e61f7b2969c58bf6b25a071cb36ed4ee9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_38.glb": {
      "bytes": 184600,
      "sha256": "bf8110c0ab71acf17a116c2d6177e744e6a0831914aef3f8e017dfeb98f20fad"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_39.glb": {
      "bytes": 237444,
      "sha256": "a6eb24c9c3ac15d9d5e86f9118692e871c5cbd79768bc49054a60eb024543a52"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_4.glb": {
      "bytes": 138372,
      "sha256": "91833b1619fd0d9c0c22cada2badd32e2367ede1dd9bfa7b763edbb410e4c25d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_40.glb": {
      "bytes": 202344,
      "sha256": "4e2bb32e32b0a222bed32269816ad9b0ecb368321f6b97f168e012b1b7345eb2"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_41.glb": {
      "bytes": 170404,
      "sha256": "f3572c720f150edee09619aac35809243570b98ba3e29754fdcbb43e872eb8a3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_42.glb": {
      "bytes": 174116,
      "sha256": "84173601277b7836adc409fdbe9f27b0d0f13ffb0c6aea13736823cc275268cd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_43.glb": {
      "bytes": 132556,
      "sha256": "5d0cf0419ad9b768855dc3e807ce8aab0a6bb75afd456b3eafbe63073591d730"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_44.glb": {
      "bytes": 118944,
      "sha256": "796b70d38b1cc23d2028d568e7eaf501bb382a5c5c25190197688a9954ba8e82"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_45.glb": {
      "bytes": 132064,
      "sha256": "939c9ee76e019b998e1af18910a5c64f2adfd243e1ab6dd6be94ad63bbe0c730"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_46.glb": {
      "bytes": 104496,
      "sha256": "21506941d0ef7884b358b03ad69ebaf5234a9c306cd87191f109d1589d57de7a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_47.glb": {
      "bytes": 165212,
      "sha256": "6794d5dccae89557acb8d502785a783fd45ed2dd80bf9fd58e38b31fbb460226"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_48.glb": {
      "bytes": 133048,
      "sha256": "49db0c9b112e374238d68df18af55843623b790fae912c1619cb48f84966369b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_49.glb": {
      "bytes": 147396,
      "sha256": "64dbacc76940c52c2296b9a7d6c06be23bb6762dc51f42ed446071b824a51c9a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_5.glb": {
      "bytes": 187844,
      "sha256": "edbee3de09ba18ba3b3f22094260a6c2fe23212240cd3cfea06494c007abe0a8"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_50.glb": {
      "bytes": 158784,
      "sha256": "115d506a876d8a9d61cd233d30b8319f9b0c954ef457b0ddfe946aa6fd80d9a1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_51.glb": {
      "bytes": 164500,
      "sha256": "1aee63c9834293bb07fbd3cb1df6654ab24b3368b35ced2b583ef7f0ee713a5b"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_52.glb": {
      "bytes": 167736,
      "sha256": "134e83e5e37990336430a62ec4d2db4bd45c1e7766b67ac6e2a0e7e4f9cded41"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_53.glb": {
      "bytes": 144592,
      "sha256": "2ae7d039df4ec0f6beb5766e407545e47895260689924073492a38f40f8ffea3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_54.glb": {
      "bytes": 135116,
      "sha256": "53e88782fce87ffa4bff5f0d8997803aa74fe1a18f5e883b8c320bd2e8acd6cd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_55.glb": {
      "bytes": 166852,
      "sha256": "e907b0dd5086d2bfdad2375a682a356189c2a38ac54ffd0dbd679dae4e050045"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_56.glb": {
      "bytes": 177224,
      "sha256": "3d91ee2c9c1fb69201761b4fd87fa6b143fb8009e9293cbda30a4532472be1e6"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_57.glb": {
      "bytes": 125784,
      "sha256": "27cc74fe1f1833e5b9c4d1c10e6ffa564db92868de4b15fc01c08c44e990e0e3"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_58.glb": {
      "bytes": 124336,
      "sha256": "4d8cddae33bc3115aa3ec4666a5c69c2dff48d9884235d6fac14311122f06f57"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_59.glb": {
      "bytes": 46532,
      "sha256": "b59716368b53e511634b9fd038a613d73fe9b6effb5c2d906444cde66fc21c21"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_6.glb": {
      "bytes": 181416,
      "sha256": "9d16bb96d7d4d32a2d4cf76a65e33aed05ccbb85b6f2c1aa4d6aa55ef581d983"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_60.glb": {
      "bytes": 155160,
      "sha256": "8420e91c1e03b9d723f0ed303b472983248bf895b11b77c4b62264dd03665ac7"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_61.glb": {
      "bytes": 205920,
      "sha256": "e9b106958971ae70c65f053226ceaee1282adea3dca724f2857f21c2237313d5"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_62.glb": {
      "bytes": 235092,
      "sha256": "a75cc9b02ea7d1855b7626bb8ccb4329e0d700275dc6c977c7cf0bb91bb61544"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_63.glb": {
      "bytes": 84484,
      "sha256": "56783fb79892ee58ddd6a3309174dd3a16a39e178055bb91cfe9994e6baaf02d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_64.glb": {
      "bytes": 44592,
      "sha256": "75ca33172820c561a13f669456e1dc378cab6de87e13216f97db36bb53efbcf6"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_65.glb": {
      "bytes": 236216,
      "sha256": "20be357b1b668224b45dfc9e85c4f4ec980a8f1abcda8468709b0b9bc8c4ae58"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_66.glb": {
      "bytes": 242804,
      "sha256": "280c744459c69db36e63aacd1b8af231233d0e106e8e030c7641c5f3d54a4d9e"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_67.glb": {
      "bytes": 89092,
      "sha256": "6cfdf495428cc0073723ddc58cd9a187b812efe24196a877f08d5c3d309929eb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_68.glb": {
      "bytes": 123972,
      "sha256": "5748290ca1082e34794df6ddb912f36493a6de85dc0cdebc3ae5d6156e887201"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_69.glb": {
      "bytes": 174852,
      "sha256": "9ffb7c4a5c04b6d4175068ba86f345d510122fae7104082144fae861ab07c2de"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_7.glb": {
      "bytes": 82248,
      "sha256": "7aa1bde9a394598281bc3428b1d1bafef073a83c2bf136dc929793599c01344c"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_70.glb": {
      "bytes": 112656,
      "sha256": "a716b5cb90116a2a3dedcba95ef649cf78f3ab7599f3fd24ccbf1e496dfd3736"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_71.glb": {
      "bytes": 156668,
      "sha256": "f1366e85e0de08129d7a9e4db90123f75c81bdef41ae0f50f851ddbe901889db"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_72.glb": {
      "bytes": 85812,
      "sha256": "a072c6540b2e9971790fd03d1a65742b91388f472507d2372db40dcd7eadc58d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_73.glb": {
      "bytes": 150656,
      "sha256": "6c84b6d4b1bdf628b9006766765cd57cb917b82e6c3be130d68a48021ff33bcd"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_74.glb": {
      "bytes": 124628,
      "sha256": "c5ca797d7c2cf8aaeff40b02ce090eeb998a95b462625c8c1b490799bd29a0c4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_75.glb": {
      "bytes": 230440,
      "sha256": "4f1330ca796fc610e8e019b285a26ecff791ad4fc10a11aa158be51c5c648c62"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_76.glb": {
      "bytes": 181424,
      "sha256": "bb1e1fb65a1cb00cc903e60a347ca9e85ddd66685c4289195db2a7f9d79f93f4"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_77.glb": {
      "bytes": 124760,
      "sha256": "5b9fcf4b537631d4993e813fb89f8100d660cf1dd63554cc296699ed4aa78f55"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_78.glb": {
      "bytes": 145676,
      "sha256": "765a2dbd134cd49eb337ba5badd12d91addec905e72bd94921e2c621828ff453"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_79.glb": {
      "bytes": 153796,
      "sha256": "018008fa4aaea27cd878d5d630b64e9c371a2f7c0ae2385d036dded34737d598"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_8.glb": {
      "bytes": 28356,
      "sha256": "5606585e571d51374eb38413ced5a7615dc1742ae08f7e66fd2b29475fea1372"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_80.glb": {
      "bytes": 177952,
      "sha256": "c80263b7278d22dad99a2010fe9c090596de36b906e5f7998d98fa3aa57b60eb"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_81.glb": {
      "bytes": 107556,
      "sha256": "e5c44e1ad4f19a157045993f1df325779326f434aaa148c6f3a1051232f69f81"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_82.glb": {
      "bytes": 166772,
      "sha256": "1679b38967d4f8383cd4ccb630eaf6d8a530ee1747f27b78ae54893aaa9aace9"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_83.glb": {
      "bytes": 105904,
      "sha256": "f54e4ce442ff08b016bd8764d016dcae836b85ac24badf787d8e877f4c6ec50c"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_84.glb": {
      "bytes": 158212,
      "sha256": "a88967035c44c9b263a0f297519563d29ad7f3c11e7c992ca18b3be22014ce09"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_85.glb": {
      "bytes": 162556,
      "sha256": "b51ada09fdbef20f7f45fee5bf3d7260b7d496fc0006263ecbbdd30f5d32f718"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_86.glb": {
      "bytes": 111588,
      "sha256": "df404e42499f18156f903667da27d54fcedef5e0df4714ad57224286e5a94346"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_87.glb": {
      "bytes": 180100,
      "sha256": "01c908ed34021c73d1c698aea7739f82f925bb3a1e2116c7dd9fd3168e2d486a"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_88.glb": {
      "bytes": 180444,
      "sha256": "6780a100a81b6829a07b7906e32bce6585baf08ae4577528d57efbf257ada039"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_89.glb": {
      "bytes": 153240,
      "sha256": "7565c2648b2c1f6eeb451797fe57e728bf634fe2f54703a48c5fd062beb6fb14"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_9.glb": {
      "bytes": 141900,
      "sha256": "059fcf4684b74de56b8e20bde605d03ee88ea30d26e2c1bf345f06f82a9b1baa"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_90.glb": {
      "bytes": 205528,
      "sha256": "34921fe1e053f158b874b77355d1f4ff6ed55b05ff9e7971604f82c44e259835"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_91.glb": {
      "bytes": 26384,
      "sha256": "ea15d5a96c01dc4924a190975cc6f186d85b31e98070d79a2efcd58ff1aada73"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_92.glb": {
      "bytes": 166140,
      "sha256": "5c2149544016deb3a6c33c949828be6f434f335c0668901fe4dc3b0cb5b8bd3d"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_93.glb": {
      "bytes": 128984,
      "sha256": "91ba91b3550a1ceba578ea50b1f6d73eac5c031e2e1806d8f9b51f5f74d0c110"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_94.glb": {
      "bytes": 238308,
      "sha256": "daa29ed0d26ab4b31f59db3f3867a80587641ae4b7a433082765edb4afc81c13"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_95.glb": {
      "bytes": 173132,
      "sha256": "a1f89277d580856ce073c655515839c3697890d54eaa862d35189ca234b7a036"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_96.glb": {
      "bytes": 133744,
      "sha256": "98d2a8ac770545ff72ac73069b80da9c855b5f8ed4b7ae729b80c4d178adfaa6"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_97.glb": {
      "bytes": 173340,
      "sha256": "a2d976fa9b92fef6fe985df352db7647e4f4e91cca383eb90564af850376cc87"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_98.glb": {
      "bytes": 118528,
      "sha256": "3fa935366a51da4676adf27ee2f57632edc2fe9ec4789b3edb5ac34d3b5c1eae"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/Block_00000_Level23_99.glb": {
      "bytes": 67228,
      "sha256": "1db973a42952a730ee25302d7fc7a99c92cd05a959442032d4a0a16b0ef822b1"
    },
    "office-poisson-las-ktx2/3dtiles/Block_00000/tileset.json": {
      "bytes": 364480,
      "sha256": "cffed63fc85342ac09d08929a477ae9f6fe60948592d08ca252e6f039bf186fb"
    },
    "office-poisson-las-ktx2/3dtiles/coordinate_contract.json": {
      "bytes": 789,
      "sha256": "50166dbd57faad7c5a0665e14c4d84b4920ccd60011581366adeb680a0df9007"
    },
    "office-poisson-las-ktx2/3dtiles/tileset.json": {
      "bytes": 1284,
      "sha256": "3c20ac56606a47b79d8f6563e5faa4f3675a7a9fe31303c0d3942b97043e1183"
    }
  }
} as const
